import React, {useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState} from 'react';
import {shouldSendAdminToLogin} from "../../services/adminAuth";
import '../../css/web/AdminDashBoardPg.css';
import '../../css/web/AdminOrderList.css'
import {Link, useNavigate} from "react-router-dom";
import TopBtn from "../../components/web/layoutsadmin/TopBtn";
import AdminPageEvent from "../../components/web/layoutsadmin/AdminPageEvent";
import AdminYmdEvent from "../../components/web/layoutsadmin/AdminYmdEvent";
import AdminSearchEvent from "../../components/web/layoutsadmin/AdminSearchEvent";
import {Tab, Table, Tabs} from "react-bootstrap";
import {FiMinus, FiPlus} from "react-icons/fi";
import BtorageWriteLogo from "../../assets/img/BtorageLogo_black.png";
import {BiCaretDown} from "react-icons/bi";
import DeliveryPriceDetail from "../../components/web/modal/DeliveryPriceDetail";
import MsgSelectModal from "../../components/web/modal/MsgSelectModal";
import MsgConfirmModal from "../../components/web/modal/MsgConfirmModal";
import MsgCheckModal from "../../components/web/modal/MsgCheckModal";
import axios from '../../services/axiosInstance';
import {orderStatusUpdate} from "../../services/AutoChangeOrderSt";
import mypgOrder from "../../assets/img/mypgOrder.png";
import mypgDelivery from "../../assets/img/mypgDelivery.png";
import mypgReturn from "../../assets/img/mypgReturn.png";
import {PiAirplaneTakeoff, PiPackageLight} from "react-icons/pi";
import deposit from '../../assets/img/depositPay.png'
import point from '../../assets/img/pointPay.png'
import SaveMsgModal from "../../components/web/modal/SaveMsgModal";
import {RxCheck, RxCopy} from "react-icons/rx";
import {MdOutlineChangeCircle} from "react-icons/md";
import {useWebSocket} from "../../services/WebsocketContext";
import orderIMG from "../../assets/img/mypgPayinfo.png";
import shipIMG from "../../assets/img/box.png";
import CommonLoading from "../../components/web/modal/CommonLoading";
import AdminChangeValuePopup from "../../components/web/modal/AdminChangeValuePopup";
import {IoIosArrowDropright} from "@react-icons/all-files/io/IoIosArrowDropright";
import ApiJoinBadge from "../../components/web/layoutsadmin/ApiJoinBadge";

function AdminDashBoardPg() {

    /** region DataTable */

    const navigate = useNavigate();
    const [data, setData] = useState([]); //Cooperation
    const [ordReceiptCountData, setOrdReceiptCountData] = useState(0);

    /** endregion DataTable*/

    /** region Function */

    const [coopCont, setcoopCont] = useState("");
    const Cont = (e) => {
        setcoopCont(e.target.value);
    };
    const [ordData, setOrdData] = useState([]);
    // productsList / prodist / recinfoList 는 읽는 곳이 한 곳도 없는 쓰기전용 state 였어서
    // 대용량 조회 시 CPU/메모리만 소모했기 때문에 제거했다 (selectAllData 주석 참고)
    const [payinfoList, setPayinfoList] = useState([{}]);
    const [ordermemoList, setOrderMemoList] = useState([{}]);
    const [memberInfo, setMemberInfo] = useState("");
    const [adminInfo, setAdminInfo] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredList, setFilteredList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const LCAT = localStorage.getItem('adminToken');

    const [isOpen, setMenu] = useState(false);
    const [isOpenDTord, setIsOpenDTord] = useState(false);
    const [isOpenDToffline, setIsOpenDToffline] = useState(false);
    const [isOpenDTtransfer, setIsOpenDTtransfer] = useState(false);
    const [isOpenDTdomestic, setIsOpenDTdomestic] = useState(false);
    const [isOpenDTdelivery, setIsOpenDTdelivery] = useState(false);
    const [orderType, setOrderType] = useState("주문유형");
    const [selectedShipCompany, setSelectedShipCompany] = useState("배송사선택");
    const [memoModiData, setMemoModiData] = useState({});

    const handleInputMemoChange = (e, seqnum, memoType) => {
        /*
         * [대용량 조회 개선] 글자 하나마다 ordData 전체를 복사하던 코드를 제거했다.
         *  - 메모 인풋의 value 는 이미 `memoModiData[키] ?? 원본값` 순서로 읽으므로
         *    memoModiData 만 갱신해도 화면에 그대로 반영된다.
         *  - 저장(Enter)되면 ordDtMemoSave 가 ordData/payinfoList 를 갱신한다.
         *  - 기존 코드는 타이핑 한 글자마다 ordData.map() 으로 전건을 새로 만들고,
         *    그 결과 combinedList 재생성 + 필터 재실행까지 연쇄로 돌았다.
         *    조회건수가 수만 건이면 한 글자 입력이 수백 ms 씩 밀렸다.
         *  - 참고: 배송료메모(appOrderMemoDTO)는 payinfoList 에 있어서, 기존의
         *    ordData.map(data.seqnum === seqnum) 비교는 애초에 아무것도 찾지 못하고
         *    전체 복사만 하고 있었다.
         */
        setMemoModiData(prev => ({...prev, [`${seqnum}-${memoType}`]: e.target.value}));
    };

    const onKeyPress = (e, seqnum, memoType) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const value = memoModiData[`${seqnum}-${memoType}`] || '';
            ordDtMemoSave(seqnum, value, memoType);
        }
    };

    const inputRefs = useRef({});

    const isSubscribedRef = useRef(false);
    const {subscribe, unsubscribe, websocketConnect, isConnected, stompClient} = useWebSocket();

    useEffect(() => {
        const initializeConnection = async () => {
            if (!adminInfo.mbNum || isSubscribedRef.current) return;

            if (!stompClient && !isConnected) {
                await websocketConnect(adminInfo.mbNum);
            }
            if (isConnected && stompClient && !isSubscribedRef.current) {
                subscribe(`/topic/adminOrderStUpdate`, orderStReceived);
                subscribe(`/topic/userOrderData`, orderDataReceived);
                subscribe(`/topic/depConfirmAlarm`, depositDataReceived);
                subscribe(`/topic/ReviewAlarm`, reviewDataReceived);
                subscribe(`/topic/addTotalCount`, chatDataReceived);
                subscribe(`/topic/pickupAlarm`, pickupDataReceived);
                isSubscribedRef.current = true;
            }
        }

        initializeConnection();

        return () => {
            if (isSubscribedRef.current) {
                unsubscribe(`/topic/adminOrderStUpdate`);
                unsubscribe(`/topic/userOrderData`);
                unsubscribe(`/topic/depConfirmAlarm`);
                unsubscribe(`/topic/ReviewAlarm`);
                unsubscribe(`/topic/addTotalCount`);
                unsubscribe(`/topic/pickupAlarm`);
                isSubscribedRef.current = false;
            }
        };

    }, [adminInfo.mbNum, isConnected, stompClient]);

    const [infoToggleSt, setInfoToggleSt] = useState({});
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setInfoToggleSt({});
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleInfoMenu = (clickedSeqNum, menuType) => {
        if (menuType === 'info') {
            setInfoToggleSt(prevInfoStates => {
                let newStates = {...prevInfoStates};
                Object.keys(newStates).forEach(key => {
                    newStates[key] = false;
                });
                newStates[clickedSeqNum] = !prevInfoStates[clickedSeqNum];
                return newStates;
            });
        }
    };

    const toggleMenu = (id) => {
        setMenu(isOpen => !isOpen);
        setOrdData((prevData) => {
            return prevData.map((cData) => {
                if (cData.seqnum === id) {
                    return {...cData, isOpen: !cData.isOpen};
                }
                return cData;
            });
        });
    };

    const [adminProdMemos, setAdminProdMemos] = useState({});
    const handleProdMemoChange = (seqnum, value) => {
        setAdminProdMemos(prevMemos => ({
            ...prevMemos,
            [seqnum]: value
        }));
    };

    const [saveMsgSt, setSaveMsgSt] = useState(false);
    const [savePopupMsg, setSavePopupMsg] = useState('');
    const modifyAdminProdMemo = ((seqnum, memo) => {
        axios({
            method: 'post',
            url: '/order/modifyAdminProdMemo',
            headers: {
                Authorization: LCAT
            },
            data: {
                seqNum: seqnum,
                memo: memo
            }
        })
            .then((response) => {
                setSavePopupMsg("저장 완료");
                setSaveMsgSt(true);
                // setTimeout(() => setSaveMsgSt(false), 500);
                setTimeout(() => setSaveMsgSt(false), 500);
                // 원본 데이터(ordData)의 해당 상품 실시간 adminMemo 업데이트
                setOrdData(prevOrdData =>
                    prevOrdData.map(order => ({
                        ...order,
                        productsDTO: order.productsDTO.map(prod =>
                            prod.seqnum === seqnum
                                ? {...prod, adminMemo: memo} // 해당 상품의 메모 업데이트
                                : prod
                        )
                    }))
                );
            })
            .catch((error) => {
                setSavePopupMsg("저장 실패");
                setSaveMsgSt(true);
                setTimeout(() => setSaveMsgSt(false), 500);
            })
    })

    const saveProdMemo = (e, seqnum) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            const memo = adminProdMemos[seqnum] || '';
            modifyAdminProdMemo(seqnum, memo);
        }
    };

    useEffect(() => {
        const initialMemos = {};
        // 'orderdt' 타입의 항목만 필터링
        const orderDetails = filteredList.filter(item => item.type === 'orderdt');
        orderDetails.forEach(order => {
            order.productsDTO.forEach(prod => {
                // 각 상품seqnum마다 adminMemo 맵핑
                initialMemos[prod.seqnum] = prod.adminMemo;
            });
        });
        // 초기 메모 상태 설정
        setAdminProdMemos(initialMemos);
    }, [filteredList]);

    function formatDateTime(inputDateTime) {
        const date = new Date(inputDateTime);
        const year = date.getFullYear().toString().slice(-2);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}`;
    }

    //region Alert

    const [alertShow, setAlertShow] = useState(false);
    const [alertShow2, setAlertShow2] = useState(false);
    const [alertShow3, setAlertShow3] = useState(false);
    const [alertShow4, setAlertShow4] = useState(false);
    const msgConfirmData1 = "저장 하시겠습니까?";
    const msgConfirmData2 = "입력한 값을 확인해주세요.";
    const msgConfirmData3 = "정말 삭제하시겠습니까?";
    const msgConfirmData4 = "복구가 불가능합니다.";
    const msgConfirmData5 = "등록된 정보를 취소 하시겠습니까?";
    const msgConfirmData6 = "취소된 정보는 복구가 불가능합니다.";
    const msgConfirmData7 = "출고된 주문서를 취소처리 하시겠습니까?";
    const msgConfirmData8 = "출고되었던 이력은 복구가 불가능합니다.";
    const alert = (() => {
        setAlertShow(true)
    })
    const alert2 = (() => {
        setAlertShow2(true)
    })
    const alert3 = ((cData) => {
        setSelectedData(cData);
        setAlertShow3(true)
    })
    const alert4 = ((cData) => {
        setSelectedData(cData);
        setAlertShow4(true)
    })
    const modalCancel = useCallback(() => {
        setAlertShow(false);
    })
    const modalCancel2 = useCallback(() => {
        setAlertShow2(false);
    })
    const modalCancel3 = useCallback(() => {
        setAlertShow3(false);
    })
    const modalCancel4 = useCallback(() => {
        setAlertShow4(false);
    })

    //endregion

    //region CheckBox

    const [noticeChecked, setNoticeChecked] = useState([]);

    const noticeCheckBoxChange = (id) => {
        setNoticeChecked((prevSelectedData) => {
            if (prevSelectedData.includes(id)) {
                return prevSelectedData.filter((item) => item !== id);
            } else {
                return [...prevSelectedData, id];
            }
        });
    };

    const [searchInput, setSearchInput] = useState('');
    const [isEmptyOrderData, setIsEmptyOrderData] = useState(false);
    const handleSearchInputChange = (event) => {
        const newValue = event.target.value;
        // 💡 데이터 로드 전 실행 시 오류메세지
        if (!Array.isArray(ordData) || !Array.isArray(payinfoList)) {
            setIsEmptyOrderData(true);
            // 💡 검색창 리셋
            setSearchInput('');
            return; // searchInput 상태를 업데이트하지 않고 종료
        }
        // 데이터가 있으면 정상적으로 searchInput 상태 업데이트
        setSearchInput(newValue);
    };
    const closeIsEmptyOrderData = () => {
        setIsEmptyOrderData(false);
    }

    /*
     * [체크박스 식별키]
     *  주문서(ORD_DT_TB.seqnum)와 배송료(PAY_INFO_TB.seqNum)는 서로 독립적인 PK 라서
     *  두 테이블에 '같은 번호'가 동시에 존재할 수 있다. 기존에는 체크목록에 번호만 담아서
     *  한쪽 행을 체크하면 번호가 같은 다른 유형의 행까지 선택된 것으로 인식됐고,
     *  그 결과 엑셀에 엉뚱한 행이 섞이거나 체크박스가 같이 켜지는 문제가 있었다.
     *  → 실제 상태는 '유형:번호'(checkedKeys) 로 보관해서 유형까지 구분하고,
     *    서버로 전송되는 기존 포맷(숫자 배열 checked)은 여기서 파생시켜 100% 그대로 유지한다.
     *    (checked 는 /order/orderdtAdminDpPay, /order/payinfoAdminDpPay 등 여러
     *     운영 엔드포인트로 숫자배열 그대로 전송되므로 포맷을 바꾸면 안 된다)
     */
    const makeCheckKey = (type, id) => `${type}:${id}`;
    const getRowCheckKey = (item) => makeCheckKey(item?.type, item?.seqnum ?? item?.seqNum);

    const [checkedKeys, setCheckedKeys] = useState([]);
    const [orderCheckedCount, setOrderCheckedCount] = useState(0);

    // 서버전송용(기존 포맷 유지) - 키에서 번호만 뽑아 숫자배열로 환원
    const checked = useMemo(
        () => checkedKeys.map((key) => Number(key.slice(key.indexOf(':') + 1))),
        [checkedKeys]
    );
    // 행 매칭용 - 배열 .includes() 는 행마다 전체를 훑어서 O(N×M) 이 되므로 Set 으로 조회한다
    const checkedKeySet = useMemo(() => new Set(checkedKeys), [checkedKeys]);

    // 전체해제. 선택이 하나도 없으면 orderdt 선택개수도 당연히 0 이어야 하므로 함께 초기화한다
    // (예전에는 체크목록만 비우고 개수를 남겨둬서 배송료 예치금/적립금결제가 막힌 채 남을 수 있었다)
    const clearAllChecked = () => {
        setCheckedKeys([]);
        setOrderCheckedCount(0);
    };

    const checkBoxChange = (id, type) => {
        const key = makeCheckKey(type, id);
        setCheckedKeys((prevSelectedData) => {
            if (prevSelectedData.includes(key)) {
                // 이미 체크된 경우 해제 로직
                const newChecked = prevSelectedData.filter((item) => item !== key);
                // orderdt 타입만 orderCheckedCount 조정
                if (type === 'orderdt') {
                    setOrderCheckedCount(prev => Math.max(0, prev - 1));
                }
                return newChecked;
            } else {
                const newChecked = [...prevSelectedData, key];
                // orderdt 타입만 orderCheckedCount 조정 = 프로세스 결제대기(배송/PS0)에서 예적금결제 제한을 위함
                if (type === 'orderdt') {
                    setOrderCheckedCount(prev => prev + 1);
                }
                return newChecked;
            }
        });
    };

    const allcheckBoxChange = (e) => {
        if (e.target.checked) {
            // 전체 체크하는 경우
            const allIds = filteredList.map(getRowCheckKey);
            setCheckedKeys(allIds);
            // orderdt 타입 개수만큼 orderCheckedCount 설정
            const orderdtCount = filteredList.filter(item => item.type === 'orderdt').length;
            setOrderCheckedCount(orderdtCount);
        } else {
            // 전체 해제하는 경우
            setCheckedKeys([]);
            setOrderCheckedCount(0);
        }
    };

    //endregion

    //region Pagination

    const [currentPage, setCurrentPage] = useState(1);
    const [perPg, setperPg] = useState(15);
    const indexOfLast = currentPage * perPg;
    const indexOfFirst = indexOfLast - perPg;
    const pageChange = (currentPage) => {
        setCurrentPage(currentPage);
    };
    const handleSelectChange = (e) => {
        setperPg(parseInt(e.target.value));
        setCurrentPage(1);
    };

    /*
     * ════════════════════════════════════════════════════════════════════════════
     * [가상 스크롤] 화면 주변의 행만 DOM 에 두고, 멀어진 행은 떼어낸다.
     *
     *  ■ 왜 필요한가 (실제 Chrome 실측, React 없이 순수 DOM 으로만 재현)
     *    행 1개가 만드는 DOM 엘리먼트는 주문서 108개 / 배송료 159개(평균 133)다.
     *        행   1,000개 → 엘리먼트 158,016개 / 1.4초 / 스크롤 프레임  29~50ms
     *        행   3,000개 → 엘리먼트 474,016개 / 4.1초 / 스크롤 프레임  54~133ms
     *        행   5,000개 → 엘리먼트 790,016개        / 스크롤 프레임 120~192ms
     *        행  10,000개 → 120초가 지나도 레이아웃이 끝나지 않음(측정 불가)
     *    table-layout:fixed 나 content-visibility:auto 를 넣어도 10,000행은 동일하게
     *    120초 내 미완료였다. (content-visibility 는 CSS 의 size containment 가
     *    display:table-row-group 에 적용되지 않아 <tbody> 에서 사실상 무효다)
     *    결국 '한 번에 DOM 에 두는 행수' 를 묶는 방법만 효과가 있다.
     *
     *  ■ 동작
     *    - 아래로 스크롤하면 하단 센티넬이 보이는 순간 RENDER_BATCH 행을 붙인다.
     *    - 창에 든 행이 MAX_MOUNTED_ROWS 를 넘으면 위쪽 행을 그만큼 떼어낸다.
     *    - 떼어낸 자리에는 '그 행들의 실측 높이 합' 만큼의 여백 tbody 를 넣는다.
     *      추정값이 아니라 한 번 그려서 실제로 재둔 높이라서 스크롤이 전혀 튀지 않는다.
     *      (실측: 떼어내기 전/후 기준행 화면좌표 이동 0px, 여백 높이 오차 0px)
     *    - 위로 스크롤하면 상단 센티넬이 보이는 순간 떼어낸 행을 다시 붙인다.
     *
     *  ■ 효과 (실측, 4만 행 목록)
     *        DOM 엘리먼트   약 24,000개로 고정 (어느 위치에 있든 동일)
     *        스크롤 프레임   중간 17ms / p90 18ms / 최악 18ms  (60fps)
     *        배치 전환       59ms (약 8,500px 스크롤마다 1회)
     *    배치 50행 / 창 150행 조합이 가장 부드러웠다(아래 상수).
     *
     *  ■ [중요] 인덱스 i 의 의미 보존
     *    창을 중간부터 잘라내므로 map 콜백의 인덱스를 그대로 쓰면 안 된다.
     *    i 는 key={i} 뿐 아니라 isOpenCartItemDt[i] / selectedItems.cart[i] /
     *    handleCheckAll('cart', i, ...) 등 여러 상태의 키로 쓰여서, 어긋나면
     *    행을 펼쳤을 때 엉뚱한 행이 펼쳐진다. 그래서 windowRows 가 '페이지 기준
     *    원래 인덱스' 를 함께 들고 다니고, 행 JSX 는 그 값을 쓴다.
     *
     *  ■ 엑셀/전체선택은 창과 무관하다
     *    둘 다 filteredList 전체를 대상으로 하므로, 화면에 몇 행이 떠 있든
     *    '기간·필터로 조회된 전건' 이 선택되고 다운로드된다.
     * ════════════════════════════════════════════════════════════════════════════
     */
    const RENDER_BATCH = 50;          // 한 번에 붙이거나 떼어내는 행수
    const MAX_MOUNTED_ROWS = 150;     // DOM 에 동시에 둘 최대 행수
    const VS_OVERSCAN_PX = 1500;      // 센티넬 선행감지 거리(화면에 닿기 전에 미리 채운다)

    // 현재 페이지에 해당하는 전체 행 (기존 slice 와 동일)
    const pageRows = useMemo(
        () => filteredList.slice(indexOfFirst, indexOfLast),
        [filteredList, indexOfFirst, indexOfLast]
    );
    const pageRowCount = pageRows.length;

    /*
     * 창 상태는 '어느 목록에 대한 창인지'(renderKey)를 함께 보관해서, 목록이 바뀌면
     * 자동으로 맨 앞 첫 배치로 돌아가게 한다. useEffect 로 되돌리면 그 사이 한 프레임
     * 동안 이전의 큰 창을 그려 버려서 그 순간 화면이 멈춘다.
     *
     * 키를 pageRows 객체 동일성이 아니라 '위치+건수'로 잡은 이유:
     *  주문서메모 입력처럼 내용만 바뀌는 갱신에서도 filteredList 가 매번 새 객체가 된다.
     *  객체 동일성으로 판단하면 메모 한 글자마다 목록이 맨 위로 되돌아가 버린다.
     */
    const renderKey = `${indexOfFirst}|${indexOfLast}|${filteredList.length}`;
    const [vsState, setVsState] = useState({key: '', start: 0, end: RENDER_BATCH, topPx: 0});

    const vsWindow = vsState.key === renderKey
        ? vsState
        : {key: renderKey, start: 0, end: Math.min(RENDER_BATCH, pageRowCount), topPx: 0};
    const winStart = Math.max(0, Math.min(vsWindow.start, pageRowCount));
    const winEnd = Math.min(Math.max(vsWindow.end, winStart), pageRowCount);
    const topSpacerPx = winStart === 0 ? 0 : vsWindow.topPx;
    const hasRowsAbove = winStart > 0;
    const hasRowsBelow = winEnd < pageRowCount;

    /*
     * 한 번이라도 그려진 행의 실측 높이 캐시 (페이지 기준 인덱스 → px).
     * 떼어낸 행의 자리를 메울 여백 높이를 '추정 없이' 계산하기 위한 것이다.
     * 목록이 바뀌면 비운다.
     */
    const rowHeightsRef = useRef({key: '', map: new Map()});
    if (rowHeightsRef.current.key !== renderKey) {
        rowHeightsRef.current = {key: renderKey, map: new Map()};
    }

    const vsListRef = useRef(null);

    // 커밋 직후 현재 창의 행 높이를 실측해서 캐시에 채운다.
    // 행을 펼치면(isOpen) 높이가 크게 바뀌므로 매 커밋마다 갱신한다.
    useLayoutEffect(() => {
        // ref 가 비어있는 예외상황에도 측정이 끊기지 않도록 문서 전체에서 한 번 더 찾는다.
        // (측정이 비면 여백 높이가 0 이 되어 스크롤이 튀므로 이 경로를 비워둘 수 없다)
        const container = vsListRef.current || document;
        const heights = rowHeightsRef.current.map;
        container.querySelectorAll('tbody[data-vs-row]').forEach((el) => {
            const height = el.getBoundingClientRect().height;
            if (height > 0) {
                heights.set(Number(el.dataset.vsRow), height);
            }
        });
    });

    const sumRowHeights = (from, to) => {
        const heights = rowHeightsRef.current.map;
        let sum = 0;
        for (let i = from; i < to; i++) {
            sum += heights.get(i) || 0;
        }
        return sum;
    };

    /*
     * [안전장치] 떼어낼 구간의 모든 행 높이를 실제로 알고 있는지 확인한다.
     * 하나라도 모르면 여백이 실제보다 짧아져 스크롤이 위로 튄다. 그런 경우에는
     * 아예 떼어내지 않고(= 예전의 '점진적 추가' 동작으로 degrade) 안전을 택한다.
     */
    const hasAllRowHeights = (from, to) => {
        const heights = rowHeightsRef.current.map;
        for (let i = from; i < to; i++) {
            if (!heights.get(i)) return false;
        }
        return true;
    };

    // 아래로: 다음 배치를 붙이고, 창이 넘치면 위쪽을 떼어낸다
    const vsAdvance = () => {
        setVsState((prev) => {
            const cur = prev.key === renderKey
                ? prev
                : {key: renderKey, start: 0, end: Math.min(RENDER_BATCH, pageRowCount), topPx: 0};
            if (cur.end >= pageRowCount) return prev;

            const end = Math.min(cur.end + RENDER_BATCH, pageRowCount);
            let start = Math.max(cur.start, end - MAX_MOUNTED_ROWS);
            // 떼어내는 행들은 이미 그려져서 높이를 알고 있으므로 여백이 정확히 들어맞는다
            if (start > cur.start && !hasAllRowHeights(0, start)) {
                start = cur.start;   // 높이를 모르는 행이 있으면 떼어내지 않는다
            }
            return {key: renderKey, start, end, topPx: sumRowHeights(0, start)};
        });
    };

    // 위로: 떼어낸 행을 다시 붙이고, 창이 넘치면 아래쪽을 떼어낸다
    const vsRetreat = () => {
        setVsState((prev) => {
            if (prev.key !== renderKey || prev.start <= 0) return prev;
            const start = Math.max(0, prev.start - RENDER_BATCH);
            const end = Math.min(prev.end, start + MAX_MOUNTED_ROWS);
            return {key: renderKey, start, end, topPx: sumRowHeights(0, start)};
        });
    };

    // 실제로 DOM 에 그릴 행들. 페이지 기준 원래 인덱스를 함께 들고 다닌다.
    const windowRows = useMemo(() => {
        const rows = [];
        for (let i = winStart; i < winEnd; i++) {
            if (pageRows[i]) rows.push({cData: pageRows[i], i});
        }
        return rows;
    }, [pageRows, winStart, winEnd]);

    const vsTopSentinelRef = useRef(null);
    const vsBottomSentinelRef = useRef(null);

    useEffect(() => {
        if (typeof IntersectionObserver === 'undefined') return;
        const observers = [];

        const watch = (target, handler) => {
            if (!target) return;
            const observer = new IntersectionObserver((entries) => {
                if (entries.some((entry) => entry.isIntersecting)) handler();
            }, {rootMargin: `${VS_OVERSCAN_PX}px 0px`});
            observer.observe(target);
            observers.push(observer);
        };

        if (hasRowsBelow) watch(vsBottomSentinelRef.current, vsAdvance);
        if (hasRowsAbove) watch(vsTopSentinelRef.current, vsRetreat);

        return () => observers.forEach((observer) => observer.disconnect());
        /*
         * winStart/winEnd 를 의존성에 넣어, 창이 움직여 센티넬 DOM 이 교체되더라도 항상
         * 현재 노드를 감시하게 한다. 아직 감지범위 안이면 즉시 다시 발화해서 화면이
         * 찰 때까지 채우고, 다 차면 자연히 멈춘다.
         * 창 높이(150행 ≈ 25,000px)가 감지범위(화면+3,000px)보다 훨씬 커서
         * 위/아래 센티넬이 동시에 발화하는 상황은 생기지 않는다.
         */
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [renderKey, winStart, winEnd, pageRowCount, hasRowsAbove, hasRowsBelow]);

    //endregion

    //region DateSelect

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const startHandle = (e) => {
        setStartDate(e.target.value);
    };
    const endHandle = (e) => {
        setEndDate(e.target.value);
    };

    // 마운트 시 최초에만 2개월 전 날짜세팅
    const defaultMonth = () => {
        const currentDate = new Date();
        const pastDate = new Date();
        pastDate.setDate(currentDate.getDate() - 60);
        // YYYYMMDD 형식으로 변환
        const formattedStartDate = formatDate(pastDate);
        const formattedEndDate = formatDate(currentDate);
        setStartDate(formattedStartDate);
        setEndDate(formattedEndDate);
    }

    const handleRangeChange = (e) => {
        const value = e.target.value;
        const now = new Date();
        let past = new Date();

        if (value === "1개월") past.setMonth(now.getMonth() - 1);
        else if (value === "2개월") past.setMonth(now.getMonth() - 2);
        else if (value === "3개월") past.setMonth(now.getMonth() - 3);
        else if (value === "6개월") past.setMonth(now.getMonth() - 6);
        else if (value === "1년") past.setFullYear(now.getFullYear() - 1);
        else if (value === "2년") past.setFullYear(now.getFullYear() - 2);
        else if (value === "5년") past.setFullYear(now.getFullYear() - 5);
        else if (value === "10년") past.setFullYear(now.getFullYear() - 10);

        setStartDate(formatDate(past));
        setEndDate(formatDate(now));
    };

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    //endregion DateSelect

    const orderStPrint = (orderSt) => {
        const orderStStyles = {
            OS00: {color: "#98B0D4", label: "입고대기"},
            OS01: {color: "#98B0D4", label: "결제대기(상품)"},
            OS02: {color: "#98B0D4", label: "결제중(상품)"},
            OS03: {color: "#FFB378", label: "결제완료(상품)"},
            OS04: {color: "#98B0D4", label: "구매중"},
            OS05: {color: "#EB939D", label: "구매완료"},
            OS06: {color: "#98B0D4", label: "입고중"},
            OS07: {color: "#6EDA60", label: "센터도착"},
            OS08: {color: "#e57f9d", label: "패킹중"},
            OS09: {color: "#98B0D4", label: "결제대기(배송)"},
            OS10: {color: "#98B0D4", label: "결제중(배송)"},
            OS11: {color: "#FFB378", label: "결제완료(배송)"},
            OS12: {color: "#979696", label: "출고완료"},
            OS13: {color: "#FF8F62", label: "반송중"},
            OS14: {color: "#FF8F62", label: "신청취소"},
        };

        const style = orderStStyles[orderSt] || {color: "black", label: null};
        return <p style={{margin: "0", color: style.color, fontSize: "12px"}}>{style.label}</p>;
    };

    const prodStPrint = (prodSt) => {
        const prodStStyles = {
            IS00: {color: "#98B0D4", label: "입고대기"},
            IS01: {color: "#98B0D4", label: "결제대기(상품)"},
            IS02: {color: "#98B0D4", label: "결제중(상품)"},
            IS03: {color: "#FFB378", label: "결제완료(상품)"},
            IS04: {color: "#EB939D", label: "구매완료"},
            IS05: {color: "#6EDA60", label: "센터도착"},
            IS06: {color: "#98B0D4", label: "패킹중"},
            IS07: {color: "#98B0D4", label: "결제대기(배송)"},
            IS08: {color: "#98B0D4", label: "결제중(배송)"},
            IS09: {color: "#FFB378", label: "결제완료(배송)"},
            IS10: {color: "#979696", label: "출고완료"},
            IS11: {color: "#FF8F62", label: "반송중"},
            IS12: {color: "#FF8F62", label: "신청취소"},
            IS13: {color: "#98B0D4", label: "구매중"},
            IS14: {color: "#98B0D4", label: "입고중"}
        };

        const style = prodStStyles[prodSt] || {color: "black", label: null};
        return <p style={{margin: "0", color: style.color, fontSize: "14px"}}>{style.label}</p>;
    };

    // 메인알림로직
    const [lcNewOrdData, setLcNewOrdData] = useState([]);
    const [lcPayData, setLcPayData] = useState([]);
    const [lcPickupData, setLcPickupData] = useState([]);
    const [lcDepositData, setLcDepositData] = useState([]);
    const [lcReviewData, setLcReviewData] = useState([]);
    const [lcChatData, setLcChatData] = useState(0);

    const selectAlarmData = (() => {
        axios({
            method: 'get',
            url: '/order/selectAlarmData',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                const data = response.data;

                if (data.orderData.length > 0) {
                    setLcNewOrdData(data.orderData)
                }

                if (data.payList.length > 0) {
                    setLcPayData(data.payList)
                }

                if (data.depositList.length > 0) {
                    setLcDepositData(data.depositList)
                }

                if (data.reviewList.length > 0) {
                    setLcReviewData(data.reviewList)
                }

            })
            .catch((error) => {
                console.log("알림데이터 조회실패 : ", error)
            })
    });

    const selectChatCount = (() => {
        axios({
            method: 'get',
            url: '/order/selectChatCount',
        })
            .then(async (response) => {
                const totalChats = response.data.ordChat + response.data.nonUserChat;
                // [구매대행 API] 비토리지가 읽지 않은 '상점사 채팅' 메세지 수도 함께 합산한다.
                let storeChats = 0;
                try {
                    const storeRes = await axios.get('/storeChat/admin/unreadTotal', {headers: {Authorization: LCAT}});
                    storeChats = Number(storeRes.data || 0);
                } catch (e) { /* 상점사 채팅 조회 실패가 기존 알림합산을 막지 않는다 */ }
                setLcChatData(totalChats + storeChats);
            })
            .catch((error) => console.error(error))
    })

    const selectPickupCount = (() => {
        axios({
            method: 'get',
            url: '/pickup/selectPickupHistoryList',
            params: {
                status: '0'
            },
        })
            .then((res) => {
                const dataLength = res.data.length;
                setLcPickupData(dataLength);
            })
            .catch((error) => {
                console.log("조회실패 : ", error)
            })
    });

    useEffect(() => {
        selectAlarmData();
        selectChatCount();
        selectPickupCount();
    }, [])

    const moveToAlarmListPg = ((type, count) => {
        if (count > 0) {
            const stateData = {
                order: lcNewOrdData,
                pay: lcPayData,
                deposit: lcDepositData,
                review: lcReviewData
            };

            navigate(`/btcorpad/alarmlist/${type}`, {state: stateData[type]});
        }
    })

    const orderDataReceived = ((payload) => {
        let orderData = JSON.parse(payload.body);
        selectAlarmData();
        selectedAllProcessCount();
    })

    const depositDataReceived = ((payload) => {
        let depositData = JSON.parse(payload.body);
        selectAlarmData();
        selectedAllProcessCount();
    })

    const reviewDataReceived = ((payload) => {
        let reviewData = JSON.parse(payload.body);
        selectAlarmData();
        selectedAllProcessCount();
    })

    const chatDataReceived = ((payload) => {
        let chatData = JSON.parse(payload.body);
        selectChatCount();
    })

    const pickupDataReceived = ((payload) => {
        let pickupData = JSON.parse(payload.body);
        selectPickupCount();
    })

    const [copiedIndexes, setCopiedIndexes] = useState([]);

    const handleCopy = (text, index) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                setCopiedIndexes([...copiedIndexes, index]);
                setTimeout(() => {
                    setCopiedIndexes(copiedIndexes.filter(i => i !== index));
                }, 1000);
            })
            .catch((error) => {
                console.error("실패: ", error);
            });
    };

    const [modifyOneValueSt, setModifyOneValueSt] = useState(false);
    const [modifyOneValueSeqNum, setModifyOneValueSeqNum] = useState(null);
    const [beforeOneValue, setBeforeOneValue] = useState(null);
    const [modifyOneValueType, setModifyOneValueType] = useState(null);


    const handleChangeValue = (seqNum, type, value) => {
        setModifyOneValueSeqNum(seqNum);
        setBeforeOneValue(value);
        setModifyOneValueType(type);
        setTimeout(() => {
            setModifyOneValueSt(true);
        }, 100)
    };


    const modifyTrackNum = (seqNum, type, value) => {
        try {
            const config = {
                headers: {
                    'Authorization': LCAT
                },
                params: {
                    seqNum,
                    value
                }
            };

            if (type === "os") {
                // 해외운송장번호 변경 (payinfo)
                axios.post('/order/modifyOutWayNum', null, config)
                    .then(() => {
                        setFilteredList(prev =>
                            prev.map(item => {
                                if (item.type === "payinfo" && item.shipInfoDTO?.seqNum === seqNum) {
                                    return {
                                        ...item,
                                        shipInfoDTO: {
                                            ...item.shipInfoDTO,
                                            outWayNum: value
                                        }
                                    };
                                }
                                return item;
                            })
                        );
                    })
                    .catch(error => console.error("해외운송장 변경실패", error));

            } else if (type === "ds") {
                // 국내운송장번호 등록 (orderdt)
                axios.post('/order/saveDsOutWayNum', null, config)
                    .then(() => {
                        setFilteredList(prev =>
                            prev.map(item => {
                                if (item.type === "orderdt" && item.seqnum === seqNum) {
                                    return {
                                        ...item,
                                        outWaynum: value
                                    };
                                }
                                return item;
                            })
                        );
                    })
                    .catch(error => console.error("국내운송장 변경실패", error));

            } else {
                // 배송료 변경 (payinfo)
                axios.post('/order/modifyShipPrice', null, config)
                    .then(() => {
                        setFilteredList(prev =>
                            prev.map(item => {
                                if (item.type === "payinfo" && item.shipInfoDTO?.seqNum === seqNum) {
                                    return {
                                        ...item,
                                        shipInfoDTO: {
                                            ...item.shipInfoDTO,
                                            shipPrice: value
                                        }
                                    };
                                }
                                return item;
                            })
                        );
                    })
                    .catch(error => console.error("해외배송료 변경실패", error));
            }
            closeModifyPopup();
        } catch (error) {
            console.log("서버통신실패", error);
        }
    };

    const closeModifyPopup = () => {
        setModifyOneValueSt(false);
    }


    const [editMode, setEditMode] = useState(null);
    const [editedWayNum, setEditedWayNum] = useState({});

    const handleEditClick = (cData) => {
        setEditMode(cData.seqNum);
        setEditedWayNum({
            outWayNum: cData.shipInfoDTO.outWayNum,
        });
    };

    const handleFeeChange = (e, feeType) => {
        setEditedWayNum(prevWayNum => ({
            ...prevWayNum,
            [feeType]: e.target.value
        }));
    };

    const handleSaveClick = (seqNum) => {
        const wayNumToSubmit = {
            seqNum,
            outWayNum: editedWayNum.outWayNum,
        };

        axios.post('/order/updateOutWayNum', wayNumToSubmit, {
            headers: {
                'Authorization': LCAT
            }
        })
            .then(() => {
                // setData(prevData =>
                //     prevData.map(item =>
                //     item.seqNum === seqNum ? { ...item, shipInfoDTO: { ...item.shipInfoDTO, outWayNum: editedWayNum.outWayNum } } : item
                // ));
                setData(prevData => prevData.map(item =>
                    item.seqNum === seqNum ? {...item, ...editedWayNum} : item
                ));
                setEditMode(null);
            })
            .catch(error => console.error("err", error));
    };

    /** endregion Function */

    /** region Event */

    useEffect(() => {
        coopSelect();
        ordReceiptCount();
    }, [])

    const coopSelect = () => {
        axios.get('/admincoop/admincoopselect')
            .then((response) => {
                const sortedData = response.data.sort((a, b) => new Date(b.regTime) - new Date(a.regTime));
                setData(sortedData);
                setcoopCont("");
            })
            .catch((error) => {
                console.error("조회실패:", error);
            });
    }

    const coopSave = () => {
        if (coopCont === "") {
            return false;
        } else {
            axios.post('/admincoop/admincoopsave', {
                coopCont: coopCont
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: LCAT
                }
            })
                .then(() => {
                    coopSelect();
                })
                .catch(() => {
                })
        }
    }

    const coopDataDelete = () => {
        clearAllChecked();
        axios
            .delete('/admincoop/admincoopdelete', {data: noticeChecked})
            .then(() => {
                coopSelect();
                setNoticeChecked([]);
                setAlertShow2(false);
            })
            .catch(() => {
            })
    };

    const ordReceiptCount = (() => {
        axios({
            method: 'get',
            url: '/order/receiptCount',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                setOrdReceiptCountData(response.data);
            })
            .catch(() => {
            })
    })

    const selectedAdminInfo = ((retried = false) => {
        axios({
            method: 'get',
            url: '/member/findMember',
            // 재발급 직후 재시도할 때는 새 토큰을 써야 한다 (LCAT 은 렌더시점 값)
            headers: {
                Authorization: localStorage.getItem('adminToken') || LCAT
            },
        })
            .then((response) => {
                setAdminInfo(response.data)
            })
            .catch(async (error) => {
                console.log("Admin 조회실패 : ", error)
                /*
                 * 예전에는 오류 종류를 가리지 않고 바로 로그인 화면으로 보냈다.
                 * 네트워크가 잠깐 끊기거나 서버가 500 을 돌려주기만 해도
                 * 작업중인 화면에서 튕겨나갔다.
                 * 인증문제(401/403)일 때만, 그것도 토큰 재발급을 한 번 시도해본 뒤에
                 * 판단한다. 재발급에 성공하면 화면을 그대로 유지한다.
                 */
                if (await shouldSendAdminToLogin(error)) {
                    navigate("/btcorpad-login")
                    return;
                }
                // 재발급으로 살아났으면 조회를 한 번 더 시도한다 (딱 한 번만 — 무한루프 방지)
                if (!retried && (error?.response?.status === 401 || error?.response?.status === 403)) {
                    selectedAdminInfo(true);
                }
            })
    })

    useEffect(() => {
        selectedAdminInfo();
        defaultMonth();
    }, [])

    useEffect(() => {
        if (startDate && endDate) {
            selectAllData();
        }
    }, [startDate, endDate]);

    // 날짜조회
    const selectAllData = (() => {
        axios({
            method: 'get',
            url: '/order/selectAllMainData',
            headers: {
                Authorization: LCAT
            },
            params: {
                startDate: startDate.replace(/-/g, ''),
                endDate: endDate.replace(/-/g, ''),
            },
        })
            .then((response) => {
                /*
                 * [대용량 조회 개선]
                 *  1) 기존의 modiTime 정렬을 제거했다. 화면 목록은 아래 필터 useEffect 에서
                 *     combined.sort(mostRecentDate desc) 로 어차피 다시 정렬되고, payinfoList 등은
                 *     정렬 전 응답으로 만들어지므로 이 정렬은 결과에 영향이 전혀 없었다.
                 *     (수만 건이면 비교마다 new Date() 2개를 만들어 수십만 번 파싱만 했다)
                 *  2) productsList / recinfoList / prodist 세팅을 제거했다. 세 state 모두
                 *     이 파일 전체에서 '읽는 곳이 한 곳도 없는' 쓰기전용 state 였고,
                 *     특히 productsList 는 주문서마다 Map 을 새로 만들어 상품 전체를
                 *     중복제거하는 루프를 돌면서 CPU/메모리만 먹고 있었다.
                 */
                const orderList = Array.isArray(response.data) ? response.data : [];
                setOrdData(orderList);

                const payList = orderList.flatMap(order => order.payInfoDTO || []);
                setPayinfoList(payList);

                // 조회결과가 0건일 때 response.data[0] 접근으로 터지던 것을 방어
                setMemberInfo(orderList.length > 0 ? orderList[0].memberDTO : "");
            })
            .catch((error) => {
                console.log("대시보드 날짜조회 실패 : ", error)
            })
    })

    const [orderStSelectCommonValue, setOrderStSelectCommonValue] = useState("상태(전체)");

    const convertToShipco = ((dvType, defalutShipco) => {
        if (dvType === 'D00') {
            return '국내배송';
        } else if (dvType === 'D01') {
            return 'FedEx';
        } else if (dvType === 'D16') {
            return 'FedEx-E';
        } else if (dvType === 'D11') {
            return 'UPS';
        } else if (dvType === 'D17') {
            return 'UPS-E';
        } else if (dvType === 'D02') {
            return 'EMS';
        } else if (dvType === 'D15') {
            return 'EMSP';
        } else if (dvType === 'D04') {
            return 'DHL';
        } else if (dvType === 'D13') {
            return 'K-Packet';
        } else if (dvType === 'D14') {
            return 'Small-Packet';
        } else if (dvType === 'D03') {
            return 'SEA';
        } else {
            return defalutShipco;
        }
    });

    const getSpecificShippingName = (cData) => {
        const activeShipping = [];
        if (cData.ttFedexPrice > 0) activeShipping.push("FedEx");
        if (cData.ttFedexEcoPrice > 0) activeShipping.push("FedEx-E");
        if (cData.ttUpsPrice > 0) activeShipping.push("UPS");
        if (cData.ttUpsEcoPrice > 0) activeShipping.push("UPS-E");
        if (cData.ttEmsPrice > 0) activeShipping.push("EMS");
        if (cData.ttEmsPrePrice > 0) activeShipping.push("EMSP");
        if (cData.ttKPackPrice > 0) activeShipping.push("K-Packet");
        if (cData.ttAirSPrice > 0) activeShipping.push("Small-Packet");
        if (cData.ttSeaPrice > 0) activeShipping.push("SEA");

        return activeShipping.length === 1 ? activeShipping[0] : null;
    };

    const [isPackingFilter, setIsPackingFilter] = useState(false);

    /*
     * [대용량 조회 개선] 주문서(orderdt) + 배송료(payinfo) 를 한 리스트로 합치는 작업을
     * useMemo 로 분리했다.
     *  - 기존에는 아래 필터 useEffect 안에 있어서, 검색어 한 글자/드롭다운 한 번만 바꿔도
     *    PayInfoDTO(필드 약 125개) 전건을 스프레드로 다시 복사하고 전체를 재정렬했다.
     *    이제 데이터가 새로 조회될 때(ordData/payinfoList 변경)만 1회 수행된다.
     *  - 정렬키도 건당 Date 객체 3개를 만들던 것을 숫자 타임스탬프로 바꿨다.
     *    (mostRecentDate 는 이 정렬에만 쓰이고 화면에서 참조하는 곳이 없다)
     */
    const combinedList = useMemo(() => {
        if (!Array.isArray(ordData) || !Array.isArray(payinfoList)) {
            return [];
        }

        const toRow = (item, type) => {
            // Date 변환 시 안전 처리 (값이 없으면 0)
            const modiTime = item?.modiTime ? new Date(item.modiTime).getTime() || 0 : 0;
            const regTime = item?.regTime ? new Date(item.regTime).getTime() || 0 : 0;
            return {
                type,
                // Optional Chaining (?.) 적용: 데이터가 null이어도 죽지 않음
                date: item?.modiTime || item?.regTime,
                mostRecentDate: modiTime > regTime ? modiTime : regTime,
                ...item,
            };
        };

        const rows = [
            ...ordData.map((item) => toRow(item, 'orderdt')),
            ...payinfoList.map((item) => toRow(item, 'payinfo')),
        ];
        rows.sort((a, b) => b.mostRecentDate - a.mostRecentDate);
        return rows;
    }, [ordData, payinfoList]);

    useEffect(() => {
        try {
            const combined = combinedList;

            const isDateInRange = (targetDate) => {
                if (!targetDate) return false;
                if (!startDate || !endDate) return true;

                const sDate = startDate.replace(/-/g, '');
                const eDate = endDate.replace(/-/g, '');
                const tDate = targetDate.replace(/-/g, '');
                return tDate >= sDate && tDate <= eDate;
            };

            const filterStatus = (order) => {
                if (orderStSelectCommonValue === "상태(전체)") return true;
                switch (orderStSelectCommonValue) {
                    case "PS0":
                        return (order.type === 'orderdt' && order.orderStatus === "OS09") ||
                            (order.type === 'payinfo' && order.payStatus === "PS0");
                    case "PS1":
                        return (order.type === 'orderdt' && order.orderStatus === "OS10") ||
                            (order.type === 'payinfo' && order.payStatus === "PS1");
                    case "PS2":
                        return (order.type === 'orderdt' && order.orderStatus === "OS11") ||
                            (order.type === 'payinfo' && order.payStatus === "PS2");
                    case "PS3": // 출고완료
                        const isStatusMatch = (order.type === 'orderdt' && order.orderStatus === "OS12") ||
                            (order.type === 'payinfo' && order.payStatus === "PS3");
                        if (!isStatusMatch) return false;
                        // shipDate가 존재하면 shipDate가 기준, 없으면 modiDate가 기준
                        const targetShipDate = order.shipDate;
                        const targetModiDate = order.modiDate;
                        if (targetShipDate) {
                            // [중요] shipDate가 있으면 무조건 shipDate로만 판단 (modiDate 무시)
                            // shipDate가 범위 밖이면, modiDate가 범위 안이라도 false 반환됨
                            return isDateInRange(targetShipDate);
                        } else {
                            // shipDate가 null인 경우에만 modiDate 참조
                            return isDateInRange(targetModiDate);
                        }
                    case "PS4":
                        return (order.type === 'orderdt' && order.orderStatus === "OS13") ||
                            (order.type === 'payinfo' && order.payStatus === "PS4");
                    case "PS5":
                        return (order.type === 'orderdt' && order.orderStatus === "OS14") ||
                            (order.type === 'payinfo' && order.payStatus === "PS5");
                    case "OS07":
                        // 패킹리스트에 포장보류 외 데이터만 출력
                        if (isPackingFilter) {
                            // reqmnDTO가 없을 경우를 대비해 ?. 추가
                            return order.orderStatus === "OS07" && order.reqmnDTO?.packingHold === false;
                        } else {
                            return (order.type === 'orderdt' && order.orderStatus === "OS07") ||
                                (order.type === 'payinfo' && order.payStatus === "OS07");
                        }
                    default:
                        return (order.type === 'orderdt' && order.orderStatus === orderStSelectCommonValue) ||
                            (order.type === 'payinfo' && order.payStatus === orderStSelectCommonValue);
                }
            }

            const filterShipCo = (order) => {
                if (selectedShipCompany === "배송사선택") return true;
                // order.shipco 접근 시 안전하게 ?. 사용
                switch (selectedShipCompany) {
                    case "FedEx":
                        return (order.type === 'orderdt' && order?.shipco === "FedEx") ||
                            (order.type === 'payinfo' && order.dvType === "D01");
                    case "FedEx-E":
                        return (order.type === 'orderdt' && order?.shipco === "FedEx-E") ||
                            (order.type === 'payinfo' && order.dvType === "D16");
                    case "UPS":
                        return (order.type === 'orderdt' && order?.shipco === "UPS") ||
                            (order.type === 'payinfo' && order.dvType === "D11");
                    case "UPS-E":
                        return (order.type === 'orderdt' && order?.shipco === "UPS-E") ||
                            (order.type === 'payinfo' && order.dvType === "D17");
                    case "EMS":
                        return (order.type === 'orderdt' && order?.shipco === "EMS") ||
                            (order.type === 'payinfo' && order.dvType === "D02");
                    case "EMSP":
                        return (order.type === 'orderdt' && order?.shipco === "EMSP") ||
                            (order.type === 'payinfo' && order.dvType === "D15");
                    case "SEA":
                        return (order.type === 'orderdt' && order?.shipco === "SEA") ||
                            (order.type === 'payinfo' && order.dvType === "D03");
                    case "국내배송":
                        return (order.type === 'orderdt' && order?.shipco === "국내배송") ||
                            (order.type === 'payinfo' && order.dvType === "D00");
                    // case "DHL":
                    //     return (order.type === 'orderdt' && order.shipco === "DHL") ||
                    //         (order.type === 'payinfo' && order.dvType === "D04");
                    case "K-Packet":
                        return (order.type === 'orderdt' && order?.shipco === "K-Packet") ||
                            (order.type === 'payinfo' && order.dvType === "D13");
                    case "Small-Packet":
                        return (order.type === 'orderdt' && order?.shipco === "Small-Packet") ||
                            (order.type === 'payinfo' && order.dvType === "D14");
                    default:
                        // convertToShipco에 undefined가 들어가지 않도록 방어
                        return (order.type === 'orderdt' && order?.shipco === selectedShipCompany) ||
                            (order.type === 'payinfo' && convertToShipco(order.dvType, order.orderdtDTO?.shipco) === selectedShipCompany);
                }
            }

            // 🚨 [안전장치] 검색어가 null이거나 value가 null일 때 충돌 방지
            const matchesSearch = (value) => {
                const searchString = searchInput?.toLowerCase().trim() || ''; // searchInput이 null일 경우 방지
                if (!searchString) return true; // 검색어가 없으면 모두 true 처리 (혹은 상황에 맞게 조정)

                if (typeof value === 'number') {
                    const prefixedValue = `BT${value}`;
                    return searchString === prefixedValue.toLowerCase();
                }
                // value가 null/undefined면 빈 문자열로 치환
                const strValue = value ? String(value) : '';
                return strValue.toLowerCase().includes(searchString);
            };

            const filterOrderType = (order) => {
                if (orderType === "주문유형") {
                    return true;  // 모든데이터
                }
                if (orderType === "주문서") {
                    return order.type === 'orderdt';
                }
                if (orderType === "배송료") {
                    return order.type === 'payinfo';
                }
                return true;
            };

            const newList = combined.filter((order) => {
                // 각 필터 함수 실행 중 에러 발생 시 해당 항목은 제외(false) 처리될 수 있도록 고려
                try {
                    if (!filterStatus(order)) return false;
                    if (!filterShipCo(order)) return false;
                    if (!filterOrderType(order)) return false;
                    if (!searchInput || !searchInput.trim()) return true;

                    if (order.type === 'orderdt') {
                        // DTO나 하위 객체가 null일 경우 ?. 사용 및 배열인 경우 || [] 처리
                        return (
                            matchesSearch(order?.orderNumber) ||
                            matchesSearch(order?.shipco) ||
                            matchesSearch(order.memberDTO?.mbNum) ||
                            matchesSearch(order.memberDTO?.userName) ||
                            matchesSearch(order.recinfoDTO?.recname) ||
                            matchesSearch(order.recinfoDTO?.countryDTO?.countryEngNm) ||
                            matchesSearch(order.recinfoDTO?.countryDTO?.countryNm) ||
                            matchesSearch(order.recinfoDTO?.country) ||
                            matchesSearch('주문서') ||
                            (order.productsDTO || []).some((prod) => matchesSearch(prod?.option)) ||
                            (order.productsDTO || []).some((prod) => matchesSearch(prod?.name)) ||
                            (order.productsDTO || []).some((prod) => matchesSearch(prod?.inWaynum))
                        );
                    } else if (order.type === 'payinfo') {
                        return (
                            matchesSearch(order.orderdtDTO?.orderNumber) ||
                            matchesSearch(convertToShipco(order.dvType, order.orderdtDTO?.shipco)) ||
                            matchesSearch(order.orderdtDTO?.memberDTO?.mbNum) ||
                            matchesSearch(order.orderdtDTO?.memberDTO?.userName) ||
                            matchesSearch(order.appRecDTO?.recname) ||
                            matchesSearch(order.appRecDTO?.countryDTO?.countryEngNm) ||
                            matchesSearch(order.appRecDTO?.countryDTO?.countryNm) ||
                            matchesSearch(order.appRecDTO?.country) ||
                            matchesSearch(order.appOrderMemoDTO?.ordDtCont) ||
                            matchesSearch(order.shipInfoDTO?.outWayNum) ||
                            matchesSearch('배송료') ||
                            (order.packListDTO?.productsDTO || []).some((prod) => matchesSearch(prod?.option)) ||
                            (order.packListDTO?.productsDTO || []).some((prod) => matchesSearch(prod?.name))
                        );
                    }
                    return false;
                } catch (innerErr) {
                    // 특정 데이터 필터링 중 에러 발생 시 그 행만 제외하고 계속 진행
                    console.warn("Row filtering skipped due to error:", innerErr);
                    return false;
                }
            });

            /*
             * [대용량 조회 개선] 필터결과 전체를 콘솔에 찍던 로그를 제거했다.
             *  수만 건 대형 객체 배열을 console 에 넘기면 브라우저가 그 배열을 계속
             *  참조해서 GC 가 회수하지 못하고(개발자도구가 열려 있으면 더 치명적),
             *  광범위 날짜조회에서 메모리 급증과 화면 멈춤의 원인이 됐다.
             *  건수만 남긴다.
             */
            console.log("필터 후 데이터건수 : ", newList.length);
            setFilteredList(newList);

        } catch (err) {
            // 🚨 치명적 오류 발생 시 화이트스크린 대신 빈 리스트 처리 및 로그 기록
            console.error("Dashboard Filtering Error (White Screen Prevention):", err);
            setFilteredList([]);
        }

    }, [combinedList, searchInput, orderStSelectCommonValue, selectedShipCompany, orderType, isPackingFilter, startDate, endDate]);

    // useEffect(() => {
    //
    //     // 데이터 로드 전 실행 시
    //     if (!Array.isArray(ordData) || !Array.isArray(payinfoList)) {
    //         setFilteredList([]);
    //         return;
    //     }
    //
    //     const combined = [
    //         ...ordData.map((item) => ({
    //             type: 'orderdt',
    //             date: item.modiTime || item.regTime,
    //             mostRecentDate: new Date(Math.max(new Date(item.modiTime), new Date(item.regTime))),
    //             ...item,
    //         })),
    //         ...payinfoList.map((item) => ({
    //             type: 'payinfo',
    //             date: item?.modiTime || item?.regTime,
    //             mostRecentDate: new Date(Math.max(new Date(item.modiTime), new Date(item.regTime))),
    //             ...item,
    //         })),
    //     ];
    //
    //     combined.sort((a, b) => b.mostRecentDate - a.mostRecentDate);
    //     // combined.sort((a, b) => moment(b.date).isAfter(moment(a.date)) ? 1 : 0);
    //
    //     // 프로세스현황의 출고완료(shipDate) 데이터출력 날짜비교
    //     const isDateInRange = (targetDate) => {
    //         if (!targetDate) return false;
    //         const sDate = startDate.replace(/-/g, '');
    //         const eDate = endDate.replace(/-/g, '');
    //         const tDate = targetDate.replace(/-/g, '');
    //         return tDate >= sDate && tDate <= eDate;
    //     };
    //
    //     const filterStatus = (order) => {
    //         if (orderStSelectCommonValue === "상태(전체)") return true;
    //         switch (orderStSelectCommonValue) {
    //             case "PS0":
    //                 return (order.type === 'orderdt' && order.orderStatus === "OS09") ||
    //                     (order.type === 'payinfo' && order.payStatus === "PS0");
    //             case "PS1":
    //                 return (order.type === 'orderdt' && order.orderStatus === "OS10") ||
    //                     (order.type === 'payinfo' && order.payStatus === "PS1");
    //             case "PS2":
    //                 return (order.type === 'orderdt' && order.orderStatus === "OS11") ||
    //                     (order.type === 'payinfo' && order.payStatus === "PS2");
    //             case "PS3": // 출고완료
    //                 const isStatusMatch = (order.type === 'orderdt' && order.orderStatus === "OS12") ||
    //                     (order.type === 'payinfo' && order.payStatus === "PS3");
    //                 if (!isStatusMatch) return false;
    //                 // shipDate가 존재하면 shipDate가 기준, 없으면 modiDate가 기준
    //                 const targetShipDate = order.shipDate;
    //                 const targetModiDate = order.modiDate;
    //                 if (targetShipDate) {
    //                     // [중요] shipDate가 있으면 무조건 shipDate로만 판단 (modiDate 무시)
    //                     // shipDate가 범위 밖이면, modiDate가 범위 안이라도 false 반환됨
    //                     return isDateInRange(targetShipDate);
    //                 } else {
    //                     // shipDate가 null인 경우에만 modiDate 참조
    //                     return isDateInRange(targetModiDate);
    //                 }
    //             case "PS4":
    //                 return (order.type === 'orderdt' && order.orderStatus === "OS13") ||
    //                     (order.type === 'payinfo' && order.payStatus === "PS4");
    //             case "PS5":
    //                 return (order.type === 'orderdt' && order.orderStatus === "OS14") ||
    //                     (order.type === 'payinfo' && order.payStatus === "PS5");
    //             case "OS07":
    //                 // 패킹리스트에 포장보류 외 데이터만 출력
    //                 if (isPackingFilter) {
    //                     return order.orderStatus === "OS07" && order.reqmnDTO?.packingHold === false;
    //                 }
    //                 else {
    //                     return (order.type === 'orderdt' && order.orderStatus === "OS07") ||
    //                         (order.type === 'payinfo' && order.payStatus === "OS07");
    //                 }
    //             default:
    //                 return (order.type === 'orderdt' && order.orderStatus === orderStSelectCommonValue) ||
    //                     (order.type === 'payinfo' && order.payStatus === orderStSelectCommonValue);
    //         }
    //     }
    //
    //     const filterShipCo = (order) => {
    //         if (selectedShipCompany === "배송사선택") return true;
    //         switch (selectedShipCompany) {
    //             case "FedEx":
    //                 return (order.type === 'orderdt' && order?.shipco === "FedEx") ||
    //                     (order.type === 'payinfo' && order.dvType === "D01");
    //             case "FedEx-E":
    //                 return (order.type === 'orderdt' && order?.shipco === "FedEx-E") ||
    //                     (order.type === 'payinfo' && order.dvType === "D16");
    //             case "UPS":
    //                 return (order.type === 'orderdt' && order?.shipco === "UPS") ||
    //                     (order.type === 'payinfo' && order.dvType === "D11");
    //             case "UPS-E":
    //                 return (order.type === 'orderdt' && order?.shipco === "UPS-E") ||
    //                     (order.type === 'payinfo' && order.dvType === "D17");
    //             case "EMS":
    //                 return (order.type === 'orderdt' && order?.shipco === "EMS") ||
    //                     (order.type === 'payinfo' && order.dvType === "D02");
    //             case "EMSP":
    //                 return (order.type === 'orderdt' && order?.shipco === "EMSP") ||
    //                     (order.type === 'payinfo' && order.dvType === "D15");
    //             case "SEA":
    //                 return (order.type === 'orderdt' && order?.shipco === "SEA") ||
    //                     (order.type === 'payinfo' && order.dvType === "D03");
    //             case "국내배송":
    //                 return (order.type === 'orderdt' && order?.shipco === "국내배송") ||
    //                     (order.type === 'payinfo' && order.dvType === "D00");
    //             // case "DHL":
    //             //     return (order.type === 'orderdt' && order.shipco === "DHL") ||
    //             //         (order.type === 'payinfo' && order.dvType === "D04");
    //             case "K-Packet":
    //                 return (order.type === 'orderdt' && order?.shipco === "K-Packet") ||
    //                     (order.type === 'payinfo' && order.dvType === "D13");
    //             case "Small-Packet":
    //                 return (order.type === 'orderdt' && order?.shipco === "Small-Packet") ||
    //                     (order.type === 'payinfo' && order.dvType === "D14");
    //             default:
    //                 return (order.type === 'orderdt' && order?.shipco === selectedShipCompany) ||
    //                     (order.type === 'payinfo' && convertToShipco(order.dvType, order.orderdtDTO?.shipco) === selectedShipCompany);
    //         }
    //     }
    //
    //     const matchesSearch = (value) => {
    //         const searchString = searchInput.toLowerCase().trim();
    //         if (typeof value === 'number') {
    //             const prefixedValue = `BT${value}`;
    //             return searchString === prefixedValue.toLowerCase();
    //         }
    //         return value?.toString().toLowerCase().includes(searchString);
    //     };
    //
    //     const filterOrderType = (order) => {
    //         if (orderType === "주문유형") {
    //             return true;  // 모든데이터
    //         }
    //         if (orderType === "주문서") {
    //             return order.type === 'orderdt';
    //         }
    //         if (orderType === "배송료") {
    //             return order.type === 'payinfo';
    //         }
    //         return true;
    //     };
    //
    //     const newList = combined.filter((order) => {
    //         if (!filterStatus(order)) return false;
    //         if (!filterShipCo(order)) return false;
    //         if (!filterOrderType(order)) return false;
    //         if (!searchInput.trim()) return true;
    //
    //         if (order.type === 'orderdt') {
    //             return (
    //                 matchesSearch(order?.orderNumber) ||
    //                 matchesSearch(order?.shipco) ||
    //                 matchesSearch(order.memberDTO?.mbNum) ||
    //                 matchesSearch(order.memberDTO?.userName) ||
    //                 matchesSearch(order.recinfoDTO?.recname) ||
    //                 matchesSearch(order.recinfoDTO?.countryDTO?.countryEngNm) ||
    //                 matchesSearch(order.recinfoDTO?.countryDTO?.countryNm) ||
    //                 matchesSearch(order.recinfoDTO?.country) ||
    //                 matchesSearch('주문서') ||
    //                 order.productsDTO?.some((prod) => matchesSearch(prod?.option)) ||
    //                 order.productsDTO?.some((prod) => matchesSearch(prod?.name)) ||
    //                 order.productsDTO?.some((prod) => matchesSearch(prod?.inWaynum))
    //             );
    //         } else if (order.type === 'payinfo') {
    //             return (
    //                 matchesSearch(order.orderdtDTO?.orderNumber) ||
    //                 matchesSearch(convertToShipco(order.dvType, order.orderdtDTO?.shipco)) ||
    //                 matchesSearch(order.orderdtDTO?.memberDTO?.mbNum) ||
    //                 matchesSearch(order.orderdtDTO?.memberDTO?.userName) ||
    //                 matchesSearch(order.appRecDTO?.recname) ||
    //                 matchesSearch(order.appRecDTO?.countryDTO?.countryEngNm) ||
    //                 matchesSearch(order.appRecDTO?.countryDTO?.countryNm) ||
    //                 matchesSearch(order.appRecDTO?.country) ||
    //                 matchesSearch(order.appOrderMemoDTO?.ordDtCont) ||
    //                 matchesSearch(order.shipInfoDTO?.outWayNum) ||
    //                 matchesSearch('배송료') ||
    //                 order.packListDTO?.productsDTO?.some((prod) => matchesSearch(prod?.option)) ||
    //                 order.packListDTO?.productsDTO?.some((prod) => matchesSearch(prod?.name))
    //             );
    //         }
    //     });
    //     console.log("필터 후 데이터리스트 : ", newList);
    //     setFilteredList(newList);
    // }, [ordData, payinfoList, searchInput, orderStSelectCommonValue, selectedShipCompany, orderType, isPackingFilter, startDate, endDate]);

    // useEffect(() => {
    //
    //     // 데이터 로드 전 실행 시
    //     if (!Array.isArray(ordData) || !Array.isArray(payinfoList)) {
    //         setFilteredList([]);
    //         return;
    //     }
    //
    //     const combined = [
    //         ...ordData.map((item) => ({
    //             type: 'orderdt',
    //             date: item.modiTime || item.regTime,
    //             mostRecentDate: new Date(Math.max(new Date(item.modiTime), new Date(item.regTime))),
    //             ...item,
    //         })),
    //         ...payinfoList.map((item) => ({
    //             type: 'payinfo',
    //             date: item?.modiTime || item?.regTime,
    //             mostRecentDate: new Date(Math.max(new Date(item.modiTime), new Date(item.regTime))),
    //             ...item,
    //         })),
    //     ];
    //
    //     combined.sort((a, b) => b.mostRecentDate - a.mostRecentDate);
    //     // combined.sort((a, b) => moment(b.date).isAfter(moment(a.date)) ? 1 : 0);
    //
    //     const filterStatus = (order) => {
    //         if (orderStSelectCommonValue === "상태(전체)") return true;
    //         switch (orderStSelectCommonValue) {
    //             case "PS0":
    //                 return (order.type === 'orderdt' && order.orderStatus === "OS09") ||
    //                     (order.type === 'payinfo' && order.payStatus === "PS0");
    //             case "PS1":
    //                 return (order.type === 'orderdt' && order.orderStatus === "OS10") ||
    //                     (order.type === 'payinfo' && order.payStatus === "PS1");
    //             case "PS2":
    //                 return (order.type === 'orderdt' && order.orderStatus === "OS11") ||
    //                     (order.type === 'payinfo' && order.payStatus === "PS2");
    //             case "PS3":
    //                 return (order.type === 'orderdt' && order.orderStatus === "OS12") ||
    //                     (order.type === 'payinfo' && order.payStatus === "PS3");
    //             case "PS4":
    //                 return (order.type === 'orderdt' && order.orderStatus === "OS13") ||
    //                     (order.type === 'payinfo' && order.payStatus === "PS4");
    //             case "PS5":
    //                 return (order.type === 'orderdt' && order.orderStatus === "OS14") ||
    //                     (order.type === 'payinfo' && order.payStatus === "PS5");
    //             case "OS07":
    //                 // 패킹리스트에 포장보류 외 데이터만 출력
    //                 if (isPackingFilter) {
    //                     return order.orderStatus === "OS07" && order.reqmnDTO?.packingHold === false;
    //                 }
    //                 else {
    //                     return (order.type === 'orderdt' && order.orderStatus === "OS07") ||
    //                         (order.type === 'payinfo' && order.payStatus === "OS07");
    //                 }
    //             default:
    //                 return (order.type === 'orderdt' && order.orderStatus === orderStSelectCommonValue) ||
    //                     (order.type === 'payinfo' && order.payStatus === orderStSelectCommonValue);
    //         }
    //     }
    //
    //     const filterShipCo = (order) => {
    //         if (selectedShipCompany === "배송사선택") return true;
    //         switch (selectedShipCompany) {
    //             case "FedEx":
    //                 return (order.type === 'orderdt' && order?.shipco === "FedEx") ||
    //                     (order.type === 'payinfo' && order.dvType === "D01");
    //             case "FedEx-E":
    //                 return (order.type === 'orderdt' && order?.shipco === "FedEx-E") ||
    //                     (order.type === 'payinfo' && order.dvType === "D16");
    //             case "UPS":
    //                 return (order.type === 'orderdt' && order?.shipco === "UPS") ||
    //                     (order.type === 'payinfo' && order.dvType === "D11");
    //             case "UPS-E":
    //                 return (order.type === 'orderdt' && order?.shipco === "UPS-E") ||
    //                     (order.type === 'payinfo' && order.dvType === "D17");
    //             case "EMS":
    //                 return (order.type === 'orderdt' && order?.shipco === "EMS") ||
    //                     (order.type === 'payinfo' && order.dvType === "D02");
    //             case "EMSP":
    //                 return (order.type === 'orderdt' && order?.shipco === "EMSP") ||
    //                     (order.type === 'payinfo' && order.dvType === "D15");
    //             case "SEA":
    //                 return (order.type === 'orderdt' && order?.shipco === "SEA") ||
    //                     (order.type === 'payinfo' && order.dvType === "D03");
    //             case "국내배송":
    //                 return (order.type === 'orderdt' && order?.shipco === "국내배송") ||
    //                     (order.type === 'payinfo' && order.dvType === "D00");
    //             // case "DHL":
    //             //     return (order.type === 'orderdt' && order.shipco === "DHL") ||
    //             //         (order.type === 'payinfo' && order.dvType === "D04");
    //             case "K-Packet":
    //                 return (order.type === 'orderdt' && order?.shipco === "K-Packet") ||
    //                     (order.type === 'payinfo' && order.dvType === "D13");
    //             case "Small-Packet":
    //                 return (order.type === 'orderdt' && order?.shipco === "Small-Packet") ||
    //                     (order.type === 'payinfo' && order.dvType === "D14");
    //             default:
    //                 return (order.type === 'orderdt' && order?.shipco === selectedShipCompany) ||
    //                     (order.type === 'payinfo' && convertToShipco(order.dvType, order.orderdtDTO?.shipco) === selectedShipCompany);
    //         }
    //     }
    //
    //     const matchesSearch = (value) => {
    //         const searchString = searchInput.toLowerCase().trim();
    //         if (typeof value === 'number') {
    //             const prefixedValue = `BT${value}`;
    //             return searchString === prefixedValue.toLowerCase();
    //         }
    //         return value?.toString().toLowerCase().includes(searchString);
    //     };
    //
    //     const filterOrderType = (order) => {
    //         if (orderType === "주문유형") {
    //             return true;  // 모든데이터
    //         }
    //         if (orderType === "주문서") {
    //             return order.type === 'orderdt';
    //         }
    //         if (orderType === "배송료") {
    //             return order.type === 'payinfo';
    //         }
    //         return true;
    //     };
    //
    //     const newList = combined.filter((order) => {
    //         if (!filterStatus(order)) return false;
    //         if (!filterShipCo(order)) return false;
    //         if (!filterOrderType(order)) return false;
    //         if (!searchInput.trim()) return true;
    //
    //         if (order.type === 'orderdt') {
    //             return (
    //                 matchesSearch(order?.orderNumber) ||
    //                 matchesSearch(order?.shipco) ||
    //                 matchesSearch(order.memberDTO?.mbNum) ||
    //                 matchesSearch(order.memberDTO?.userName) ||
    //                 matchesSearch(order.recinfoDTO?.recname) ||
    //                 matchesSearch(order.recinfoDTO?.countryDTO?.countryEngNm) ||
    //                 matchesSearch(order.recinfoDTO?.countryDTO?.countryNm) ||
    //                 matchesSearch(order.recinfoDTO?.country) ||
    //                 matchesSearch('주문서') ||
    //                 order.productsDTO?.some((prod) => matchesSearch(prod?.option)) ||
    //                 order.productsDTO?.some((prod) => matchesSearch(prod?.name)) ||
    //                 order.productsDTO?.some((prod) => matchesSearch(prod?.inWaynum))
    //             );
    //         } else if (order.type === 'payinfo') {
    //             return (
    //                 matchesSearch(order.orderdtDTO?.orderNumber) ||
    //                 matchesSearch(convertToShipco(order.dvType, order.orderdtDTO?.shipco)) ||
    //                 matchesSearch(order.orderdtDTO?.memberDTO?.mbNum) ||
    //                 matchesSearch(order.orderdtDTO?.memberDTO?.userName) ||
    //                 matchesSearch(order.appRecDTO?.recname) ||
    //                 matchesSearch(order.appRecDTO?.countryDTO?.countryEngNm) ||
    //                 matchesSearch(order.appRecDTO?.countryDTO?.countryNm) ||
    //                 matchesSearch(order.appRecDTO?.country) ||
    //                 matchesSearch(order.appOrderMemoDTO?.ordDtCont) ||
    //                 matchesSearch(order.shipInfoDTO?.outWayNum) ||
    //                 matchesSearch('배송료') ||
    //                 order.packListDTO?.productsDTO?.some((prod) => matchesSearch(prod?.option)) ||
    //                 order.packListDTO?.productsDTO?.some((prod) => matchesSearch(prod?.name))
    //             );
    //         }
    //     });
    //     console.log("필터 후 데이터리스트 : ", newList);
    //     setFilteredList(newList);
    // }, [ordData, payinfoList, searchInput, orderStSelectCommonValue, selectedShipCompany, orderType, isPackingFilter]);


    // 패킹리스트 개수 출력
    const packableCount = useMemo(() => {
        const combinedData = [
            ...ordData.map(item => ({...item, type: 'orderdt'})),
            ...payinfoList.map(item => ({...item, type: 'payinfo'}))
        ];

        const packableItems = combinedData.filter(order => {
            const isOS06 = order.orderStatus === "OS06";
            const isPackableOS07 = order.orderStatus === "OS07" && order.reqmnDTO?.packingHold === false;
            return isOS06 || isPackableOS07;
        });

        return packableItems.length;
    }, [ordData, payinfoList]);

    const orderContentRef = useRef(null);
    const scrollToOrderContent = () => {
        if (orderContentRef.current) {
            orderContentRef?.current.scrollIntoView({behavior: 'smooth'});
        }
    };

    const [selectedProcessSt, setSelectedProcessSt] = useState('');
    // 조건없는 전체조회
    const selectNoDateTotalOrderList = ((orderSt) => {
        if (orderSt === "OS01" || orderSt === "PS0" || orderSt === "PS3") {
            clearAllChecked();
        }
        setSelectedProcessSt(orderSt);

        /*
         * [대용량 조회 개선] 출고완료(PS3)만 날짜조건을 서버로 넘긴다.
         *
         *  이 함수는 원래 startDate/endDate 를 아예 보내지 않았고, 백엔드는 조건이 비면
         *  where 절이 사라져 ORD_DT_TB '전 기간 전체'를 모든 조인과 함께 끌어왔다.
         *  출고완료 프로세스를 누른 뒤 1년치를 보려는 흐름에서, 첫 클릭만으로 전 기간
         *  데이터를 받아오느라 랙/페이지대기가 발생했다.
         *
         *  그런데 날짜를 무조건 넘기면 안 된다. 입고대기(OS00)~결제완료(OS11) 등 다른
         *  프로세스는 아래 filterStatus 에서 날짜를 보지 않기 때문에, 지금까지
         *  '날짜범위와 무관하게 전건' 을 보여주는 것이 정상동작이었다. 날짜를 넘기면
         *  범위 밖의 미처리 건이 목록에서 사라져 운영에 지장이 생긴다.
         *
         *  반면 PS3(출고완료)는 filterStatus 가 shipDate(없으면 modiDate)를 현재
         *  날짜범위와 비교해서 걸러내므로, 서버에서 같은 범위로 미리 좁혀도 화면에
         *  출력되는 결과가 달라지지 않는다. (서버조건은 regDate/modiDate/shipDate 중
         *  하나라도 범위에 들면 통과시키므로 shipDate 가 범위 안인 건은 반드시 포함된다)
         */
        const useDateRange = orderSt === "PS3" && !!startDate && !!endDate;

        axios({
            method: 'get',
            url: '/order/selectAllMainData',
            headers: {
                Authorization: LCAT
            },
            params: useDateRange ? {
                startDate: startDate.replace(/-/g, ''),
                endDate: endDate.replace(/-/g, ''),
            } : undefined,
        })
            .then((response) => {
                // 정렬/미사용 state 세팅 제거 (사유는 selectAllData 주석 참고)
                const orderList = Array.isArray(response.data) ? response.data : [];
                setOrdData(orderList);

                const payList = orderList.flatMap(order => order.payInfoDTO || []);
                setPayinfoList(payList);

                scrollToOrderContent();
                setOrderStSelectCommonValue(orderSt);
                // 추후 개월수 로직 완료되면 개월값을 default로 변경예정
                // setPeriodSelectCommonValue("전체")

            })
            .catch((error) => {
                console.log("노데이트 주문조회실패 : ", error)
            })
    })

    //region Modal-blank

    let WayModal = null;
    const width = 850;
    const height = 900;
    const left = (window.innerWidth / 2) - (width / 2);
    const top = (window.innerHeight / 2) - (height / 2);

    const wayModalRef = useRef(null);

    const openPayModal = (data, type) => {
        const combinedData = {
            ...data,
            type,
        };
        const url = `/btcorpad/btad-Payreg2`;
        const width = 660;
        const height = 840;
        const left = (window.innerWidth / 2) - (width / 2);
        const top = (window.innerHeight / 2) - (height / 2);

        const popup = window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top},scrollbars=yes`);

        if (popup) {
            localStorage.setItem('ordData', JSON.stringify(combinedData));
        } else {
            console.error('Popup open error');
        }
    };

    const openModal = (rowData, dataType) => {
        const combinedData = {
            ...rowData,
            dataType,
        };

        localStorage.setItem('orderData', JSON.stringify(combinedData));

        const url = 'btad-Payreg';
        const widthP = 660;
        const heightP = 840;
        const leftP = (window.innerWidth / 2) - (widthP / 2);
        const topP = (window.innerHeight / 2) - (heightP / 2);

        if (wayModalRef.current && !wayModalRef.current.closed) {
            wayModalRef.current.location.href = `/btcorpad/${url}`;
            wayModalRef.current.focus();
        } else {
            wayModalRef.current = window.open(`/btcorpad/${url}`, '_blank', `width=${widthP},height=${heightP},left=${leftP},top=${topP},scrollbars=yes`);
        }
    };

    const openModalMerge = (rowData) => {
        localStorage.setItem('orderData', JSON.stringify(rowData));
        if (WayModal && !WayModal.closed) {
            WayModal.location.href = '/btcorpad/btad-Merge';
            WayModal.focus();
        } else {
            WayModal = window.open('/btcorpad/btad-Merge', '_blank', `width=${width},height=${height},left=${left},top= ${top}, scrollbars=yes`);
        }
        // 주기적으로 팝업 창이 닫혔는지 확인후 닫혔으면 order 재조회
        const checkPopupClosed = setInterval(async () => {
            if (!WayModal || WayModal.closed) {
                clearInterval(checkPopupClosed);
                // 분리/통합 여부 상관없이 팝업창만 닫아도 재조회하고 있어서 나중에
                selectAllData();
            }
        }, 2000);
    };

    const openModalDivide = (rowData) => {
        localStorage.setItem('orderData', JSON.stringify(rowData));
        if (WayModal && !WayModal.closed) {
            WayModal.location.href = '/btcorpad/btad-Divide';
            WayModal.focus();
        } else {
            WayModal = window.open('/btcorpad/btad-Divide', '_blank', `width=${width},height=${height},left=${left},top= ${top}, scrollbars=yes`);
        }
        // 주기적으로 팝업 창이 닫혔는지 확인후 닫혔으면 order 재조회
        const checkPopupClosed = setInterval(async () => {
            if (!WayModal || WayModal.closed) {
                clearInterval(checkPopupClosed);
                selectAllData();
            }
        }, 2000);
    };

    //endregion

    // region Excel

    const date = new Date();
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const DateViewValue = year + month + day;

    /*
     * ────────────────────────────────────────────────────────────────────────────
     * [엑셀 대용량 다운로드 개선] 엑셀 1개 파일당 최대 데이터 행수
     *   exceljs 는 셀 1개당 자바스크립트 객체 1개를 메모리에 들고 있어서 행수가 커지면
     *   브라우저 탭이 OOM 으로 죽는다. (실측: 3만행 ≈ JS heap 1.1GB / 9만행 ≈ 2.9GB)
     *   또 writeBuffer() 는 중간에 끊을 수 없는 단일 작업이라 파일이 너무 크면
     *   그 구간에서만 수십초 멈춰 '페이지 대기' 팝업이 뜬다.
     *   → 이 행수를 넘으면 주문서(병합그룹) 경계를 깨지 않고 여러 파일로 나눠 내려준다.
     *
     *   15,000 으로 잡은 근거: 3만행에서 JS heap 이 약 1.39GB 까지 올라가는데, 메모리가
     *   넉넉하지 않은 PC 에서는 그 자체로 탭이 죽을 수 있다. 절반으로 낮추면 파일당
     *   약 700MB 로 떨어지고(파일을 하나씩 만들고 버리므로 피크가 누적되지 않는다),
     *   writeBuffer 구간도 파일당 5~6초로 줄어 '페이지 대기' 위험이 더 낮아진다.
     * ────────────────────────────────────────────────────────────────────────────
     */
    const EXCEL_MAX_ROWS_PER_FILE = 15000;

    // 긴 동기작업 중간에 메인스레드를 양보해서 화면 멈춤과 '페이지 대기' 팝업을 막는다
    const yieldToBrowser = () => new Promise((resolve) => setTimeout(resolve, 0));

    const [excelLoading, setExcelLoading] = useState(false);

    /*
     * ════════════════════════════════════════════════════════════════════════════
     * EXCEL[주문서] 다운로드
     *
     *  1순위) 서버생성(/order/excelMainOrderList)
     *     체크한 행의 (유형, 식별번호)만 보내고 서버가 POI SXSSF 로 스트리밍 생성한다.
     *     브라우저는 파일을 받기만 하므로 수만~수십만 건도 메모리 부담이 없고 단일 파일이다.
     *     필터를 서버가 다시 해석하지 않고 '선택된 행'만 받으므로 화면과 어긋날 수 없다.
     *
     *  2순위) 브라우저생성(아래 excelDownInBrowser)
     *     서버 엔드포인트가 아직 배포되지 않았거나 장애일 때를 위한 대체경로다.
     *     프론트/백엔드 배포시점이 달라도 엑셀이 끊기지 않게 하기 위해 남겨둔다.
     *     두 경로의 결과물이 동일한지는 백엔드 OrderExcelServiceParityTest 로 검증한다.
     * ════════════════════════════════════════════════════════════════════════════
     */
    const excelDown = async () => {
        if (excelLoading) return;
        setExcelLoading(true);
        try {
            // 로딩모달이 실제로 화면에 그려진 뒤에 무거운 작업을 시작한다
            await yieldToBrowser();

            // 주문서/배송료의 번호가 겹칠 수 있어서 '유형:번호' 키로 매칭한다(Set 조회)
            // 화면에 그려진 행수(점진적 렌더링)와 무관하게 '조회된 전건' 중 체크된 것을 대상으로 한다
            const selectedRows = filteredList.filter((item) => checkedKeySet.has(getRowCheckKey(item)));

            if (selectedRows.length === 0) {
                window.alert("다운로드할 데이터를 선택해주세요");
                return;
            }

            try {
                await excelDownFromServer(selectedRows);
                return;
            } catch (serverError) {
                console.warn("[EXCEL] 서버생성 실패 - 브라우저 생성으로 대체합니다.", serverError);
            }

            await excelDownInBrowser(selectedRows);
        } catch (error) {
            console.error("엑셀[주문서] 다운로드 중 오류 발생:", error);
        } finally {
            setExcelLoading(false);
        }
    };

    /** 서버에서 생성된 엑셀을 받아 내려준다 */
    const excelDownFromServer = async (selectedRows) => {
        // 유형은 행마다 객체를 만들지 않고 한 글자씩 이어붙여 전송량을 줄인다
        let types = '';
        const seqnums = [];
        for (const row of selectedRows) {
            const isOrderdt = row.type === 'orderdt';
            types += isOrderdt ? 'O' : 'P';
            seqnums.push(isOrderdt ? row.seqnum : row.seqNum);
        }

        const response = await axios({
            method: 'post',
            url: '/order/excelMainOrderList',
            headers: {
                'Content-Type': 'application/json',
                Authorization: LCAT
            },
            data: {types, seqnums, dateLabel: DateViewValue},
            responseType: 'blob',
            // 수십만 건은 서버 생성에 시간이 걸릴 수 있어 전역 60초 제한을 늘린다
            timeout: 600000,
        });

        const url = window.URL.createObjectURL(response.data);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = `[BT]OrderList_${DateViewValue}.xlsx`;
        anchor.click();
        setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    };

    const excelDownInBrowser = async (selectedRows) => {
        try {
            const excel = require('exceljs');

            // region 주문상태(OS) & 상품상태(IS) 정의

            function interpretOrderStatus(status) {
                const statusMap = {
                    'OS00': '입고대기',
                    'OS01': '결제대기(상품)',
                    'OS02': '결제중(상품)',
                    'OS03': '결제대기(상품)',
                    'OS04': '구매중',
                    'OS05': '구매완료',
                    'OS06': '입고중',
                    'OS07': '센터도착',
                    'OS08': '패킹중',
                    'OS09': '결제대기(배송)',
                    'OS10': '결제중(배송)',
                    'OS11': '결제완료(배송)',
                    'OS12': '출고완료',
                    'OS13': '반송중',
                    'OS14': '출고완료',
                };
                return statusMap[status] || 'N/A';
            }

            function interpretPayStatus(status) {
                const statusMap = {
                    'PS0': '결제대기',
                    'PS1': '결제중',
                    'PS2': '결제완료',
                    'PS3': '출고완료',
                };
                return statusMap[status] || 'N/A';
            }

            function interpretProdType(status) {
                const statusMap = {
                    'P00': '장바구니',
                    'P01': '구매대행',
                    'P02': '오프라인',
                    'P03': '이체대행',
                    'P04': '국내배송',
                    'P05': '배송대행',
                };
                return statusMap[status] || 'N/A';
            }

            function interpretProdStatus(status) {
                const statusMap = {
                    'IS00': '입고대기',
                    'IS01': '결제대기(P)',
                    'IS02': '결제중(P)',
                    'IS03': '결제완료(P)',
                    'IS04': '구매완료',
                    'IS05': '센터도착',
                    'IS06': '패킹중',
                    'IS07': '결제대기(D)',
                    'IS08': '결제중(D)',
                    'IS09': '결제완료(D)',
                    'IS10': '출고완료',
                    'IS11': '반송중',
                    'IS12': '신청취소',
                    'IS13': '구매중',
                    'IS14': '입고중',
                };
                return statusMap[status] || 'N/A';
            }

            // endregion

            function getSafeValue(obj, key, defaultValue = '') {
                return obj && obj[key] !== undefined ? obj[key] : defaultValue;
            }

            function getSafeArray(obj, key) {
                return obj && Array.isArray(obj[key]) ? obj[key] : [];
            }

            /*
             * [관부가세선납 컬럼]
             *  관부가세선납 금액은 배송사별로 서로 다른 컬럼에 저장되고, 한 배송료건에서
             *  값이 들어있는 컬럼은 (있다면) 하나뿐이다. 그래서 배송사타입(dvType)에
             *  해당하는 컬럼만 읽는다. convertToShipco() 의 dvType 분기와 1:1로 맞췄다.
             *
             *  주의: EMSP(D15) / DHL(D04) 는 배송료등록 저장단계에서 emsPreCusPrepay,
             *  dhlCusPrepay 가 0 으로 고정 저장되므로 엑셀에도 0 으로 출력된다(의도된 동작).
             *  D00(국내배송)은 관부가세선납 개념이 없어 매핑하지 않는다.
             */
            const cusPrepayKeyByDvType = {
                D01: 'fedexCusPrepay',      // FedEx
                D16: 'fedexEcoCusPrepay',   // FedEx-E
                D11: 'upsCusPrepay',        // UPS
                D17: 'upsEcoCusPrepay',     // UPS-E
                D02: 'emsCusPrepay',        // EMS
                D15: 'emsPreCusPrepay',     // EMSP
                D04: 'dhlCusPrepay',        // DHL
                D13: 'kpackCusPrepay',      // K-Packet
                D14: 'airSCusPrepay',       // Small-Packet
                D03: 'seaCusPrepay',        // SEA
            };

            function getCusPrepay(payInfo) {
                const key = payInfo && cusPrepayKeyByDvType[payInfo.dvType];
                return key ? (Number(payInfo[key]) || 0) : 0;
            }

            // region 해당하는 열에 각 데이터 지정하여 전달

            function mapDataToExcelRows(item) {
                const productsDTO = item.type === 'orderdt'
                    ? getSafeArray(item, 'productsDTO')
                    : getSafeArray(item.packListDTO, 'productsDTO');

                // 수수료계열
                let ttEtcFee = 0;
                let etcFeeNm = '';
                let repackFee = 0;
                let agencyFee = 0;
                let removeFee = 0;
                let deliveryFee = 0;
                let comprFee = 0;

                // 할인
                let appSalePrice = 0;

                // 비용계열
                let ttEtcPrice = 0;
                let etcPriceNm = '';
                let returnFee = 0;
                let courierPay = 0;

                if (item.type === 'orderdt') {
                    /*
                     * [기타비용 누락 개선] 기타비용/기타수수료는 payType 'PT2'(기타비용)
                     * 결제건에 들어있다. 관리자가 기타비용을 여러 번 등록하면 한 주문서에
                     * PT2 결제건이 여러 건 생기는데, 기존 코드는 find() 로 '첫 1건'만
                     * 가져와서 나머지 금액이 엑셀에서 통째로 누락됐다.
                     * → PT2 전건을 대상으로 금액은 합산하고, 내용 문자열은 ' / ' 로 잇는다.
                     */
                    const pt2PayInfos = (Array.isArray(item.payInfoDTO) ? item.payInfoDTO : [item.payInfoDTO])
                        .filter(info => info?.payType === 'PT2');

                    const sumPt2 = (key) => pt2PayInfos.reduce((sum, info) => sum + (Number(info?.[key]) || 0), 0);
                    const joinPt2 = (key) => pt2PayInfos
                        .map(info => info?.[key])
                        .filter(text => text !== null && text !== undefined && String(text).trim() !== '')
                        .join(' / ');

                    ttEtcFee = sumPt2('ttEtcFee'); // 총기타수수료
                    etcFeeNm = joinPt2('etcFeeNm'); // 기타수수료명
                    repackFee = sumPt2('repackFee'); // 재포장수수료
                    agencyFee = sumPt2('agencyFee'); // 대행수수료
                    removeFee = sumPt2('removeFee'); // 제거작업 수수료
                    deliveryFee = sumPt2('deliveryFee'); // 배송대행수수료
                    comprFee = sumPt2('comprFee'); // 압축팩수수료

                    ttEtcPrice = sumPt2('ttEtcPrice'); // 총기타비용
                    etcPriceNm = joinPt2('etcPriceNm'); // 기타비용명
                    returnFee = sumPt2('returnFee'); // 국내반송료
                    courierPay = sumPt2('courierPay'); // 착불비
                }

                return productsDTO.map(product => ({
                    '여백': '',
                    '주문번호': item.type === 'orderdt' ? getSafeValue(item, 'orderNumber', '')
                        : `${getSafeValue(item.orderdtDTO, 'orderNumber', '')}-${getSafeValue(item.shipInfoDTO, 'boxNum', '')}`,
                    '주문유형': item.type === 'orderdt' ? '주문서' : '배송료',
                    '사서함번호': item.type === 'orderdt' ? 'BT' + getSafeValue(item.memberDTO, 'mbNum', '') : 'BT' + getSafeValue(item.orderdtDTO.memberDTO, 'mbNum', ''),
                    '고객명': item.type === 'orderdt' ? getSafeValue(item.memberDTO, 'userName', '') : getSafeValue(item.orderdtDTO.memberDTO, 'userName', ''),
                    '수취인명': getSafeValue(item.type === 'orderdt' ? item.recinfoDTO : item.appRecDTO, 'recname', ''),
                    '국가': `${getSafeValue(item.type === 'orderdt' ? item.recinfoDTO : item.appRecDTO, 'countryDTO', {}).countryNm || ''}[${getSafeValue(item.type === 'orderdt' ? item.recinfoDTO : item.appRecDTO, 'countryDTO', {}).countryCode || ''}]`,
                    '주문상태': item.type === 'orderdt' ? interpretOrderStatus(item.orderStatus) : interpretPayStatus(item.payStatus),
                    '서비스구분': interpretProdType(product.prodTy),
                    '개별상태': interpretProdStatus(product.prodSt),
                    '상품명': product.name,
                    '상품옵션': product.option,
                    '상품수량': product.quantity || 0,
                    '금액': product.price || 0,
                    '몰배송비': product.mallShipPrice || 0,
                    '상품수수료': product.fee || 0,
                    'URL': product.url || '',
                    '배송사': item.type === 'orderdt' ? getSafeValue(item, 'shipco', '') : (convertToShipco(item.dvType) || ''),
                    '운송장번호': item.type === 'orderdt' ? '' : getSafeValue(item.shipInfoDTO, 'outWayNum', ''),

                    // 조건 1 적용 (서로 겹치지 않게 처리 & 명칭 매핑 통일)
                    '국내반송료': item.type === 'orderdt' ? returnFee : 0,
                    '착불비': item.type === 'orderdt' ? courierPay : 0,
                    '기타비용': item.type === 'orderdt' ? ttEtcPrice : 0,
                    '기타비용내용': item.type === 'orderdt' ? etcPriceNm : '',
                    '재포장수수료': item.type === 'orderdt' ? repackFee : 0,
                    '대행수수료': item.type === 'orderdt' ? agencyFee : 0,
                    '제거작업수수료': item.type === 'orderdt' ? removeFee : 0,
                    '압축팩수수료': item.type === 'orderdt' ? comprFee : 0,
                    '배송대행수수료': item.type === 'orderdt' ? deliveryFee : 0,
                    '기타수수료': item.type === 'orderdt' ? ttEtcFee : 0,
                    '기타수수료내용': item.type === 'orderdt' ? etcFeeNm : '',

                    // 조건 2 적용 (앱할인은 음수처리)
                    '앱할인': item.type !== 'orderdt' ? (item.appSalePrice ? -Math.abs(item.appSalePrice) : 0) : 0,

                    // 배송사타입(dvType)에 해당하는 관부가세선납 값 (주문서 행은 0)
                    '관부가세선납': item.type !== 'orderdt' ? getCusPrepay(item) : 0,

                    'FedEx': item.type !== 'orderdt' ? getSafeValue(item, 'ttFedexPrice', 0) : 0,
                    'FedEx-E': item.type !== 'orderdt' ? getSafeValue(item, 'ttFedexEcoPrice', 0) : 0,
                    'UPS': item.type !== 'orderdt' ? getSafeValue(item, 'ttUpsPrice', 0) : 0,
                    'UPS-E': item.type !== 'orderdt' ? getSafeValue(item, 'ttUpsEcoPrice', 0) : 0,
                    'EMS': item.type !== 'orderdt' ? getSafeValue(item, 'ttEmsPrice', 0) : 0,
                    'EMSP': item.type !== 'orderdt' ? getSafeValue(item, 'ttEmsPrePrice', 0) : 0,
                    'Kpack': item.type !== 'orderdt' ? getSafeValue(item, 'ttKPackPrice', 0) : 0,
                    'Small-Packet': item.type !== 'orderdt' ? getSafeValue(item, 'ttAirSPrice', 0) : 0,
                    'Sea': item.type !== 'orderdt' ? getSafeValue(item, 'ttSeaPrice', 0) : 0,

                    '출고일시': item.type === 'orderdt' ? getSafeValue(item, 'shipTime', '') : item.type === 'payinfo' && (item.shipTime !== null && item.shipTime !== '') ?
                        getSafeValue(item, 'shipTime', '') : getSafeValue(item.shipInfoDTO, 'outRegTime', ''),
                }));
            }

            // endregion

            // region 헤더(1행)의 값과 스타일 지정

            const sheetConfigs = {
                'Btorage Order': {
                    name: 'Btorage Order',
                    columns: [
                        {header: '', key: '여백', width: 0.5},
                        {header: '주문번호', key: '주문번호', width: 25, style: {alignment: {horizontal: 'center'}}},
                        {header: '주문유형', key: '주문유형', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: '사서함번호', key: '사서함번호', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: '고객명', key: '고객명', width: 23, style: {alignment: {horizontal: 'center'}}},
                        {header: '수취인명', key: '수취인명', width: 23, style: {alignment: {horizontal: 'center'}}},
                        {header: '국가', key: '국가', width: 18, style: {alignment: {horizontal: 'center'}}},
                        {header: '주문상태', key: '주문상태', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '서비스구분', key: '서비스구분', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: '개별상태', key: '개별상태', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '상품명', key: '상품명', width: 30},
                        {header: '상품옵션', key: '상품옵션', width: 30},
                        {header: '상품수량', key: '상품수량', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: '금액', key: '금액', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: '몰배송비', key: '몰배송비', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: '상품수수료', key: '상품수수료', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: 'URL', key: 'URL', width: 10},
                        {header: '배송사', key: '배송사', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: '운송장번호', key: '운송장번호', width: 20, style: {alignment: {horizontal: 'center'}}},

                        // 추가된 컬럼들 반영
                        {header: '국내반송료', key: '국내반송료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '착불비', key: '착불비', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '기타비용', key: '기타비용', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '기타비용내용', key: '기타비용내용', width: 40},
                        {header: '재포장수수료', key: '재포장수수료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '대행수수료', key: '대행수수료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '제거작업수수료', key: '제거작업수수료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '압축팩수수료', key: '압축팩수수료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '배송대행수수료', key: '배송대행수수료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '기타수수료', key: '기타수수료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '기타수수료내용', key: '기타수수료내용', width: 40},

                        {header: '앱할인', key: '앱할인', width: 15, style: {alignment: {horizontal: 'center'}}},
                        // 앱할인과 FedEx 사이에 추가된 관부가세선납 컬럼
                        {header: '관부가세선납', key: '관부가세선납', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: 'FedEx', key: 'FedEx', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: 'FedEx-E', key: 'FedEx-E', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: 'UPS', key: 'UPS', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: 'UPS-E', key: 'UPS-E', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: 'EMS', key: 'EMS', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: 'EMSP', key: 'EMSP', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: 'Kpack', key: 'Kpack', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {
                            header: 'Small-Packet',
                            key: 'Small-Packet',
                            width: 13,
                            style: {alignment: {horizontal: 'center'}}
                        },
                        {header: 'Sea', key: 'Sea', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: '출고일시', key: '출고일시', width: 20, style: {alignment: {horizontal: 'center'}}},
                    ],
                }
            };

            // endregion

            const borderHeaderStyle = {
                top: {style: 'thin', color: {argb: 'FF000000'}},
                left: {style: 'thin', color: {argb: 'FF000000'}},
                bottom: {style: 'thin', color: {argb: 'FF000000'}},
                right: {style: 'thin', color: {argb: 'FF000000'}}
            };

            const applyBordersToRow = (row, border) => {
                row.eachCell({includeEmpty: true}, (cell) => {
                    cell.border = border;
                });
            };

            const createSheet = (workbook, name, columns) => {
                const sheet = workbook.addWorksheet(name);
                sheet.columns = columns;
                return sheet;
            };

            // region 주문서와 배송료를 한눈에 구분하기 위해 색상 칠

            const addRowsToSheet = async (sheet, rows, border) => {
                for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
                    const item = rows[rowIndex];
                    const row = sheet.addRow(item);

                    //주문번호 열
                    const orderNumberCell = row.getCell('주문번호');
                    const orderNumberValue = orderNumberCell.value ? orderNumberCell.value.toString() : '';
                    orderNumberCell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: {argb: orderNumberValue.includes('-') ? 'edf5fa' : 'fffae8'},
                    };

                    //주문유형 열
                    const orderTypeCell = row.getCell('주문유형');
                    orderTypeCell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: {argb: orderTypeCell.value === '주문서' ? 'fffae8' : 'edf5fa'},
                    };

                    // URL 열 하위 값들 하이퍼링크 적용
                    const urlCell = row.getCell('URL');
                    if (
                        urlCell.value &&
                        typeof urlCell.value === 'string' &&
                        (urlCell.value.startsWith('http://') || urlCell.value.startsWith('https://'))
                    ) {
                        urlCell.value = {text: urlCell.value, hyperlink: urlCell.value};
                        urlCell.font = {color: {argb: 'FF0000FF'}, underline: true, name: '맑은 고딕', size: 10};
                    }

                    row.eachCell({includeEmpty: true}, (cell) => {
                        // URL 셀은 별도 폰트 설정을 유지
                        if(cell._column.key !== 'URL'){
                            cell.font = {name: '맑은 고딕', size: 10};
                        }
                    });
                    applyBordersToRow(row, border);

                    // 대량행 생성중에도 화면이 멈추지 않도록 2048행마다 메인스레드를 양보
                    if ((rowIndex & 2047) === 2047) {
                        await yieldToBrowser();
                    }
                }
            };

            // endregion

            // region 병합 (주문서/배송료 단위로 값이 같은 컬럼을 세로병합)

            /*
             * 병합대상 컬럼.
             *  기존에는 'B','C',...,'AN' 처럼 엑셀 열문자를 하드코딩해서, 컬럼이 하나라도
             *  추가되면(이번 관부가세선납처럼) 그 뒤 열문자가 전부 밀려 엉뚱한 열이 병합됐다.
             *  → 컬럼 key 로 지정하고 열문자는 실제 시트에서 역산한다.
             *  기존 하드코딩(B~H, R~AN)과 동일한 컬럼집합 + 관부가세선납 이다.
             */
            const mergeKeys = [
                '주문번호', '주문유형', '사서함번호', '고객명', '수취인명', '국가', '주문상태',
                '배송사', '운송장번호',
                '국내반송료', '착불비', '기타비용', '기타비용내용',
                '재포장수수료', '대행수수료', '제거작업수수료', '압축팩수수료', '배송대행수수료',
                '기타수수료', '기타수수료내용',
                '앱할인', '관부가세선납',
                'FedEx', 'FedEx-E', 'UPS', 'UPS-E', 'EMS', 'EMSP', 'Kpack', 'Small-Packet', 'Sea',
            ];

            /*
             * 연속된 행들중 병합대상 컬럼값이 전부 같은 구간을 한 그룹으로 묶는다.
             *  기존에는 sheet.getCell('B3') 처럼 엑셀 주소문자열로 셀을 다시 읽어 비교했는데,
             *  행수×30컬럼×2회(3만행이면 약 180만회)의 주소파싱이 발생했다.
             *  이미 메모리에 있는 데이터 배열에서 비교하면 같은 결과를 훨씬 싸게 얻는다.
             */
            const buildMergeGroups = (rows) => {
                // 데이터에 나올 수 없는 제어문자(\u0001)를 구분자로 써서 값 경계가 섞이지 않게 한다
                const groupKeys = rows.map((row) => mergeKeys.map((key) => String(row[key] ?? '')).join('\u0001'));
                const groups = [];
                let start = 0;
                while (start < rows.length) {
                    let end = start;
                    while (end + 1 < rows.length && groupKeys[end + 1] === groupKeys[start]) {
                        end++;
                    }
                    groups.push({start, end});
                    start = end + 1;
                }
                return groups;
            };

            /*
             * ────────────────────────────────────────────────────────────────────
             * [3시간 멈춤의 원인] exceljs 의 mergeCells() 는 호출마다 '이미 등록된 전체
             * 병합목록'을 순회하며 교차검사를 한다(worksheet.js _mergeCellsInternal).
             * 병합 M건이면 비교가 M²/2 로 폭발해서, 1년치(병합 약 30만건) 다운로드가
             * 1~3시간 걸리고 브라우저가 멈췄다.
             *   실측(동일 로직 재현): 병합 3만건 60.1초 → 9만건 약 9분 → 30만건 약 100분
             *
             * 아래는 병합 루프동안 레지스트리(_merges)를 비워 그 순회를 0 으로 만들고,
             * 각 호출이 등록한 결과만 모아 마지막에 되돌려준다. 병합작업 자체는 공식 API
             * (mergeCells)가 그대로 수행하므로 결과 xlsx 는 완전히 동일하다.
             * 우리가 만드는 범위는 열/행이 서로 겹치지 않게 생성되므로 교차검사가 애초에
             * 불필요하다. 개선 후 실측: 병합 30만건 1.7초.
             *
             * exceljs 내부구조가 예상과 다른 버전이면(메이저 업그레이드 등) 자동으로
             * 기존 방식으로 폴백한다 - 느려지지만 결과는 같다.
             * ────────────────────────────────────────────────────────────────────
             */
            const mergeRangesFast = async (sheet, ranges) => {
                const registry = sheet._merges;
                const canFastPath = !!registry && typeof registry === 'object' && !Array.isArray(registry);

                if (!canFastPath) {
                    for (let i = 0; i < ranges.length; i++) {
                        sheet.mergeCells(ranges[i]);
                        if ((i & 4095) === 4095) await yieldToBrowser();
                    }
                    return;
                }

                const collected = {};
                try {
                    for (let i = 0; i < ranges.length; i++) {
                        sheet._merges = {};
                        sheet.mergeCells(ranges[i]);
                        for (const address in sheet._merges) {
                            collected[address] = sheet._merges[address];
                        }
                        if ((i & 16383) === 16383) await yieldToBrowser();
                    }
                } finally {
                    // 예외가 나더라도 레지스트리를 반드시 원복한다
                    sheet._merges = Object.assign(registry, collected);
                }
            };

            // endregion

            const transformedRows = selectedRows.flatMap(mapDataToExcelRows);

            if (transformedRows.length === 0) {
                // 선택된 건에 상품이 하나도 없어서 만들 행이 없는 경우
                window.alert("다운로드할 데이터가 없습니다");
                return;
            }

            /*
             * 파일 분할.
             *  병합그룹(= 주문서/배송료 한 건)을 반드시 한 파일 안에 유지해야 하므로
             *  그룹 단위로 담다가 최대 행수를 넘으면 다음 파일로 넘긴다.
             *  (한 그룹 자체가 최대치를 넘더라도 쪼개지 않고 그 파일에 그대로 둔다)
             */
            const allGroups = buildMergeGroups(transformedRows);
            const fileChunks = [];
            let currentChunk = null;
            allGroups.forEach((group) => {
                const groupSize = group.end - group.start + 1;
                if (!currentChunk || (currentChunk.rows.length > 0 && currentChunk.rows.length + groupSize > EXCEL_MAX_ROWS_PER_FILE)) {
                    currentChunk = {rows: [], groups: []};
                    fileChunks.push(currentChunk);
                }
                const offset = currentChunk.rows.length;
                for (let i = group.start; i <= group.end; i++) {
                    currentChunk.rows.push(transformedRows[i]);
                }
                // 1행짜리 그룹은 병합할 필요가 없다 (기존 로직의 endRow > startRow 조건과 동일)
                if (groupSize > 1) {
                    currentChunk.groups.push({start: offset, end: offset + groupSize - 1});
                }
            });

            const totalFiles = fileChunks.length;
            if (totalFiles > 1) {
                console.log(`[EXCEL] 총 ${transformedRows.length}행 → ${totalFiles}개 파일로 분할 생성합니다.`);
            }

            // 한 파일(워크북) 생성 후 즉시 다운로드
            const buildAndDownloadFile = async (chunk, fileIndex) => {
                const workbook = new excel.Workbook();
                workbook.created = new Date();
                workbook.modified = new Date();

                const sheet = createSheet(workbook, sheetConfigs['Btorage Order'].name, sheetConfigs['Btorage Order'].columns);

                //행 고정
                sheet.views = [
                    {state: 'frozen', xSplit: 5, ySplit: 2, activeCell: 'F3'}
                ];

                // region 주문유형 - 배송료 헤더를 색칠(주문서와 배송료 구분하기 좋게)

                const targetHeaders = [
                    '운송장번호',
                    '국내반송료',
                    '착불비',
                    '기타비용',
                    '기타비용내용',
                    '재포장수수료',
                    '대행수수료',
                    '제거작업수수료',
                    '압축팩수수료',
                    '배송대행수수료',
                    '기타수수료',
                    '기타수수료내용',
                    '앱할인',
                    '관부가세선납',
                    'FedEx',
                    'FedEx-E',
                    'UPS',
                    'UPS-E',
                    'EMS',
                    'EMSP',
                    'Kpack',
                    'Small-Packet',
                    'Sea',
                    '출고일시'
                ];

                const headerRow = sheet.getRow(1);
                headerRow.eachCell((cell) => {
                    cell.alignment = {horizontal: 'center'};
                    cell.font = {bold: true, name: '맑은 고딕', size: 11};

                    if (targetHeaders.includes(cell.value)) {
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: {argb: 'edf5fa'}
                        };
                    }
                });

                // endregion

                const columnMap = {};
                sheet.columns.forEach((col) => {
                    if (col.key && col.letter) {
                        columnMap[col.key] = col.letter;
                    }
                });

                // 데이터 행 범위 설정 (데이터는 3행부터 시작)
                const dataStartRow = 3;
                const dataEndRow = dataStartRow + chunk.rows.length - 1;

                // region 지정된 열 하위 행의 값들 합산

                const sumKeys = ['상품수량', '금액', '몰배송비', '상품수수료', '국내반송료', '착불비', '기타비용', '재포장수수료', '대행수수료', '제거작업수수료', '압축팩수수료', '배송대행수수료', '기타수수료', '앱할인', '관부가세선납', 'FedEx', 'FedEx-E', 'UPS', 'UPS-E', 'EMS', 'EMSP', 'Kpack', 'Small-Packet', 'Sea'];

                const summaryRow = {};
                sheetConfigs['Btorage Order'].columns.forEach(col => {
                    summaryRow[col.key] = '';
                });

                // 첫열에 텍스트 표시
                summaryRow['주문번호'] = '합계';

                // 합계 대상 열에는 수식 지정
                sumKeys.forEach((key) => {
                    const colLetter = columnMap[key];
                    if (colLetter) {
                        summaryRow[key] = {formula: `SUM(${colLetter}${dataStartRow}:${colLetter}${dataEndRow})`};
                    }
                });

                sheet.spliceRows(2, 0, summaryRow);

                const summaryExcelRow = sheet.getRow(2);
                // 주문번호(B)부터 마지막 직전 컬럼(Sea)까지 스타일 적용.
                // 기존에는 40 으로 하드코딩되어 있었는데 컬럼이 추가되면 범위가 어긋나므로
                // 전체 컬럼수에서 역산한다(마지막 '출고일시' 열은 기존과 동일하게 제외).
                const summaryStyleEndCol = sheetConfigs['Btorage Order'].columns.length - 1;
                for (let col = 2; col <= summaryStyleEndCol; col++) {
                    const cell = summaryExcelRow.getCell(col);
                    cell.alignment = {horizontal: 'right'};
                    cell.font = {name: '맑은 고딕', size: 10, bold: true, color: {argb: 'FFFF0000'}};
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: {argb: 'f1f1f1'}
                    };

                    // 숫자인 경우 통화단위 표시
                    if (
                        (typeof cell.value === 'number') ||
                        (cell.value && typeof cell.value === 'object' && cell.value.formula)
                    ) {
                        cell.numFmt = '#,##0';
                    }
                }

                await addRowsToSheet(sheet, chunk.rows, borderHeaderStyle);

                sheet.eachRow({includeEmpty: true}, (row) => {
                    for (let col = 2; col <= 5; col++) { //B~E열에 해당하는 값들 Bold
                        const cell = row.getCell(col);
                        cell.font = {...(cell.font || {}), bold: true};
                    }
                });

                // region 병합 실행 (미리 계산해둔 그룹경계 → 실제 셀범위)

                const mergeColumnLetters = mergeKeys
                    .map((key) => columnMap[key])
                    .filter(Boolean);

                const mergeRanges = [];
                chunk.groups.forEach((group) => {
                    const topRow = dataStartRow + group.start;
                    const bottomRow = dataStartRow + group.end;
                    mergeColumnLetters.forEach((letter) => {
                        mergeRanges.push(`${letter}${topRow}:${letter}${bottomRow}`);
                    });
                });

                await mergeRangesFast(sheet, mergeRanges);

                // 병합된 대표셀 가운데정렬 (기존 mergeCellsByCondition 동작과 동일)
                chunk.groups.forEach((group) => {
                    const topRow = dataStartRow + group.start;
                    mergeColumnLetters.forEach((letter) => {
                        sheet.getCell(`${letter}${topRow}`).alignment = {vertical: 'middle', horizontal: 'center'};
                    });
                });

                // endregion

                const fileName = totalFiles > 1
                    ? `[BT]OrderList_${DateViewValue}_${fileIndex + 1}of${totalFiles}.xlsx`
                    : `[BT]OrderList_${DateViewValue}.xlsx`;

                const data = await workbook.xlsx.writeBuffer();
                const blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = fileName;
                anchor.click();
                // 대용량 blob 을 즉시 해제하면 브라우저가 저장을 끝내기 전에 끊길 수 있어 잠시 뒤 해제한다
                setTimeout(() => window.URL.revokeObjectURL(url), 60000);
                // workbook/sheet/data 는 이 함수 지역변수라 반환 시점에 자동으로 회수대상이 된다
            };

            for (let fileIndex = 0; fileIndex < totalFiles; fileIndex++) {
                // 청크를 다 쓰면 참조를 끊어서 다음 파일 생성 중 GC 가 회수할 수 있게 한다
                const chunk = fileChunks[fileIndex];
                fileChunks[fileIndex] = null;
                await buildAndDownloadFile(chunk, fileIndex);
                // 다음 파일을 만들기 전에 앞 파일의 메모리를 GC 가 회수할 틈을 준다
                await yieldToBrowser();
            }

        } catch (error) {
            console.error("엑셀[주문서] 브라우저 생성 중 오류 발생:", error);
        }
        // 로딩상태는 호출부(excelDown)에서 관리한다
    };

    // 배송 세관신고 공통인보이스
    const customExcelDown = async () => {
        try {
            const allData = [...filteredList];
            // 주문서/배송료의 번호가 겹칠 수 있어서 '유형:번호' 키로 매칭한다(Set 조회)
            const selectedRows = allData.filter((item) => checkedKeySet.has(getRowCheckKey(item)));

            if (selectedRows.length === 0) {
                window.alert("배송료 데이터를 선택해주세요");
                return;
            }

            if (selectedRows.some(item => item.type !== "payinfo")) {
                window.alert("배송료 데이터만 선택해주세요");
                return;
            }

            const excel = require('exceljs');

            for (let i = 0; i < selectedRows.length; i++) {
                const rowData = selectedRows[i];
                const workbook = new excel.Workbook();
                workbook.created = new Date();
                workbook.modified = new Date();

                const worksheet = workbook.addWorksheet('Invoice');

                //region dataSet

                // ✅ [수정 1] rowData.type 체크 제거 (무조건 payinfo 타입으로 간주)
                let userName = rowData.orderdtDTO.memberDTO.userName || '';

                // ✅ [수정 1] rowData.type 체크 제거
                const orderNumber = rowData.orderdtDTO?.orderNumber || '';
                const boxNum = rowData.shipInfoDTO?.boxNum || '0';
                let orderNo = `${orderNumber}-${boxNum}`;

                // endregion

                // region 열너비 & 행높이 (기존과 동일)
                //열너비
                worksheet.getColumn('A').width = 0.8;
                worksheet.getColumn('B').width = 13;
                worksheet.getColumn('C').width = 13;
                worksheet.getColumn('D').width = 13;
                worksheet.getColumn('E').width = 25;
                worksheet.getColumn('F').width = 23;
                worksheet.getColumn('G').width = 11;
                worksheet.getColumn('H').width = 15;
                worksheet.getColumn('I').width = 15;

                //행높이
                worksheet.getRow(1).height = 4;
                worksheet.getRow(2).height = 29;
                worksheet.getRow(3).height = 4;
                worksheet.getRow(4).height = 29;
                worksheet.getRow(5).height = 4;

                for (let row = 6; row <= 13; row++) {
                    worksheet.getRow(row).height = 18;
                }
                worksheet.getRow(11).height = 10;
                worksheet.getRow(20).height = 4;
                worksheet.getRow(21).height = 32;
                for (let row = 22; row <= 56; row++) {
                    worksheet.getRow(row).height = 18;
                }
                worksheet.getRow(57).height = 20;

                // endregion

                // region 엑셀내용 (스타일 및 정적 데이터)

                const thinBorder = {style: 'thin'};

                worksheet.mergeCells('B2:I2');
                const titleCell = worksheet.getCell('B2');
                titleCell.value = 'INVOICE';
                titleCell.alignment = {vertical: 'middle', horizontal: 'center'};
                titleCell.font = {name: 'Arial', size: 18, bold: true};
                const borderStyle = {style: 'medium'};
                worksheet.getCell('B2').border = {
                    top: borderStyle,
                    bottom: borderStyle,
                };

                worksheet.mergeCells('B4:C4');
                const lcWaybillCell = worksheet.getCell('B4');
                lcWaybillCell.value = 'L/C No. and Waybill No.';
                lcWaybillCell.alignment = {vertical: 'middle', horizontal: 'right'};
                lcWaybillCell.font = {name: 'Arial', size: 12, bold: true};

                worksheet.mergeCells('D4:E4');
                const waybillValueCell = worksheet.getCell('D4');

                // ✅ [수정 1] rowData.type 체크 제거
                waybillValueCell.value = rowData.shipInfoDTO.outWayNum || ''; // outWayNum은 payinfo에만 있음

                waybillValueCell.alignment = {vertical: 'middle', horizontal: 'center'};
                waybillValueCell.font = {name: 'Arial', size: 13, bold: true, italic: true};

                worksheet.mergeCells('F4:H4');
                const exportDateTitleCell = worksheet.getCell('F4');
                exportDateTitleCell.value = 'Date of Exportation.';
                exportDateTitleCell.alignment = {vertical: 'middle', horizontal: 'right'};
                exportDateTitleCell.font = {name: 'Arial', size: 12, bold: true};

                const today = new Date();
                const monthShort = today.toLocaleString('en-US', {month: 'short'});
                const day = String(today.getDate()).padStart(2, '0');
                const year = today.getFullYear();
                const formattedToday = `${monthShort}-${day}-${year}`;
                const exportDateValueCell = worksheet.getCell('I4');
                exportDateValueCell.value = formattedToday;
                exportDateValueCell.alignment = {vertical: 'middle', horizontal: 'center'};
                exportDateValueCell.font = {name: 'Arial', size: 12, bold: true};

                worksheet.mergeCells('B6:E6');
                const shipperCell = worksheet.getCell('B6');
                shipperCell.value = 'Shipper / Exporter';
                shipperCell.alignment = {vertical: 'middle', horizontal: 'center'};
                shipperCell.font = {name: 'Arial', size: 12, bold: true};

                worksheet.mergeCells('F6:I6');
                const consigneeCell = worksheet.getCell('F6');
                consigneeCell.value = 'Consignee';
                consigneeCell.alignment = {vertical: 'middle', horizontal: 'center'};
                consigneeCell.font = {name: 'Arial', size: 12, bold: true};

                for (let row = 7; row <= 13; row++) {
                    worksheet.mergeCells(`B${row}:E${row}`);
                }

                for (let row = 7; row <= 19; row++) {
                    worksheet.getCell(`F${row}`).border = {
                        left: thinBorder,
                    };
                }

                worksheet.getCell('E6').border = {right: thinBorder,};

                for (let col of ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']) {
                    worksheet.getCell(`${col}5`).border = {bottom: thinBorder};
                    worksheet.getCell(`${col}14`).border = {top: thinBorder};
                    worksheet.getCell(`${col}57`).border = {top: thinBorder, bottom: thinBorder};
                }

                const skyBlue = {argb: 'FFE5EEFF'};
                const lightGray = {argb: 'FFF0F0F0'};

                for (let col of ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']) {
                    worksheet.getCell(`${col}6`).fill = {type: 'pattern', pattern: 'solid', fgColor: skyBlue};
                }

                for (let row = 14; row <= 19; row++) {
                    for (let col of ['B', 'C', 'D']) {
                        worksheet.getCell(`${col}${row}`).fill = {type: 'pattern', pattern: 'solid', fgColor: skyBlue};
                    }
                }

                for (let col of ['F', 'G', 'H', 'I']) {
                    worksheet.getCell(`${col}14`).fill = {type: 'pattern', pattern: 'solid', fgColor: skyBlue};
                }

                for (let col of ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']) {
                    worksheet.getCell(`${col}21`).fill = {type: 'pattern', pattern: 'solid', fgColor: lightGray};
                }

                // endregion

                // region 발송인 (기존과 동일 - 정적 데이터)
                worksheet.getCell('B7').value = 'IMEUNWOO(individual)';
                worksheet.getCell('B7').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B7').font = {name: 'Arial', size: 11};

                worksheet.getCell('B8').value = '32-15, Yeongok-gil 42beon-gil, Gonjiam-eup,';
                worksheet.getCell('B8').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B8').font = {name: 'Arial', size: 11};

                worksheet.getCell('B9').value = 'Gwangji-si, Gyeonggi-do (zipcode 12722)';
                worksheet.getCell('B9').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B9').font = {name: 'Arial', size: 11};

                worksheet.getCell('B10').value = 'Tel: 82-10-3338-9354';
                worksheet.getCell('B10').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B10').font = {name: 'Arial', size: 11};

                worksheet.getCell('B12').value = '(empty)';
                worksheet.getCell('B12').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B12').font = {name: 'Arial', size: 11};

                worksheet.getCell('B13').value = '(empty)';
                worksheet.getCell('B13').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B13').font = {name: 'Arial', size: 11};
                // endregion

                // region 수취인

                // ✅ [수정 1] rowData.type 체크 제거
                const receiver = rowData.appRecDTO; // payinfo 타입이므로 appRecDTO 사용

                const fullAddress =
                    (receiver?.address1 || '') +
                    (receiver?.address2 || '') +
                    (receiver?.address3 || '');

                const cityZipcode =
                    (receiver?.city || '') +
                    ' (zipcode ' + (receiver?.zipcode || '') + ')';

                worksheet.mergeCells('F7:I13');
                const mergedCell = worksheet.getCell('F7');

                mergedCell.value =
                    (receiver?.recname || '') + '\n' +
                    fullAddress + '\n' +
                    cityZipcode + '\n\n' +
                    'Tel: ' + (receiver?.telnum || '');

                mergedCell.alignment = {vertical: 'top', horizontal: 'left', wrapText: true};
                mergedCell.font = {name: 'Arial', size: 11};

                //수취인과 다를경우 직접입력
                worksheet.mergeCells('F15:I19');
                const mergedBuyerCell = worksheet.getCell('F15');
                mergedBuyerCell.value = '';
                mergedBuyerCell.alignment = {vertical: 'middle', horizontal: 'left'};
                mergedBuyerCell.font = {name: 'Arial', size: 11};

                // endregion

                // region 기타정보
                worksheet.mergeCells('B14:D15');
                const countryExportCell = worksheet.getCell('B14');
                countryExportCell.value = 'Country of Export';
                countryExportCell.alignment = {vertical: 'middle', horizontal: 'center'};
                countryExportCell.font = {name: 'Arial', size: 11, bold: true};
                countryExportCell.border = {top: thinBorder};

                worksheet.mergeCells('F14:I14');
                const buyerCell = worksheet.getCell('F14');
                buyerCell.value = 'Buyer (if other than consignee)';
                buyerCell.alignment = {vertical: 'middle', horizontal: 'center'};
                buyerCell.font = {name: 'Arial', size: 11, bold: true};

                worksheet.mergeCells('B16:D17');
                const reasonExportCell = worksheet.getCell('B16');
                reasonExportCell.value = 'Reason for Export';
                reasonExportCell.alignment = {vertical: 'middle', horizontal: 'center'};
                reasonExportCell.font = {name: 'Arial', size: 11, bold: true};
                reasonExportCell.border = {bottom: thinBorder, top: thinBorder};

                worksheet.mergeCells('E14:E15');
                const koreaCell = worksheet.getCell('E14');
                koreaCell.value = 'Republic of Korea [KR]';
                koreaCell.alignment = {vertical: 'middle', horizontal: 'center'};
                koreaCell.font = {name: 'Arial', size: 11};
                koreaCell.border = {bottom: thinBorder};
                koreaCell.border = {top: thinBorder};

                worksheet.mergeCells('E16:E17');
                const giftCell = worksheet.getCell('E16');
                giftCell.value = 'e.g.personal gift';
                giftCell.alignment = {vertical: 'middle', horizontal: 'center'};
                giftCell.font = {name: 'Arial', size: 11};
                giftCell.border = {bottom: thinBorder, top: thinBorder};

                worksheet.mergeCells('B18:D19');
                const destinationTitleCell = worksheet.getCell('B18');
                destinationTitleCell.value = 'Country of Ultimate Destination';
                destinationTitleCell.alignment = {vertical: 'middle', horizontal: 'center'};
                destinationTitleCell.font = {name: 'Arial', size: 11, bold: true};

                worksheet.mergeCells('E18:E19');
                const destinationCountryCell = worksheet.getCell('E18');

                // ✅ [수정 1] rowData.type 체크 제거
                destinationCountryCell.value = (rowData.appRecDTO.countryDTO.countryEngNm || '') +
                    ' [' + (rowData.appRecDTO.countryDTO.countryCode || '') + ']';
                destinationCountryCell.alignment = {vertical: 'middle', horizontal: 'center'};
                destinationCountryCell.font = {name: 'Arial', size: 10};

                // endregion

                // region 상품 목록 헤더 (기존과 동일)
                worksheet.mergeCells('B20:I20');
                const GbnCell = worksheet.getCell('B20');
                GbnCell.border = {bottom: thinBorder, top: thinBorder};

                worksheet.getCell('B21').value = 'Country of Origin';
                worksheet.getCell('B21').alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                worksheet.getCell('B21').font = {name: 'Arial', size: 11, bold: true};

                worksheet.getCell('C21').value = 'Pkgs / Type';
                worksheet.getCell('C21').alignment = {vertical: 'middle', horizontal: 'center'};
                worksheet.getCell('C21').font = {name: 'Arial', size: 11, bold: true};

                worksheet.mergeCells('D21:F21');
                worksheet.getCell('D21').value = 'Description of Goods';
                worksheet.getCell('D21').alignment = {vertical: 'middle', horizontal: 'center'};
                worksheet.getCell('D21').font = {name: 'Arial', size: 11, bold: true};

                worksheet.getCell('G21').value = 'Qty / Unit';
                worksheet.getCell('G21').alignment = {vertical: 'middle', horizontal: 'center'};
                worksheet.getCell('G21').font = {name: 'Arial', size: 11, bold: true};

                worksheet.getCell('H21').value = 'Qty / Unit Price(USD)';
                worksheet.getCell('H21').alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                worksheet.getCell('H21').font = {name: 'Arial', size: 11, bold: true};

                worksheet.getCell('I21').value = 'Total Amount(USD)';
                worksheet.getCell('I21').alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                worksheet.getCell('I21').font = {name: 'Arial', size: 11, bold: true};

                for (let row = 22; row <= 56; row++) {
                    worksheet.mergeCells(`D${row}:F${row}`);
                }

                for (let row = 21; row <= 56; row++) {
                    for (let col of ['B', 'C', 'D', 'G', 'H']) {
                        worksheet.getCell(`${col}${row}`).border = {
                            right: thinBorder,
                        };
                    }
                }

                worksheet.getCell('B22').value = 'KR';
                worksheet.getCell('B22').alignment = {vertical: 'middle', horizontal: 'center'};
                worksheet.getCell('B22').font = {name: 'Arial', size: 11, bold: true};

                worksheet.getCell('C22').value = '1 / cartons';
                worksheet.getCell('C22').alignment = {vertical: 'middle', horizontal: 'center'};
                worksheet.getCell('C22').font = {name: 'Arial', size: 11, bold: true};
                // endregion

                // region 상품 목록 매핑 (✅ [수정 2])
                const startRow = 22;

                // ✅ [수정 2] packListDTO 대신 customsDTO.customItemsDTO 사용
                let customsItems = rowData.customsDTO.customItemsDTO || [];

                // ✅ [수정 2] fetchFedexData 로직(Case 2)처럼, 자식 아이템이 없으면 부모 customsDTO를 사용
                if (customsItems.length === 0 && rowData.customsDTO.custContent) {
                    customsItems = [{
                        content: rowData.customsDTO.custContent,
                        quantity: rowData.customsDTO.custQty,
                        price: rowData.customsDTO.custPrice, // fetchFedexData Case 2 기준: Total Price (USD)
                        ttPrice: rowData.customsDTO.custPrice // fetchFedexData Case 2 기준: Total Price (USD)
                    }];
                }

                // ✅ [수정 2] customsItems를 순회하며 데이터 매핑
                customsItems.forEach((item, index) => {
                    const row = startRow + index;
                    if (row > 56) return; // 최대 35개 항목

                    const quantity = Number(item.quantity) || 0;

                    // fetchFedexData 로직(Case 1) 기준:
                    // item.price (Total) / quantity = Unit Price
                    // item.ttPrice = Total Price
                    // (price와 ttPrice가 동일한 Total Price일 가능성이 높음)
                    const totalUSD = Number(item.ttPrice) || Number(item.price) || 0;
                    const unitPriceUSD = (quantity > 0) ? (totalUSD / quantity) : 0;

                    // D열 (Description of Goods)
                    worksheet.getCell(`D${row}`).value = item.content || ''; // 'name' 대신 'content'
                    worksheet.getCell(`D${row}`).alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                    worksheet.getCell(`D${row}`).font = {name: 'Arial', size: 11};

                    // G열 (Qty / Unit)
                    worksheet.getCell(`G${row}`).value = quantity.toLocaleString();
                    worksheet.getCell(`G${row}`).alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                    worksheet.getCell(`G${row}`).font = {name: 'Arial', size: 11};

                    // H열 (Unit Price) - USD 기준
                    worksheet.getCell(`H${row}`).value = unitPriceUSD;
                    worksheet.getCell(`H${row}`).alignment = {vertical: 'middle', horizontal: 'right', wrapText: true};
                    worksheet.getCell(`H${row}`).font = {name: 'Arial', size: 11};
                    worksheet.getCell(`H${row}`).numFmt = '"$"#,##0.00';

                    // I열 (Total Amount) - USD 기준
                    worksheet.getCell(`I${row}`).value = totalUSD;
                    worksheet.getCell(`I${row}`).alignment = {vertical: 'middle', horizontal: 'right', wrapText: true};
                    worksheet.getCell(`I${row}`).font = {name: 'Arial', size: 11};
                    worksheet.getCell(`I${row}`).numFmt = '"$"#,##0.00';
                });

                // ✅ [수정 2] totalQty 계산 기준 변경
                const totalQty = customsItems.reduce((sum, item) => {
                    return sum + (Number(item.quantity) || 0);
                }, 0);

                worksheet.getCell('G57').value = `${totalQty} EA`;
                worksheet.getCell('G57').alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                worksheet.getCell('G57').font = {name: 'Arial', size: 12, bold: true};

                worksheet.getCell('I57').value = {formula: 'SUM(I22:I56)'};
                worksheet.getCell('I57').alignment = {vertical: 'middle', horizontal: 'right', wrapText: true};
                worksheet.getCell('I57').font = {name: 'Arial', size: 12, bold: true};
                worksheet.getCell('I57').numFmt = '"$"#,##0.00';

                const totalCell = worksheet.getCell('F57');
                totalCell.value = 'Total';
                totalCell.alignment = {vertical: 'middle', horizontal: 'right'};
                totalCell.font = {name: 'Arial', size: 12, bold: true};

                worksheet.mergeCells('F60:F61');

                const signedByCell = worksheet.getCell('F60');
                signedByCell.value = 'Signed By.';
                signedByCell.alignment = {vertical: 'bottom', horizontal: 'right'};
                signedByCell.font = {name: 'Arial', size: 11};

                const signatureNameCell = worksheet.getCell('I61');
                signatureNameCell.value = 'IMEUNWOO';
                signatureNameCell.alignment = {vertical: 'bottom', horizontal: 'center'};
                signatureNameCell.font = {name: 'Arial', size: 12, bold: true};

                for (let col of ['G', 'H', 'I']) {
                    worksheet.getCell(`${col}61`).border = {
                        bottom: thinBorder,
                    };
                }
                // endregion

                // region 다운로드 (기존과 동일)
                worksheet.pageSetup.printArea = 'A1:I61';

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });

                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = `[${userName}님]인보이스_${orderNo}_${DateViewValue}.xlsx`;
                anchor.click();
                window.URL.revokeObjectURL(url);
                // endregion
            }
        } catch (error) {
            console.error("세관신고 인보이스 다운로드 중 오류 발생:", error);
        } finally {
            clearAllChecked();
        }
    };

    const [errorInvoiceMsg, setErrorInvoiceMsg] = useState('');

    const invoiceDown = async () => {
        try {
            const allData = [...filteredList];
            // 주문서/배송료의 번호가 겹칠 수 있어서 '유형:번호' 키로 매칭한다(Set 조회)
            const selectedRows = allData.filter((item) => checkedKeySet.has(getRowCheckKey(item)));

            // 선택건이 수만 건일 때 배열 전체를 콘솔에 넘기면 브라우저가 계속 참조해
            // 메모리를 잡아두므로 건수만 남긴다
            console.log("다운된 데이터 건수 : ", selectedRows.length)

            if (selectedRows.length === 0) {
                setErrorInvoiceMsg('데이터를 선택해주세요');
                setTimeout(() => setErrorInvoiceMsg(''), 1500);
                return;
            }

            const excel = require('exceljs');

            for (let i = 0; i < selectedRows.length; i++) {
                const rowData = selectedRows[i];
                const workbook = new excel.Workbook();
                // console.log('rowData:', rowData);
                workbook.created = new Date();
                workbook.modified = new Date();

                const worksheet = workbook.addWorksheet('Invoice');

                //region dataSet

                let userName = '';

                if (rowData.type === 'orderdt') {
                    userName = rowData.memberDTO.userName || '';
                } else if (rowData.type === 'payinfo') {
                    userName = rowData.orderdtDTO.memberDTO.userName || '';
                } else {
                    userName = '';
                }

                let orderNo = '';

                if (rowData.type === 'orderdt') {
                    orderNo = rowData.orderNumber || '';
                } else if (rowData.type === 'payinfo') {
                    const orderNumber = rowData.orderdtDTO?.orderNumber || '';
                    const boxNum = rowData.shipInfoDTO?.boxNum || '0';
                    orderNo = `${orderNumber}-${boxNum}`;
                } else {
                    orderNo = '';
                }

                // endregion

                // region 열너비 & 행높이

                //열너비
                worksheet.getColumn('A').width = 0.8;
                worksheet.getColumn('B').width = 13;
                worksheet.getColumn('C').width = 13;
                worksheet.getColumn('D').width = 13;
                worksheet.getColumn('E').width = 25;
                worksheet.getColumn('F').width = 23;
                worksheet.getColumn('G').width = 11;
                worksheet.getColumn('H').width = 15;
                worksheet.getColumn('I').width = 15;

                //행높이
                worksheet.getRow(1).height = 4;
                worksheet.getRow(2).height = 29;
                worksheet.getRow(3).height = 4;
                worksheet.getRow(4).height = 29;
                worksheet.getRow(5).height = 4;

                for (let row = 6; row <= 13; row++) {
                    worksheet.getRow(row).height = 18;
                }
                worksheet.getRow(11).height = 10;
                worksheet.getRow(20).height = 4;
                worksheet.getRow(21).height = 32;
                for (let row = 22; row <= 56; row++) {
                    worksheet.getRow(row).height = 18;
                }
                worksheet.getRow(57).height = 20;

                // endregion

                // region 엑셀내용

                const thinBorder = {style: 'thin'};

                worksheet.mergeCells('B2:I2');
                const titleCell = worksheet.getCell('B2');
                titleCell.value = 'INVOICE';
                titleCell.alignment = {vertical: 'middle', horizontal: 'center'};
                titleCell.font = {name: 'Arial', size: 18, bold: true};
                const borderStyle = {style: 'medium'};
                worksheet.getCell('B2').border = {
                    top: borderStyle,
                    bottom: borderStyle,
                };

                worksheet.mergeCells('B4:C4');
                const lcWaybillCell = worksheet.getCell('B4');
                lcWaybillCell.value = 'L/C No. and Waybill No.';
                lcWaybillCell.alignment = {vertical: 'middle', horizontal: 'right'};
                lcWaybillCell.font = {name: 'Arial', size: 12, bold: true};

                worksheet.mergeCells('D4:E4');
                const waybillValueCell = worksheet.getCell('D4');
                if (rowData.type === 'payinfo') {
                    waybillValueCell.value = rowData.shipInfoDTO.outWayNum;
                } else {
                    waybillValueCell.value = '';
                }
                waybillValueCell.alignment = {vertical: 'middle', horizontal: 'center'};
                waybillValueCell.font = {name: 'Arial', size: 13, bold: true, italic: true};

                worksheet.mergeCells('F4:H4');
                const exportDateTitleCell = worksheet.getCell('F4');
                exportDateTitleCell.value = 'Date of Exportation.';
                exportDateTitleCell.alignment = {vertical: 'middle', horizontal: 'right'};
                exportDateTitleCell.font = {name: 'Arial', size: 12, bold: true};

                const today = new Date();
                const monthShort = today.toLocaleString('en-US', {month: 'short'}); // 예: Sep
                const day = String(today.getDate()).padStart(2, '0');                 // 예: 06
                const year = today.getFullYear();                                     // 예: 2025
                const formattedToday = `${monthShort}-${day}-${year}`;               // 예: Sep-06-2025
                const exportDateValueCell = worksheet.getCell('I4');
                exportDateValueCell.value = formattedToday;
                exportDateValueCell.alignment = {vertical: 'middle', horizontal: 'center'};
                exportDateValueCell.font = {name: 'Arial', size: 12, bold: true};

                worksheet.mergeCells('B6:E6');
                const shipperCell = worksheet.getCell('B6');
                shipperCell.value = 'Shipper / Exporter';
                shipperCell.alignment = {vertical: 'middle', horizontal: 'center'};
                shipperCell.font = {name: 'Arial', size: 12, bold: true};

                worksheet.mergeCells('F6:I6');
                const consigneeCell = worksheet.getCell('F6');
                consigneeCell.value = 'Consignee';
                consigneeCell.alignment = {vertical: 'middle', horizontal: 'center'};
                consigneeCell.font = {name: 'Arial', size: 12, bold: true};

                for (let row = 7; row <= 13; row++) {
                    worksheet.mergeCells(`B${row}:E${row}`);
                }

                for (let row = 7; row <= 19; row++) {
                    worksheet.getCell(`F${row}`).border = {
                        left: thinBorder,
                    };
                }

                worksheet.getCell('E6').border = {right: thinBorder,};

                for (let col of ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']) {
                    worksheet.getCell(`${col}5`).border = {bottom: thinBorder};
                    worksheet.getCell(`${col}14`).border = {top: thinBorder};
                    worksheet.getCell(`${col}57`).border = {top: thinBorder, bottom: thinBorder};
                }

                const skyBlue = {argb: 'FFE5EEFF'};
                const lightGray = {argb: 'FFF0F0F0'};

                for (let col of ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']) {
                    worksheet.getCell(`${col}6`).fill = {type: 'pattern', pattern: 'solid', fgColor: skyBlue};
                }

                for (let row = 14; row <= 19; row++) {
                    for (let col of ['B', 'C', 'D']) {
                        worksheet.getCell(`${col}${row}`).fill = {type: 'pattern', pattern: 'solid', fgColor: skyBlue};
                    }
                }

                for (let col of ['F', 'G', 'H', 'I']) {
                    worksheet.getCell(`${col}14`).fill = {type: 'pattern', pattern: 'solid', fgColor: skyBlue};
                }

                for (let col of ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']) {
                    worksheet.getCell(`${col}21`).fill = {type: 'pattern', pattern: 'solid', fgColor: lightGray};
                }


                // region 발송인

                worksheet.getCell('B7').value = 'IMEUNWOO(individual)';
                worksheet.getCell('B7').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B7').font = {name: 'Arial', size: 11};

                worksheet.getCell('B8').value = '32-15, Yeongok-gil 42beon-gil, Gonjiam-eup,';
                worksheet.getCell('B8').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B8').font = {name: 'Arial', size: 11};

                worksheet.getCell('B9').value = 'Gwangji-si, Gyeonggi-do (zipcode 12722)';
                worksheet.getCell('B9').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B9').font = {name: 'Arial', size: 11};

                worksheet.getCell('B10').value = 'Tel: 82-10-3338-9354';
                worksheet.getCell('B10').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B10').font = {name: 'Arial', size: 11};

                worksheet.getCell('B12').value = '(empty)';
                worksheet.getCell('B12').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B12').font = {name: 'Arial', size: 11};

                worksheet.getCell('B13').value = '(empty)';
                worksheet.getCell('B13').alignment = {vertical: 'middle', horizontal: 'left'};
                worksheet.getCell('B13').font = {name: 'Arial', size: 11};

                // endregion

                // region 수취인

                const receiver = rowData.type === 'payinfo'
                    ? rowData.appRecDTO
                    : rowData.recinfoDTO;

                const fullAddress =
                    (receiver?.address1 || '') +
                    (receiver?.address2 || '') +
                    (receiver?.address3 || '');

                const cityZipcode =
                    (receiver?.city || '') +
                    ' (zipcode ' + (receiver?.zipcode || '') + ')';

                worksheet.mergeCells('F7:I13');
                const mergedCell = worksheet.getCell('F7');

                mergedCell.value =
                    (receiver?.recname || '') + '\n' +
                    fullAddress + '\n' +
                    cityZipcode + '\n\n' +
                    'Tel: ' + (receiver?.telnum || '');

                mergedCell.alignment = {vertical: 'top', horizontal: 'left', wrapText: true};
                mergedCell.font = {name: 'Arial', size: 11};

                //수취인과 다를경우 직접입력
                worksheet.mergeCells('F15:I19');
                const mergedBuyerCell = worksheet.getCell('F15');
                mergedBuyerCell.value = '';
                mergedBuyerCell.alignment = {vertical: 'middle', horizontal: 'left'};
                mergedBuyerCell.font = {name: 'Arial', size: 11};

                // endregion

                // region 기타정보

                worksheet.mergeCells('B14:D15');
                const countryExportCell = worksheet.getCell('B14');
                countryExportCell.value = 'Country of Export';
                countryExportCell.alignment = {vertical: 'middle', horizontal: 'center'};
                countryExportCell.font = {name: 'Arial', size: 11, bold: true};
                countryExportCell.border = {top: thinBorder};

                worksheet.mergeCells('F14:I14');
                const buyerCell = worksheet.getCell('F14');
                buyerCell.value = 'Buyer (if other than consignee)';
                buyerCell.alignment = {vertical: 'middle', horizontal: 'center'};
                buyerCell.font = {name: 'Arial', size: 11, bold: true};

                worksheet.mergeCells('B16:D17');
                const reasonExportCell = worksheet.getCell('B16');
                reasonExportCell.value = 'Reason for Export';
                reasonExportCell.alignment = {vertical: 'middle', horizontal: 'center'};
                reasonExportCell.font = {name: 'Arial', size: 11, bold: true};
                reasonExportCell.border = {bottom: thinBorder, top: thinBorder};

                worksheet.mergeCells('E14:E15');
                const koreaCell = worksheet.getCell('E14');
                koreaCell.value = 'Republic of Korea [KR]';
                koreaCell.alignment = {vertical: 'middle', horizontal: 'center'};
                koreaCell.font = {name: 'Arial', size: 11};
                koreaCell.border = {bottom: thinBorder};
                koreaCell.border = {top: thinBorder};

                worksheet.mergeCells('E16:E17');
                const giftCell = worksheet.getCell('E16');
                giftCell.value = 'e.g.personal gift';
                giftCell.alignment = {vertical: 'middle', horizontal: 'center'};
                giftCell.font = {name: 'Arial', size: 11};
                giftCell.border = {bottom: thinBorder, top: thinBorder};

                worksheet.mergeCells('B18:D19');
                const destinationTitleCell = worksheet.getCell('B18');
                destinationTitleCell.value = 'Country of Ultimate Destination';
                destinationTitleCell.alignment = {vertical: 'middle', horizontal: 'center'};
                destinationTitleCell.font = {name: 'Arial', size: 11, bold: true};

                worksheet.mergeCells('E18:E19');
                const destinationCountryCell = worksheet.getCell('E18');
                let destinationCountry = '';
                if (rowData.type === 'orderdt') {
                    destinationCountry =
                        (rowData.recinfoDTO.countryDTO.countryEngNm || '') +
                        ' [' + (rowData.recinfoDTO.countryDTO.countryCode || '') + ']';
                } else if (rowData.type === 'payinfo') {
                    destinationCountry =
                        (rowData.appRecDTO.countryDTO.countryEngNm || '') +
                        ' [' + (rowData.appRecDTO.countryDTO.countryCode || '') + ']';
                }
                destinationCountryCell.value = destinationCountry;
                destinationCountryCell.alignment = {vertical: 'middle', horizontal: 'center'};
                destinationCountryCell.font = {name: 'Arial', size: 10};

                // endregion

                worksheet.mergeCells('B20:I20');
                const GbnCell = worksheet.getCell('B20');
                GbnCell.border = {bottom: thinBorder, top: thinBorder};

                worksheet.getCell('B21').value = 'Country of Origin';
                worksheet.getCell('B21').alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                worksheet.getCell('B21').font = {name: 'Arial', size: 11, bold: true};

                worksheet.getCell('C21').value = 'Pkgs / Type';
                worksheet.getCell('C21').alignment = {vertical: 'middle', horizontal: 'center'};
                worksheet.getCell('C21').font = {name: 'Arial', size: 11, bold: true};

                worksheet.mergeCells('D21:F21');
                worksheet.getCell('D21').value = 'Description of Goods';
                worksheet.getCell('D21').alignment = {vertical: 'middle', horizontal: 'center'};
                worksheet.getCell('D21').font = {name: 'Arial', size: 11, bold: true};

                worksheet.getCell('G21').value = 'Qty / Unit';
                worksheet.getCell('G21').alignment = {vertical: 'middle', horizontal: 'center'};
                worksheet.getCell('G21').font = {name: 'Arial', size: 11, bold: true};

                worksheet.getCell('H21').value = 'Qty / Unit Price(USD)';
                worksheet.getCell('H21').alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                worksheet.getCell('H21').font = {name: 'Arial', size: 11, bold: true};

                worksheet.getCell('I21').value = 'Total Amount(USD)';
                worksheet.getCell('I21').alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                worksheet.getCell('I21').font = {name: 'Arial', size: 11, bold: true};

                for (let row = 22; row <= 56; row++) {
                    worksheet.mergeCells(`D${row}:F${row}`);
                }

                for (let row = 21; row <= 56; row++) {
                    for (let col of ['B', 'C', 'D', 'G', 'H']) {
                        worksheet.getCell(`${col}${row}`).border = {
                            right: thinBorder,
                        };
                    }
                }

                worksheet.getCell('B22').value = 'KR';
                worksheet.getCell('B22').alignment = {vertical: 'middle', horizontal: 'center'};
                worksheet.getCell('B22').font = {name: 'Arial', size: 11, bold: true};

                worksheet.getCell('C22').value = '1 / cartons';
                worksheet.getCell('C22').alignment = {vertical: 'middle', horizontal: 'center'};
                worksheet.getCell('C22').font = {name: 'Arial', size: 11, bold: true};

                const startRow = 22;
                const KRW_TO_USD = 1400;
                let products = [];

                if (rowData.type === 'orderdt') {
                    products = rowData.productsDTO || [];
                } else if (rowData.type === 'payinfo') {
                    products = (rowData.packListDTO && rowData.packListDTO.productsDTO) || [];
                }

                products.forEach((product, index) => {
                    const row = startRow + index;

                    const quantity = product.quantity || 0;
                    const priceKRW = product.price || 0;
                    const totalKRW = quantity * priceKRW;

                    const priceUSD = priceKRW / KRW_TO_USD;
                    const totalUSD = totalKRW / KRW_TO_USD;

                    if (row > 56) return;

                    worksheet.getCell(`D${row}`).value = product.name || '';
                    worksheet.getCell(`D${row}`).alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                    worksheet.getCell(`D${row}`).font = {name: 'Arial', size: 11};

                    worksheet.getCell(`G${row}`).value = (product.quantity || 0).toLocaleString();
                    worksheet.getCell(`G${row}`).alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                    worksheet.getCell(`G${row}`).font = {name: 'Arial', size: 11};

                    worksheet.getCell(`H${row}`).value = priceUSD;
                    worksheet.getCell(`H${row}`).alignment = {vertical: 'middle', horizontal: 'right', wrapText: true};
                    worksheet.getCell(`H${row}`).font = {name: 'Arial', size: 11};
                    worksheet.getCell(`H${row}`).numFmt = '"$"#,##0.00';

                    worksheet.getCell(`I${row}`).value = totalUSD;
                    worksheet.getCell(`I${row}`).alignment = {vertical: 'middle', horizontal: 'right', wrapText: true};
                    worksheet.getCell(`I${row}`).font = {name: 'Arial', size: 11};
                    worksheet.getCell(`I${row}`).numFmt = '"$"#,##0.00';
                });

                const totalQty = products.reduce((sum, product) => {
                    return sum + (product.quantity || 0);
                }, 0);

                worksheet.getCell('G57').value = `${totalQty} EA`;
                worksheet.getCell('G57').alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};
                worksheet.getCell('G57').font = {name: 'Arial', size: 12, bold: true};

                worksheet.getCell('I57').value = {formula: 'SUM(I22:I56)'};
                worksheet.getCell('I57').alignment = {vertical: 'middle', horizontal: 'right', wrapText: true};
                worksheet.getCell('I57').font = {name: 'Arial', size: 12, bold: true};
                worksheet.getCell('I57').numFmt = '"$"#,##0.00';

                const totalCell = worksheet.getCell('F57');
                totalCell.value = 'Total';
                totalCell.alignment = {vertical: 'middle', horizontal: 'right'};
                totalCell.font = {name: 'Arial', size: 12, bold: true};

                worksheet.mergeCells('F60:F61');

                const signedByCell = worksheet.getCell('F60');
                signedByCell.value = 'Signed By.';
                signedByCell.alignment = {vertical: 'bottom', horizontal: 'right'};
                signedByCell.font = {name: 'Arial', size: 11};
                // ✅ I61
                const signatureNameCell = worksheet.getCell('I61');
                signatureNameCell.value = 'IMEUNWOO';
                signatureNameCell.alignment = {vertical: 'bottom', horizontal: 'center'};
                signatureNameCell.font = {name: 'Arial', size: 12, bold: true};

                for (let col of ['G', 'H', 'I']) {
                    worksheet.getCell(`${col}61`).border = {
                        bottom: thinBorder,
                    };
                }

                // endregion

                // region 다운로드

                worksheet.pageSetup.printArea = 'A1:I61';

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });

                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = `[${userName}님]인보이스_${orderNo}_${DateViewValue}.xlsx`;
                anchor.click();
                window.URL.revokeObjectURL(url);

                // endregion
            }
        } catch (error) {
            console.error(error);
        }
    };

    //endregion

    const [paySeqnum, setPaySeqnum] = useState([]);
    const [deliveryDetailSt, setDeliveryDetailSt] = useState(false);
    const deliveryDetailFalseFn = (() => {
        setDeliveryDetailSt(false);
    })
    const deliveryDetailTrueFn = ((e) => {
        setPaySeqnum(e);
        setDeliveryDetailSt(true);
    })

    // 현재 관리자 브라우저위치
    const pathComponent = window.location.pathname;

    const updateAppRecinfo = (updatedPayinfo) => {
        setPayinfoList((prevPayinfoList) => {
            return prevPayinfoList.map((payinfo) => {
                if (payinfo.appRecDTO && payinfo.appRecDTO.seqnum === updatedPayinfo.seqnum) {
                    return {...payinfo, appRecDTO: updatedPayinfo};
                }
                return payinfo;
            });
        });
    };

    const updatePayinfoList = (updatedPayinfo) => {
        setPayinfoList((prevPayinfoList) => {
            return prevPayinfoList.map((payinfo) =>
                payinfo.seqNum === updatedPayinfo.seqNum ? updatedPayinfo : payinfo,
            );
        });
    };

    // 장바구니 상품상태변경 시작
    const [isOpenCartItemDt, setIsOpenCartItemDt] = useState({});

    const toggleMenuDTcartFn = (cDataIndex, prodQy) => {
        setIsOpenCartItemDt(prevState => ({
            ...prevState,
            [cDataIndex]: prodQy > 0 ? !prevState[cDataIndex] : false
        }));
    };

    const [allCartProdStChangeShow, setAllCartProdStChangeShow] = useState(false);
    const closeAllCartProdStChangeShow = (() => {
        setAllCartProdStChangeShow(false);
    })
    const [allCartProdStNonSeqnumShow, setAllCartProdStNonSeqnumShow] = useState(false);
    const closeAllCartProdStNonSeqNumModalShow = (() => {
        setAllCartProdStNonSeqnumShow(false);
    })

    const [cartProdStShow, setCartProdStShow] = useState({});
    const cartProdStRef = useRef([]);

    const toggleCartProdStShow = (cDataIndex, productIndex) => {
        const key = `${cDataIndex}-${productIndex}`;
        setCartProdStShow(prevState => ({
            ...prevState,
            [key]: !prevState[key]
        }));
    };

    useEffect(() => {
        function handleClickOutside(event) {
            const openDropdownKey = Object.keys(cartProdStShow).find(key => cartProdStShow[key]);
            if (openDropdownKey !== undefined) {
                const openDropdownRef = cartProdStRef.current[openDropdownKey];

                if (openDropdownRef && !openDropdownRef.contains(event.target)) {
                    setCartProdStShow(prevState => ({
                        ...prevState,
                        [openDropdownKey]: false
                    }));
                }
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [cartProdStShow]);

    const [selectedAllCartProdSt, setSelectedAllCartProdSt] = useState({});
    const [allCartProdStShow, setAllCartProdStShow] = useState({});
    const allCartProdStRefs = useRef({});

    const toggleAllCartProdStShow = (cDataIndex) => {
        setAllCartProdStShow(prevState => ({
            ...prevState,
            [cDataIndex]: !prevState[cDataIndex]
        }));
    };

    useEffect(() => {
        function handleClickOutside(event) {
            const openDropdownKey = Object.keys(allCartProdStShow).find(key => allCartProdStShow[key]);
            const openDropdownRef = allCartProdStRefs.current[openDropdownKey];

            if (openDropdownRef && !openDropdownRef.contains(event.target)) {
                setAllCartProdStShow(prevState => ({
                    ...prevState,
                    [openDropdownKey]: false
                }));
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [allCartProdStShow, allCartProdStRefs]);
    // 장바구니 상품상태변경 종료


    // 구매대행 상품상태변경 시작
    const [isOpenOrderItemDt, setIsOpenOrderItemDt] = useState({});

    const toggleMenuDTorderFn = (cDataIndex, prodQy) => {
        setIsOpenOrderItemDt(prevState => ({
            ...prevState,
            [cDataIndex]: prodQy > 0 ? !prevState[cDataIndex] : false
        }));
    };

    const [allOrderProdStChangeShow, setAllOrderProdStChangeShow] = useState(false);
    const closeAllOrderProdStChangeShow = (() => {
        setAllOrderProdStChangeShow(false);
    })
    const [allOrderProdStNonSeqnumShow, setAllOrderProdStNonSeqnumShow] = useState(false);
    const closeAllOrderProdStNonSeqNumModalShow = (() => {
        setAllOrderProdStNonSeqnumShow(false);
    })

    const [orderProdStShow, setOrderProdStShow] = useState({});
    const orderProdStRef = useRef([]);

    const toggleOrderProdStShow = (cDataIndex, productIndex) => {
        const key = `${cDataIndex}-${productIndex}`;
        setOrderProdStShow(prevState => ({
            ...prevState,
            [key]: !prevState[key]
        }));
    };

    useEffect(() => {
        function handleClickOutside(event) {
            // Find the key of the currently open dropdown
            const openDropdownKey = Object.keys(orderProdStShow).find(key => orderProdStShow[key]);
            if (openDropdownKey !== undefined) {
                // Retrieve the ref of the open dropdown
                const openDropdownRef = orderProdStRef.current[openDropdownKey];

                // If the click was outside the open dropdown, close it
                if (openDropdownRef && !openDropdownRef.contains(event.target)) {
                    setOrderProdStShow(prevState => ({
                        ...prevState,
                        [openDropdownKey]: false
                    }));
                }
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [orderProdStShow]);

    const [selectedAllOrderProdSt, setSelectedAllOrderProdSt] = useState({});
    const [allOrderProdStShow, setAllOrderProdStShow] = useState({});
    const allOrderProdStRefs = useRef({});

    const toggleAllOrderProdStShow = (cDataIndex) => {
        setAllOrderProdStShow(prevState => ({
            ...prevState,
            [cDataIndex]: !prevState[cDataIndex]
        }));
    };

    useEffect(() => {
        function handleClickOutside(event) {
            const openDropdownKey = Object.keys(allOrderProdStShow).find(key => allOrderProdStShow[key]);
            const openDropdownRef = allOrderProdStRefs.current[openDropdownKey];

            if (openDropdownRef && !openDropdownRef.contains(event.target)) {
                setAllOrderProdStShow(prevState => ({
                    ...prevState,
                    [openDropdownKey]: false
                }));
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [allOrderProdStShow, allOrderProdStRefs]);
    // 구매대행 상품상태변경 종료


    // 오프라인 상품상태변경 시작
    const [isOpenOfflineItemDt, setIsOpenOfflineItemDt] = useState({});

    const toggleMenuDTofflineFn = (cDataIndex, prodQy) => {
        setIsOpenOfflineItemDt(prevState => ({
            ...prevState,
            [cDataIndex]: prodQy > 0 ? !prevState[cDataIndex] : false
        }));
    };

    const [allOfflineProdStChangeShow, setAllOfflineProdStChangeShow] = useState(false);
    const closeAllOfflineProdStChangeShow = (() => {
        setAllOfflineProdStChangeShow(false);
    })
    const [allOfflineProdStNonSeqnumShow, setAllOfflineProdStNonSeqnumShow] = useState(false);
    const closeAllOfflineProdStNonSeqNumModalShow = (() => {
        setAllOfflineProdStNonSeqnumShow(false);
    })

    const [offlineProdStShow, setOfflineProdStShow] = useState({});
    const offlineProdStRef = useRef([]);

    const toggleOfflineProdStShow = (cDataIndex, productIndex) => {
        const key = `${cDataIndex}-${productIndex}`;
        setOfflineProdStShow(prevState => ({
            ...prevState,
            [key]: !prevState[key]
        }));
    };

    useEffect(() => {
        function handleClickOutside(event) {
            // Find the key of the currently open dropdown
            const openDropdownKey = Object.keys(offlineProdStShow).find(key => offlineProdStShow[key]);
            if (openDropdownKey !== undefined) {
                // Retrieve the ref of the open dropdown
                const openDropdownRef = offlineProdStRef.current[openDropdownKey];

                // If the click was outside the open dropdown, close it
                if (openDropdownRef && !openDropdownRef.contains(event.target)) {
                    setOfflineProdStShow(prevState => ({
                        ...prevState,
                        [openDropdownKey]: false
                    }));
                }
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [offlineProdStShow]);

    const [selectedAllOfflineProdSt, setSelectedAllOfflineProdSt] = useState({});
    const [allOfflineProdStShow, setAllOfflineProdStShow] = useState({});
    const allOfflineProdStRefs = useRef({});

    const toggleAllOfflineProdStShow = (cDataIndex) => {
        setAllOfflineProdStShow(prevState => ({
            ...prevState,
            [cDataIndex]: !prevState[cDataIndex]
        }));
    };

    useEffect(() => {
        function handleClickOutside(event) {
            const openDropdownKey = Object.keys(allOfflineProdStShow).find(key => allOfflineProdStShow[key]);
            const openDropdownRef = allOfflineProdStRefs.current[openDropdownKey];

            if (openDropdownRef && !openDropdownRef.contains(event.target)) {
                setAllOfflineProdStShow(prevState => ({
                    ...prevState,
                    [openDropdownKey]: false
                }));
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [allOfflineProdStShow, allOfflineProdStRefs]);
    // 오프라인 상품상태변경 종료


    // 이체대행 상품상태변경 시작
    const [isOpenTransferItemDt, setIsOpenTransferItemDt] = useState({});

    const toggleMenuDTtransferFn = (cDataIndex, prodQy) => {
        setIsOpenTransferItemDt(prevState => ({
            ...prevState,
            [cDataIndex]: prodQy > 0 ? !prevState[cDataIndex] : false
        }));
    };

    const [allTransferProdStChangeShow, setAllTransferProdStChangeShow] = useState(false);
    const closeAllTransferProdStChangeShow = (() => {
        setAllTransferProdStChangeShow(false);
    })
    const [allTransferProdStNonSeqnumShow, setAllTransferProdStNonSeqnumShow] = useState(false);
    const closeAllTransferProdStNonSeqNumModalShow = (() => {
        setAllTransferProdStNonSeqnumShow(false);
    })

    const [transferProdStShow, setTransferProdStShow] = useState({});
    const transferProdStRef = useRef([]);

    const toggleTransferProdStShow = (cDataIndex, productIndex) => {
        const key = `${cDataIndex}-${productIndex}`;
        setTransferProdStShow(prevState => ({
            ...prevState,
            [key]: !prevState[key]
        }));
    };

    useEffect(() => {
        function handleClickOutside(event) {
            // Find the key of the currently open dropdown
            const openDropdownKey = Object.keys(transferProdStShow).find(key => transferProdStShow[key]);
            if (openDropdownKey !== undefined) {
                // Retrieve the ref of the open dropdown
                const openDropdownRef = transferProdStRef.current[openDropdownKey];

                // If the click was outside the open dropdown, close it
                if (openDropdownRef && !openDropdownRef.contains(event.target)) {
                    setTransferProdStShow(prevState => ({
                        ...prevState,
                        [openDropdownKey]: false
                    }));
                }
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [transferProdStShow]);

    const [selectedAllTransferProdSt, setSelectedAllTransferProdSt] = useState({});
    const [allTransferProdStShow, setAllTransferProdStShow] = useState({});
    const allTransferProdStRefs = useRef({});

    const toggleAllTransferProdStShow = (cDataIndex) => {
        setAllTransferProdStShow(prevState => ({
            ...prevState,
            [cDataIndex]: !prevState[cDataIndex]
        }));
    };

    useEffect(() => {
        function handleClickOutside(event) {
            const openDropdownKey = Object.keys(allTransferProdStShow).find(key => allTransferProdStShow[key]);
            const openDropdownRef = allTransferProdStRefs.current[openDropdownKey];

            if (openDropdownRef && !openDropdownRef.contains(event.target)) {
                setAllTransferProdStShow(prevState => ({
                    ...prevState,
                    [openDropdownKey]: false
                }));
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [allTransferProdStShow, allTransferProdStRefs]);
    // 이체대행 상품상태변경 종료


    // 국내구매 상품상태변경 시작
    const [isOpenDomesticItemDt, setIsOpenDomesticItemDt] = useState({});

    const toggleMenuDTdomesticFn = (cDataIndex, prodQy) => {
        setIsOpenDomesticItemDt(prevState => ({
            ...prevState,
            [cDataIndex]: prodQy > 0 ? !prevState[cDataIndex] : false
        }));
    };

    const [allDomesticProdStChangeShow, setAllDomesticProdStChangeShow] = useState(false);
    const closeAllDomesticProdStChangeShow = (() => {
        setAllDomesticProdStChangeShow(false);
    })
    const [allDomesticProdStNonSeqnumShow, setAllDomesticProdStNonSeqnumShow] = useState(false);
    const closeAllDomesticProdStNonSeqNumModalShow = (() => {
        setAllDomesticProdStNonSeqnumShow(false);
    })

    const [domesticProdStShow, setDomesticProdStShow] = useState({});
    const domesticProdStRef = useRef([]);

    const toggleDomesticProdStShow = (cDataIndex, productIndex) => {
        const key = `${cDataIndex}-${productIndex}`;
        setDomesticProdStShow(prevState => ({
            ...prevState,
            [key]: !prevState[key]
        }));
    };

    useEffect(() => {
        function handleClickOutside(event) {
            // Find the key of the currently open dropdown
            const openDropdownKey = Object.keys(domesticProdStShow).find(key => domesticProdStShow[key]);
            if (openDropdownKey !== undefined) {
                // Retrieve the ref of the open dropdown
                const openDropdownRef = domesticProdStRef.current[openDropdownKey];

                // If the click was outside the open dropdown, close it
                if (openDropdownRef && !openDropdownRef.contains(event.target)) {
                    setDomesticProdStShow(prevState => ({
                        ...prevState,
                        [openDropdownKey]: false
                    }));
                }
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [domesticProdStShow]);

    const [selectedAllDomesticProdSt, setSelectedAllDomesticProdSt] = useState({});
    const [allDomesticProdStShow, setAllDomesticProdStShow] = useState({});
    const allDomesticProdStRefs = useRef({});

    const toggleAllDomesticProdStShow = (cDataIndex) => {
        setAllDomesticProdStShow(prevState => ({
            ...prevState,
            [cDataIndex]: !prevState[cDataIndex]
        }));
    };

    useEffect(() => {
        function handleClickOutside(event) {
            const openDropdownKey = Object.keys(allDomesticProdStShow).find(key => allDomesticProdStShow[key]);
            const openDropdownRef = allDomesticProdStRefs.current[openDropdownKey];

            if (openDropdownRef && !openDropdownRef.contains(event.target)) {
                setAllDomesticProdStShow(prevState => ({
                    ...prevState,
                    [openDropdownKey]: false
                }));
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [allDomesticProdStShow, allDomesticProdStRefs]);
    // 국내구매 상품상태변경 종료

    // 배송대행 상품상태변경 시작
    const [isOpenDeliveryItemDt, setIsOpenDeliveryItemDt] = useState({});

    const toggleMenuDTdeliveryFn = (cDataIndex, prodQy) => {
        setIsOpenDeliveryItemDt(prevState => ({
            ...prevState,
            [cDataIndex]: prodQy > 0 ? !prevState[cDataIndex] : false
        }));
    };

    const [allDeliveryProdStChangeShow, setAllDeliveryProdStChangeShow] = useState(false);
    const closeAllDeliveryProdStChangeShow = (() => {
        setAllDeliveryProdStChangeShow(false);
    })
    const [allDeliveryProdStNonSeqnumShow, setAllDeliveryProdStNonSeqnumShow] = useState(false);
    const closeAllDeliveryProdStNonSeqNumModalShow = (() => {
        setAllDeliveryProdStNonSeqnumShow(false);
    })

    const [deliveryProdStShow, setDeliveryProdStShow] = useState({});
    const deliveryProdStRef = useRef([]);

    const toggleDeliveryProdStShow = (cDataIndex, productIndex) => {
        const key = `${cDataIndex}-${productIndex}`;
        setDeliveryProdStShow(prevState => ({
            ...prevState,
            [key]: !prevState[key]
        }));
    };

    useEffect(() => {
        function handleClickOutside(event) {
            const openDropdownKey = Object.keys(deliveryProdStShow).find(key => deliveryProdStShow[key]);
            if (openDropdownKey !== undefined) {
                const openDropdownRef = deliveryProdStRef.current[openDropdownKey];

                if (openDropdownRef && !openDropdownRef.contains(event.target)) {
                    setDeliveryProdStShow(prevState => ({
                        ...prevState,
                        [openDropdownKey]: false
                    }));
                }
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [deliveryProdStShow]);

    const [selectedAllDeliveryProdSt, setSelectedAllDeliveryProdSt] = useState({});
    const [allDeliveryProdStShow, setAllDeliveryProdStShow] = useState({});
    const allDeliveryProdStRefs = useRef({});

    const toggleAllDeliveryProdStShow = (cDataIndex) => {
        setAllDeliveryProdStShow(prevState => ({
            ...prevState,
            [cDataIndex]: !prevState[cDataIndex]
        }));
    };

    useEffect(() => {
        function handleClickOutside(event) {
            const openDropdownKey = Object.keys(allDeliveryProdStShow).find(key => allDeliveryProdStShow[key]);
            const openDropdownRef = allDeliveryProdStRefs.current[openDropdownKey];

            if (openDropdownRef && !openDropdownRef.contains(event.target)) {
                setAllDeliveryProdStShow(prevState => ({
                    ...prevState,
                    [openDropdownKey]: false
                }));
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [allDeliveryProdStShow, allDeliveryProdStRefs]);
    // 배송대행 상품상태변경 종료

    // common function
    const allProdStChangeMsg1 = "선택한 상품의 상태들을 변경하시겠습니까?";
    const allProdStChangeMsg2 = "변경하실 상품상태를 한 번더 확인해주세요";
    const allProdStNonSeqnumMsg = "전체변경하실 상품을 선택해주세요";

    const [selectedFormTy, setSelectedFormTy] = useState('');
    const [selectedCdataIndex, setSelectedCdataIndex] = useState(0);
    const [selectedProdSt, setSelectedProdSt] = useState({});
    const [selectedItems, setSelectedItems] = useState({
        cart: {},
        order: {},
        offline: {},
        transfer: {},
        domestic: {},
        delivery: {}
    });

    const handleCheckAll = (formType, cDataIndex, isChecked, productsDTO) => {
        let prodStCode = null;
        if (formType === 'cart') {
            prodStCode = "P00";
        } else if (formType === 'order') {
            prodStCode = "P01";
        } else if (formType === 'offline') {
            prodStCode = "P02";
        } else if (formType === 'transfer') {
            prodStCode = "P03";
        } else if (formType === 'domestic') {
            prodStCode = "P04";
        } else if (formType === 'delivery') {
            prodStCode = "P05";
        }

        setSelectedItems(prevState => {
            const updatedState = {...prevState};
            updatedState[formType][cDataIndex] = isChecked ? productsDTO.filter(prod => prod.prodTy === prodStCode).map(prod => prod.seqnum) : [];
            return updatedState;
        });
    };

    // 개별 아이템 선택 처리
    const handleCheckItem = (formType, cDataIndex, seqNum, isChecked) => {
        setSelectedItems(prevState => {
            const updatedState = {...prevState};
            if (isChecked) {
                updatedState[formType][cDataIndex] = [...(updatedState[formType][cDataIndex] || []), seqNum];
            } else {
                updatedState[formType][cDataIndex] = (updatedState[formType][cDataIndex] || []).filter(num => num !== seqNum);
            }
            return updatedState;
        });
    };

    const handleProdStChange = (formType, prodSt, seqNum, cDataIndex, productIndex) => {
        // 셀렉트 label 업뎃
        const newSelectedProdSt = {
            ...selectedProdSt,
            [`${formType}-${cDataIndex}-${productIndex}`]: prodSt
        };
        setSelectedProdSt(newSelectedProdSt);

        // 주문서 index 및 prod index에 따라 드랍다운 닫기
        if (formType === "cart") {
            setCartProdStShow({});
        } else if (formType === "order") {
            setOrderProdStShow({});
        } else if (formType === "offline") {
            setOfflineProdStShow({});
        } else if (formType === "transfer") {
            setTransferProdStShow({});
        } else if (formType === "domestic") {
            setDomesticProdStShow({});
        } else if (formType === "delivery") {
            setDeliveryProdStShow({});
        }

        modifyProdSt(prodSt, seqNum);
    };

    const handleAllProdStChange = (formType, cDataIndex, allProdSt) => {
        setSelectedFormTy(formType);
        setSelectedCdataIndex(cDataIndex);
        let selectedItemsDataFl = selectedItems[formType][cDataIndex] && selectedItems[formType][cDataIndex].length > 0;
        let selectedItemsNoDataFl = !selectedItems[formType][cDataIndex] || selectedItems[formType][cDataIndex].length === 0;

        if (formType === 'cart') {
            setSelectedAllCartProdSt(prevState => ({
                ...prevState,
                [cDataIndex]: allProdSt
            }));
            setAllCartProdStShow(prevState => ({
                ...prevState,
                [cDataIndex]: false
            }));
            setAllCartProdStChangeShow(selectedItemsDataFl);
            setAllCartProdStNonSeqnumShow(selectedItemsNoDataFl);
        } else if (formType === 'order') {
            setSelectedAllOrderProdSt(prevState => ({
                ...prevState,
                [cDataIndex]: allProdSt
            }));
            setAllOrderProdStShow(prevState => ({
                ...prevState,
                [cDataIndex]: false
            }));
            setAllOrderProdStChangeShow(selectedItemsDataFl);
            setAllOrderProdStNonSeqnumShow(selectedItemsNoDataFl);
        } else if (formType === 'offline') {
            setSelectedAllOfflineProdSt(prevState => ({
                ...prevState,
                [cDataIndex]: allProdSt
            }));
            setAllOfflineProdStShow(prevState => ({
                ...prevState,
                [cDataIndex]: false
            }));
            setAllOfflineProdStChangeShow(selectedItemsDataFl);
            setAllOfflineProdStNonSeqnumShow(selectedItemsNoDataFl);
        } else if (formType === 'transfer') {
            setSelectedAllTransferProdSt(prevState => ({
                ...prevState,
                [cDataIndex]: allProdSt
            }));
            setAllTransferProdStShow(prevState => ({
                ...prevState,
                [cDataIndex]: false
            }));
            setAllTransferProdStChangeShow(selectedItemsDataFl);
            setAllTransferProdStNonSeqnumShow(selectedItemsNoDataFl);
        } else if (formType === 'domestic') {
            setSelectedAllDomesticProdSt(prevState => ({
                ...prevState,
                [cDataIndex]: allProdSt
            }));
            setAllDomesticProdStShow(prevState => ({
                ...prevState,
                [cDataIndex]: false
            }));
            setAllDomesticProdStChangeShow(selectedItemsDataFl);
            setAllDomesticProdStNonSeqnumShow(selectedItemsNoDataFl);
        } else if (formType === 'delivery') {
            setSelectedAllDeliveryProdSt(prevState => ({
                ...prevState,
                [cDataIndex]: allProdSt
            }));
            setAllDeliveryProdStShow(prevState => ({
                ...prevState,
                [cDataIndex]: false
            }));
            setAllDeliveryProdStChangeShow(selectedItemsDataFl);
            setAllDeliveryProdStNonSeqnumShow(selectedItemsNoDataFl);
        }
    };

    const [dontTrackingShipcoSt, setDontTrackingShipcoSt] = useState(false);
    const closeDontTrackingShipco = (() => {
        setDontTrackingShipcoSt(false);
    });

    const selectDsTrackNum = ((selectedDomestic, dsTrackNum) => {
        const screenWidth = window.screen.width;
        const screenHeight = window.screen.height;
        const width = 1200;
        const height = 800;
        const left = (screenWidth / 2) - (width / 2);
        const top = (screenHeight / 2) - (height / 2);

        if (selectedDomestic === "CJ대한통운" || selectedDomestic === "CJ 대한통운") {
            const url = `https://trace.cjlogistics.com/next/tracking.html?wblNo=${dsTrackNum}`;
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (selectedDomestic === "로젠택배") {
            const url = `https://www.ilogen.com/web/personal/trace/${dsTrackNum}`;
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (selectedDomestic === "우체국") {
            const url = `https://service.epost.go.kr/trace.RetrieveDomRigiTraceList.comm?sid1=${dsTrackNum}&displayHeader=N`
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (selectedDomestic === "한진택배") {
            const url = `https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillResult.do?mCode=MN038&schLang=KR&wblnumText2=${dsTrackNum}`
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (selectedDomestic === "롯데택배") {
            const url = `https://www.lotteglogis.com/open/tracking?invno=${dsTrackNum}`
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (selectedDomestic === "경동택배") {
            const url = `https://kdexp.com/newDeliverySearch.kd?barcode=${dsTrackNum}`
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (selectedDomestic === "국내배송") {
            const url = `https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillResult.do?mCode=MN038&schLang=KR&wblnumText2=${dsTrackNum}`
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else {
            setDontTrackingShipcoSt(true);
        }
    })

    const selectOsTrackNum = ((shipco, trackNum) => {
        const screenWidth = window.screen.width;
        const screenHeight = window.screen.height;
        const width = 1200;
        const height = 800;
        const left = (screenWidth / 2) - (width / 2);
        const top = (screenHeight / 2) - (height / 2);

        if (shipco === "FedEx" || shipco === "FedEx-E") {
            const url = `https://www.fedex.com/fedextrack/?trknbr=${trackNum}`;
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (shipco === "UPS" || shipco === "UPS-E") {
            const url = `https://www.ups.com/track?loc=ko_KR&trackNums=${trackNum}&requester=ST/trackdetails`;
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (shipco === "DHL") {
            const url = `https://www.dhl.com/kr-ko/home/tracking/tracking-ecommerce.html?submit=1&tracking-id=${trackNum}`;
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (shipco === "EMS" || shipco === "SEA" || shipco === "EMSP" || shipco === "K-Packet" || shipco === "Small-Packet") {
            const url = `https://service.epost.go.kr/trace.RetrieveEmsRigiTraceList.comm?POST_CODE=${trackNum}&displayHeader=N`;
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        }
    })


    const modifyProdSt = (prodSt, seqNums) => {

        let params = new URLSearchParams();
        params.append('prodValue', prodSt.value);
        params.append('adminInfo', adminInfo.mbNum);

        if (!Array.isArray(seqNums)) {
            seqNums = [seqNums];
        }
        seqNums.forEach(num => params.append('prodSeqNum', num));

        const productSeqNums = Array.isArray(seqNums) ? seqNums : [seqNums];
        productSeqNums.forEach(num => params.append('prodSeqNum', num));

        axios({
            method: 'post',
            url: '/order/modifyProdSt',
            params: params,
        })
            .then((response) => {

                const updatedOrder = response.data;
                const updatedProducts = updatedOrder.productsDTO || [];
                const mbNum = updatedOrder?.memberDTO?.mbNum;

                setOrdData(prevOrdData =>
                    prevOrdData.map(order => {
                        // 기존 OrdData와 서버로부터 응답된 updatedOrder가 매칭불가 시 기존 OrdData 주문서 그대로 반환
                        if (order.seqnum !== updatedOrder.seqnum) {
                            return order;
                        }

                        // 백엔드 응답의 상품 데이터를 Map으로 만들어 빠르게 접근 가능하도록 세팅
                        const updatedProductsMap = new Map();
                        updatedProducts.forEach(updatedProd => {
                            updatedProductsMap.set(updatedProd.seqnum, updatedProd);
                        });

                        // 기존주문서(OrdData)의 상품들을 순회하면서 응답/업데이트된 주문서(updatedOrder)의 상품들의 업데이트된 상태를 병합
                        const newProductsDTO = order.productsDTO.map(prevProduct => {
                            // 기존주문서의 상품들과 응답주문서의 상품들의 매칭 ProductsDTO 데이터만 updatedProductData에 저장
                            const updatedProductData = updatedProductsMap.get(prevProduct.seqnum);

                            // 기존주문서(OrdData)의 상품들중 업데이트된 ProductsDTO 데이터만 updatedOrder의 상품들로 덮어쓰기
                            if (updatedProductData) {
                                return {
                                    ...prevProduct,      // 기존 상품의 모든 필드 유지
                                    ...updatedProductData // 업데이트/응답된 ProductsDTO 데이터로 덮어쓰기
                                };
                                // 만약 백엔드가 항상 상품의 모든 최신 필드를 반환한다면 아래처럼 간단히 가능:
                                // return updatedProductData;
                            } else {
                                // 업데이트사항이 없을 경우 기존주문서의 상품데이터 그대로 반환
                                return prevProduct;
                            }
                        });

                        // 기존 주문서(...order)에 업데이트된 주문서(...updatedOrder)와 새로 병합된 상품데이터(newProductsDTO)를 삽입하여 새로운 객체로 반환
                        return {
                            ...order,          // 기존 주문서의 필드 유지 (UI 상태 등)
                            ...updatedOrder,   // 백엔드에서 받은 주문서 레벨 필드 업데이트 (orderStatus 등)
                            productsDTO: newProductsDTO // 새로 병합된 상품 배열로 교체
                        };
                    })
                );

                // 사용자수신을 위해 mbNum 추가삽입후 업데이트사항 전달
                const productsForRealtime = updatedOrder.productsDTO.map(prod => ({
                    ...prod,
                    mbNum: mbNum
                }));
                realTimeChangeProdSt(productsForRealtime);

                setSelectedItems({
                    cart: {},
                    order: {},
                    offline: {},
                    transfer: {},
                    domestic: {},
                    delivery: {}
                });

                seletecdProdWithOrderSeqNum(response.data.seqnum, response.data.orderStatus, mbNum);

            })
            .catch((error) => {
                console.log("상품상태 변경실패 : ", error);
            });
    };

    const realTimeChangeProdSt = async (prodList) => {
        if (stompClient) {
            await stompClient.send("/app/prodSt/adminProdStUpdate", {}, JSON.stringify(prodList));
        } else {
            console.error("Stomp client is not connected.");
        }
    }

    const seletecdProdWithOrderSeqNum = ((orderSeqNum, orderSt, mbNum) => {
        axios({
            method: 'post',
            url: '/order/seletecdProdWithOrderSeqNum',
            headers: {
                Authorization: LCAT
            },
            params: {
                orderSeqNum: orderSeqNum
            }
        })
            .then((response) => {
                // 중앙에 stompClient 연결데이터, product List, orderSeqNum, orderSt, mbNum 전송
                orderStatusUpdate(stompClient, response.data, orderSeqNum, mbNum);
            })
            .catch((error) => {
                console.log("orderdt 반환실패 : ", error)
            })
    })

    const orderStReceived = ((payload) => {
        let data = JSON.parse(payload.body);
        setFilteredList(currentList => {
            return currentList.map(cData => {
                if (cData.type === 'orderdt' && cData.seqnum === data.orderSeqNum) {
                    cData.orderStatus = data.orderSt; // OS 실시간변경
                }
                return cData;
            });
        });
        selectAlarmData();
        selectedAllProcessCount();
    })

    const [prodStList, setProdStList] = useState([]);
    const selectedProdStList = (() => {
        axios({
            method: 'get',
            url: '/order/selectedProdStList',
            data: {
                selectPayinfo: checked
            },
        })
            .then((response) => {
                const newProdStList = response.data.map(item => ({
                    value: item.stValue,
                    label: item.stLabel
                }));
                setProdStList(newProdStList);
            })
            .catch((error) => {
                console.log("상품상태 리스트 조회실패 : ", error)
            })
    })


    useEffect(() => {
        selectedProdStList();
        selectedAllProcessCount();
    }, [])

    const [processData, setProcessData] = useState([]);
    const selectedAllProcessCount = (() => {
        axios({
            method: 'get',
            url: '/order/selectedAllProcessCount',
        })
            .then((response) => {
                setProcessData(response.data);
            })
            .catch((error) => {
                console.log("프로세스수량 조회실패 : ", error)
            })
    })

    const ordDtMemoSave = (seqnum, ordDtCont, memoType) => {
        axios.post('/order/ordMemoDtSave', {seqnum, ordDtCont, memoType}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': LCAT
            }
        })
            .then(() => {
                setSavePopupMsg("저장 완료");
                setSaveMsgSt(true);
                setTimeout(() => setSaveMsgSt(false), 500);
                // filteredList가 ordData를 참조하므로 주문서메모 변경 후 실시간 UI 업데이트
                if (memoType === 'orderdt') {
                    // 1. 주문서 메모인 경우: ordData 업데이트
                    setOrdData(prevOrdData =>
                        prevOrdData.map(order => {
                            if (order.seqnum === seqnum) {
                                return {
                                    ...order,
                                    orderMemoDTO: {
                                        ...order.orderMemoDTO,
                                        ordDtCont: ordDtCont // 변경된 내용 반영
                                    }
                                };
                            }
                            return order;
                        })
                    );
                } else if (memoType === 'payinfo') {
                    // filteredList가 payinfoList를 참조하므로 배송료메모 변경 후 실시간 UI 업데이트
                    setPayinfoList(prevPayList =>
                        prevPayList.map(payInfo => {
                            if (payInfo.seqNum === seqnum) {
                                return {
                                    ...payInfo,
                                    appOrderMemoDTO: {
                                        ...payInfo.appOrderMemoDTO,
                                        ordDtCont: ordDtCont // 변경된 내용 반영
                                    }
                                };
                            }
                            return payInfo;
                        })
                    );
                    // 만약 payinfo가 ordData 내부를 참조할 경우 내부의 ordData.payinfo.memo도 함께 변경(안전)
                    setOrdData(prevOrdData =>
                        prevOrdData.map(order => ({
                            ...order,
                            payInfoDTO: order.payInfoDTO.map(payInfo =>
                                payInfo.seqNum === seqnum
                                    ? {
                                        ...payInfo,
                                        appOrderMemoDTO: {
                                            ...payInfo.appOrderMemoDTO,
                                            ordDtCont: ordDtCont
                                        }
                                    }
                                    : payInfo
                            )
                        }))
                    );
                }
            })
            .catch(error => {
                setSavePopupMsg("저장 실패");
                setSaveMsgSt(true);
                setTimeout(() => setSaveMsgSt(false), 500);
            });
    };

    /** Event endregion */

    /** 관리자 예치금/적립금결제 시작 */
        // orderdt 관리자 예치금/적립금결제
    const [orderdtDepositPaySt, setOrderdtDepositPaySt] = useState(false);
    const [orderdtPointPaySt, setOrderdtPointPaySt] = useState(false);
    const orderdtDepositPayMsg1 = "주문서의 미결제금액을 예치금으로 결제하시겠습니까?";
    const orderdtDepositPayMsg2 = "결제 전 체크해주시기 바랍니다";
    const orderdtPointPayMsg1 = "주문서의 미결제금액을 적립금으로 결제하시겠습니까?";
    const orderdtPointPayMsg2 = "결제 전 체크해주시기 바랍니다";

    // 선택된 데이터가 null 일 경우
    const [dpPayNullSt, setDpPayNullSt] = useState(false);
    const closeDpPayNullSt = (() => {
        setDpPayNullSt(false);
    })

    const openOrderdtDepositPaySt = (() => {
        // 선택된 체크박스 데이터 없으면 orderdtDepositPayNullSt true
        if (!checked || checked.length === 0) {
            setDpPayNullSt(true);
        } else {
            setOrderdtDepositPaySt(true);
        }
    })
    const closeOrderdtDepositPaySt = (() => {
        setOrderdtDepositPaySt(false);
    })

    const openOrderdtPointPaySt = (() => {
        // 선택된 체크박스 데이터 없으면 setOrderdtPointPaySt true
        if (!checked || checked.length === 0) {
            setDpPayNullSt(true);
        } else {
            setOrderdtPointPaySt(true);
        }
    })
    const closeOrderdtPointPaySt = (() => {
        setOrderdtPointPaySt(false);
    })

    const orderdtAdminDpPay = ((type) => {
        axios({
            method: 'post',
            url: '/order/orderdtAdminDpPay',
            headers: {
                'Content-Type': 'application/json',
            },
            data: {
                seqNum: checked,
                type: type
            }
        })
            .then(async (response) => {
                for (const item of response.data) {
                    saveOrderAlarmData(response.data);
                }
                if (type === "deposit") {
                    closeOrderdtDepositPaySt();
                } else {
                    closeOrderdtPointPaySt();
                }
                selectedAllProcessCount();
                selectNoDateTotalOrderList(selectedProcessSt);
            })
            .catch((error) => {
                console.log("예치금결제 실패 : ", error)
            })
    })

    // payinfo 관리자 예치금/적립금결제
    const [payinfoDepositPaySt, setPayinfoDepositPaySt] = useState(false);
    const [payinfoPointPaySt, setPayinfoPointPaySt] = useState(false);
    const payinfoDepositPayMsg1 = "선택된 해외배송비를 예치금으로 결제하시겠습니까?";
    const payinfoDepositPayMsg2 = "결제 전 체크해주시기 바랍니다";
    const payinfoPointPayMsg1 = "선택된 해외배송비를 적립금으로 결제하시겠습니까?";
    const payinfoPointPayMsg2 = "결제 전 체크해주시기 바랍니다";
    const [payinfoSelectOrderErrSt, setPayinfoSelectOrderErrSt] = useState(false);
    const payinfoSelectOrderErrMsg = "배송료타입만 결제가 가능합니다";

    const openPayinfoDepositPaySt = (() => {
        // orderdt 주문서 유형이 선택되었다면 결제제한
        if (orderCheckedCount === 0) {
            // 선택된 체크박스 데이터 없으면 payinfoDepositPayNullSt true
            if (!checked || checked.length === 0) {
                setDpPayNullSt(true);
            } else {
                setPayinfoDepositPaySt(true);
            }
        } else {
            setPayinfoSelectOrderErrSt(true);
        }
    })
    const closePayinfoDepositPaySt = (() => {
        setPayinfoDepositPaySt(false);
    })

    const closePayinfoSelectOrderErr = (() => {
        setPayinfoSelectOrderErrSt(false);
    })

    const openPayinfoPointPaySt = (() => {
        // orderdt 주문서 유형이 선택되었다면 결제제한
        if (orderCheckedCount === 0) {
            // 선택된 체크박스 데이터 없으면 setPayinfoPointPaySt true
            if (!checked || checked.length === 0) {
                setDpPayNullSt(true);
            } else {
                setPayinfoPointPaySt(true);
            }
        } else {
            setPayinfoSelectOrderErrSt(true);
        }
    })
    const closePayinfoPointPaySt = (() => {
        setPayinfoPointPaySt(false);
    })

    const payinfoAdminDpPay = ((type) => {
        axios({
            method: 'post',
            url: '/order/payinfoAdminDpPay',
            headers: {
                'Content-Type': 'application/json',
            },
            data: {
                seqNum: checked,
                type: type
            }
        })
            .then(async (response) => {
                for (const item of response.data) {
                    saveOrderAlarmData(response.data);
                }
                if (type === "deposit") {
                    closePayinfoDepositPaySt();
                } else {
                    closePayinfoPointPaySt();
                }
                selectedAllProcessCount();
                selectNoDateTotalOrderList(selectedProcessSt);
            })
            .catch((error) => {
                console.log("예치금결제 실패 : ", error)
            })
    })

    const saveOrderAlarmData = ((orderData) => {
        axios({
            method: 'post',
            url: '/order/saveOrderData',
            headers: {
                Authorization: LCAT,
                'Content-Type': 'application/json',
            },
            data: orderData
        })
            .then(async () => {
                await stompClient.send("/app/sendOrderAlarm", {}, JSON.stringify({sendFl: true}));
            })
            .catch((error) => {
                console.log("알림데이터 저장실패 : ", error)
            })
    })

    /** 관리자 예치금/적립금결제 end */

    /** 국내반송/해외반송/출고취소 시작 */
    const [adminOsReturnSt, setAdminOsReturnSt] = useState(false);
    const [adminDsReturnSt, setAdminDsReturnSt] = useState(false);
    const [adminDeliveryCancelSt, setAdminDeliveryCancelSt] = useState(false);
    const osReturnMsg1 = "해외반송으로 처리하시겠습니까?";
    const osReturnMsg2 = "진행 후 복구가 불가합니다";
    const dsReturnMsg1 = "국내반송으로 처리하시겠습니까?";
    const dsReturnMsg2 = "진행 후 복구가 불가합니다";
    const dvCancelMsg1 = "출고를 취소하시겠습니까?";
    const dvCancelMsg2 = "결제완료(배송)상태로 리셋됩니다";

    // 선택된 데이터가 null 일 경우
    const [returnNullSt, setReturnNullSt] = useState(false);
    const closeReturnNullSt = (() => {
        setReturnNullSt(false);
    })

    const openOsReturnSt = (() => {
        if (orderCheckedCount === 0) {
            // 선택된 체크박스 데이터 없으면 orderdtDepositPayNullSt true
            if (!checked || checked.length === 0) {
                setReturnNullSt(true);
            } else {
                setAdminOsReturnSt(true);
            }
        } else {
            setPayinfoSelectOrderErrSt(true);
        }
    })
    const closeOsReturnSt = (() => {
        setAdminOsReturnSt(false);
    })

    const openDsReturnSt = (() => {
        if (orderCheckedCount === 0) {
            // 선택된 체크박스 데이터 없으면 setOrderdtPointPaySt true
            if (!checked || checked.length === 0) {
                setDpPayNullSt(true);
            } else {
                setAdminDsReturnSt(true);
            }
        } else {
            setPayinfoSelectOrderErrSt(true);
        }
    })
    const closeDsReturnSt = (() => {
        setAdminDsReturnSt(false);
    })

    const deliveryReturn = ((type) => {
        if (isLoading) return;

        setIsLoading(true);

        axios({
            method: 'post',
            url: '/order/deliveryReturn',
            headers: {
                'Content-Type': 'application/json',
                Authorization: LCAT
            },
            data: {
                seqNum: checked,
                type: type
            }
        })
            .then(async (response) => {
                for (const item of response.data) {
                    await stompClient.send("/app/updateOrderList", {}, JSON.stringify({userMbNum: item}));
                }
                if (type === "overseas") {
                    closeOsReturnSt();
                } else {
                    closeDsReturnSt();
                }
                selectedAllProcessCount();
                selectNoDateTotalOrderList(selectedProcessSt);
                setIsLoading(false);
            })
            .catch((error) => {
                console.log("리턴처리실패 : ", error)
            })
    })


    const [cancelPaySeqNum, setCancelPaySeqNum] = useState([]);
    const openDeliveryCancelSt = (async (seqNum = null) => {

        if (seqNum && typeof seqNum !== "number") {
            console.log("이벤트 객체형식 전달:", seqNum);
            return;
        }

        if (seqNum) {
            await setCancelPaySeqNum((prevSeqNum) => [...prevSeqNum, seqNum]);
        }
        // 주문서가 선택되지 않은 경우에만 실행
        if (orderCheckedCount === 0) {
            // 단일출고취소나 일괄출고취소 모두 데이터가 없을 경우
            if ((!seqNum && cancelPaySeqNum === null) && (!checked || checked.length === 0)) {
                setDpPayNullSt(true);
                // 이 외에 다음프로세스 정상실행
            } else {
                setAdminDeliveryCancelSt(true);
            }
            // 주문서가 섞여 있을 경우 에러
        } else {
            setPayinfoSelectOrderErrSt(true);
        }
    })
    const closeDeliveryCancelSt = (async () => {
        await setCancelPaySeqNum([]);
        setAdminDeliveryCancelSt(false);
    })

    const deliveryCancel = (() => {
        // seqNum값이 [SyntheticBaseEvent]식의 이벤트형식으로 전달방지
        const validCancelPaySeqNum = Array.isArray(cancelPaySeqNum) && cancelPaySeqNum.length > 0 ? cancelPaySeqNum : null;
        const choiceSeqNumToSend = validCancelPaySeqNum || checked;
        axios({
            method: 'post',
            url: '/order/deliveryCancel',
            headers: {
                'Content-Type': 'application/json',
                Authorization: LCAT
            },
            data: {
                seqNum: choiceSeqNumToSend,
                cancelFlag: true
            }
        })
            .then(async (response) => {
                for (const item of response.data) {
                    await stompClient.send("/app/updateOrderList", {}, JSON.stringify({userMbNum: item}));
                }
                await setCancelPaySeqNum([]);
                closeDeliveryCancelSt();
                selectedAllProcessCount();
                selectNoDateTotalOrderList(selectedProcessSt);
            })
            .catch((error) => {
                console.log("배송취소실패 : ", error)
            })
    })

    const cancelUpsShipment = async (shipmentIdentificationNumber) => {
        try {
            return;
            const response = await axios.post('/externalApi/upsReceiptCancel', {
                shipmentIdentificationNumber,
            });
        } catch (error) {
            console.error("UPS 출고 취소 실패:", error);
        }
    };

    const ordOutCancel = (() => {
        setAdminDsReturnSt(false);
    })

    /** 국내반송/해외반송/출고취소 종료 */

    const [selectedData, setSelectedData] = useState(null);

    const expRegDelete = async (cData) => {
        if (!cData || cData.type !== 'payinfo') {
            console.log('dataType 확인요망:', cData);
            return;
        }
        if (!cData) return;
        await axios({
            method: 'post',
            url: '/ordPay/deletePayinfoList/',
            data: {
                customsSeqnum: cData?.customsDTO?.seqNum,
                appReqSeqnum: cData?.appReqDTO?.seqNum,
                appRecSeqnum: cData?.appRecDTO?.seqnum,
                shipInfoSeqnum: cData?.shipInfoDTO?.seqNum,
                payConSeqnum: cData?.payConDTOList?.map(item => item.seqNum),
                packListSeqnum: cData?.packListDTO?.seqnum,
                payinfoSeqnum: cData?.seqNum,
                memoSeqnum: cData?.appOrderMemoDTO ? cData.appOrderMemoDTO.amSeqNum : null,
            },
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                const {updatedProducts, updatedOrderdt} = response.data;
                setAlertShow3(false);

                // 삭제된 payinfo UI에서 제거
                setPayinfoList((prevList) => prevList.filter((item) => item.seqNum !== cData.seqNum));
                // 변경된 order, product UI에서 변경
                setOrdData((prevData) => {
                    return prevData.map((order) => {
                        if (order.seqnum === updatedOrderdt.seqnum) {
                            return {
                                ...order,
                                orderStatus: updatedOrderdt.orderStatus,
                                productsDTO: (order.productsDTO || []).map((product) => {
                                    const updatedProduct = (updatedProducts || []).find((p) => p.seqnum === product.seqnum);
                                    return updatedProduct ? {...product, prodSt: updatedProduct.prodSt} : product;
                                })
                            };
                        }
                        return order;
                    });
                });
            })
            .catch((error) => {
                console.error('Error response:', error.response?.data || error.message);
                console.error('Status code:', error.response?.status);
                console.error('Headers:', error.response?.headers);
            })
    };

    const totalProdQyDv = ((cData) => {
        // 상품총수량(payinfo)
        return cData?.packListDTO?.productsDTO?.reduce((totalSum, item) => {
            if (item) {
                return totalSum + item.quantity;
            }
            return totalSum;
        }, 0);
    })

    /** endregion Event */

    const [scannedInvoiceNum, setScannedInvoiceNum] = useState("");
    const [scannedInvoices, setScannedInvoices] = useState([]);

    const handleInvoiceScanChange = (e) => {
        setScannedInvoiceNum(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter" && scannedInvoiceNum) {
            const matchingData = filteredList.find((cData) =>
                cData.productsDTO?.some(
                    (prod) => prod.inWaynum === scannedInvoiceNum.trim()
                )
            );

            if (matchingData) {
                // 스캔한 운송장 번호 추가
                setScannedInvoices((prev) => [...prev, scannedInvoiceNum.trim()]);

                // 모든 운송장 번호가 매칭되었는지 확인
                const allMatched = matchingData.productsDTO.every((prod) =>
                    [...scannedInvoices, scannedInvoiceNum.trim()].includes(prod.inWaynum)
                );

                if (allMatched) {
                    matchingData.productsDTO.forEach((prod) => {
                        handleProdStChange("delivery", prodStList[6], prod.seqnum);
                    });
                }
            }

            setScannedInvoiceNum(""); // 입력창 초기화
        }
    };

    const openDetailWindow = (orderNumber) => {
        window.open(`/btcorpad/orderdtmodi/${orderNumber}`, '_blank');
    };

    const handleViewDetail = (userName) => {
        const url = `/btcorpad/aduserinfo?search=${encodeURIComponent(userName)}`;
        window.open(url, '_blank'); // 새 탭에서 열기
    };

    // 배송료 세관내용 드랍다운팝업
    const [payDropSeqNum, setPayDropSeqNum] = useState(null); // 현재 팝업이 열린 데이터의 seqnum 저장
    const togglePopover = (id) => {
        if (togglePopover === id) {
            setPayDropSeqNum(null); // 이미 열려있으면 닫기
        } else {
            setPayDropSeqNum(id); // 해당 ID 열기
        }
    };
    const closePopover = (e) => {
        e.stopPropagation(); // 부모 클릭 이벤트 전파 방지
        setPayDropSeqNum(null);
    };

    return (
        <div className="AdminDashBoardPg">
            <div className="admin-wrap">
                <div className="AdminDashBoardSub">
                    <div className="admin-wrap-card dash-header">
                        <div className="display-flex flex-row align-center just-cont-sb" style={{padding: "0.8rem"}}>
                            <div className="display-flex just-cont-center wd-45pc">
                                <div className="status-card">
                                    <div className="card-img-warp">
                                        <div style={{display: "inline-block", width: "65px", height: "65px"}}>
                                            <img className="default-img" alt="" src={mypgOrder}/>
                                        </div>
                                    </div>
                                    <div className="m-b-15"><b className="c-def font-s-17 font-t-title" style={{
                                        textDecoration: "underline",
                                        textUnderlinePosition: "under"
                                    }}>주문</b></div>
                                    <div className="admin-status-ord font-t-cont">
                                        <div className="status-cont" onClick={() => selectNoDateTotalOrderList("OS00")}
                                             style={{
                                                 border: selectedProcessSt === "OS00" ? "solid 2px #FFAF34" : null,
                                                 borderRadius: selectedProcessSt === "OS00" ? "4px" : null
                                             }}>
                                            <a style={{cursor: "pointer"}}>입고대기</a>
                                            <div>
                                                <b style={{cursor: "pointer"}}>{processData.OS00 || 0}</b>
                                            </div>
                                        </div>
                                        <div className="status-cont" onClick={() => selectNoDateTotalOrderList("OS01")}
                                             style={{
                                                 border: selectedProcessSt === "OS01" ? "solid 2px" : null,
                                                 borderColor: selectedProcessSt === "OS01" ? "#FFAF34" : null
                                             }}>
                                            <a style={{cursor: "pointer"}}>결제대기</a>
                                            <div>
                                                <b style={{cursor: "pointer"}}>{processData.OS01 || 0}</b>
                                            </div>
                                        </div>
                                        <div className="status-cont" onClick={() => selectNoDateTotalOrderList("OS02")}
                                             style={{
                                                 border: selectedProcessSt === "OS02" ? "solid 2px" : null,
                                                 borderColor: selectedProcessSt === "OS02" ? "#FFAF34" : null
                                             }}>
                                            <a style={{cursor: "pointer"}}>결제중</a>
                                            <div>
                                                <b style={{cursor: "pointer"}}>{processData.OS02 || 0}</b>
                                            </div>
                                        </div>
                                        <div className="status-cont" onClick={() => selectNoDateTotalOrderList("OS03")}
                                             style={{
                                                 border: selectedProcessSt === "OS03" ? "solid 2px" : null,
                                                 borderColor: selectedProcessSt === "OS03" ? "#FFAF34" : null
                                             }}>
                                            <a style={{cursor: "pointer"}}>결제완료</a>
                                            <div>
                                                <b style={{cursor: "pointer"}}>{processData.OS03 || 0}</b>
                                            </div>
                                        </div>
                                        <div className="status-cont" onClick={() => selectNoDateTotalOrderList("OS04")}
                                             style={{
                                                 border: selectedProcessSt === "OS04" ? "solid 2px" : null,
                                                 borderColor: selectedProcessSt === "OS04" ? "#FFAF34" : null
                                             }}>
                                            <a style={{cursor: "pointer"}}>구매중</a>
                                            <div>
                                                <b style={{cursor: "pointer"}}>{processData.OS04 || 0}</b>
                                            </div>
                                        </div>
                                        <div className="status-cont" onClick={() => selectNoDateTotalOrderList("OS05")}
                                             style={{
                                                 border: selectedProcessSt === "OS05" ? "solid 2px" : null,
                                                 borderColor: selectedProcessSt === "OS05" ? "#FFAF34" : null
                                             }}>
                                            <a style={{cursor: "pointer"}}>구매완료</a>
                                            <div>
                                                <b style={{cursor: "pointer"}}>{processData.OS05 || 0}</b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="gbn-border"></div>
                                <div className="status-card">
                                    <div className="card-img-warp">
                                        <div style={{display: "inline-block", width: "65px", height: "65px"}}>
                                            <img className="default-img" alt="" src={mypgDelivery}/>
                                        </div>
                                    </div>
                                    <div className="m-b-15"><b className="c-def font-s-17 font-t-title" style={{
                                        textDecoration: "underline",
                                        textUnderlinePosition: "under"
                                    }}>배송</b></div>
                                    <div className="admin-status-ship font-t-cont">
                                        <div className="status-cont" onClick={() => selectNoDateTotalOrderList("OS06")}
                                             style={{
                                                 border: selectedProcessSt === "OS06" ? "solid 2px" : null,
                                                 borderColor: selectedProcessSt === "OS06" ? "#FFAF34" : null
                                             }}>
                                            <a style={{cursor: "pointer"}}>입고중</a>
                                            <div>
                                                <b style={{cursor: "pointer"}}>{processData.OS06 || 0}</b>
                                            </div>
                                        </div>
                                        <div className="status-cont" style={{
                                            border: selectedProcessSt === "OS07" ? "solid 2px" : null,
                                            borderColor: selectedProcessSt === "OS07" ? "#FFAF34" : null
                                        }} onClick={() => {
                                            selectNoDateTotalOrderList("OS07");
                                            setIsPackingFilter(false); // 👈 Packing 필터 비활성화
                                        }}>
                                            <a style={{cursor: "pointer"}}>센터도착</a>
                                            <div>
                                                <b style={{cursor: "pointer"}}>{processData.OS07 || 0}</b>
                                            </div>
                                        </div>
                                        <div className="status-cont" style={{
                                            border: selectedProcessSt === "OS08" ? "solid 2px" : null,
                                            borderColor: selectedProcessSt === "OS08" ? "#FFAF34" : null
                                        }} onClick={() => selectNoDateTotalOrderList("OS08")}>
                                            <a style={{cursor: "pointer"}}>패킹중</a>
                                            <div>
                                                <b style={{cursor: "pointer"}}>{processData.OS08 || 0}</b>
                                            </div>
                                        </div>
                                        <div className="status-cont" style={{
                                            border: selectedProcessSt === "PS0" ? "solid 2px" : null,
                                            borderColor: selectedProcessSt === "PS0" ? "#FFAF34" : null
                                        }} onClick={() => selectNoDateTotalOrderList("PS0")}>
                                            <a style={{cursor: "pointer"}}>결제대기</a>
                                            <div>
                                                <b style={{cursor: "pointer"}}>{processData.OS09 + processData.PS0 || 0}</b>
                                            </div>
                                        </div>
                                        <div className="status-cont" style={{
                                            border: selectedProcessSt === "PS1" ? "solid 2px" : null,
                                            borderColor: selectedProcessSt === "PS1" ? "#FFAF34" : null
                                        }} onClick={() => selectNoDateTotalOrderList("PS1")}>
                                            <a style={{cursor: "pointer"}}>결제중</a>
                                            <div>
                                                <b style={{cursor: "pointer"}}>{processData.OS10 + processData.PS1 || 0}</b>
                                            </div>
                                        </div>
                                        <div className="status-cont" style={{
                                            border: selectedProcessSt === "PS2" ? "solid 2px" : null,
                                            borderColor: selectedProcessSt === "PS2" ? "#FFAF34" : null
                                        }} onClick={() => selectNoDateTotalOrderList("PS2")}>
                                            <a style={{cursor: "pointer"}}>결제완료</a>
                                            <div>
                                                <b style={{cursor: "pointer"}}>{processData.OS11 + processData.PS2 || 0}</b>
                                            </div>
                                        </div>
                                        <div className="status-cont" style={{
                                            border: selectedProcessSt === "PS3" ? "solid 2px" : null,
                                            borderColor: selectedProcessSt === "PS3" ? "#FFAF34" : null
                                        }} onClick={() => selectNoDateTotalOrderList("PS3")}>
                                            <a style={{cursor: "pointer"}}>출고완료</a>
                                            <div>
                                                <b style={{cursor: "pointer"}}>{processData.OS12 + processData.PS3 || 0}</b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="gbn-border"></div>
                                <div className="status-card">
                                    <div className="card-img-warp">
                                        <div style={{display: "inline-block", width: "65px", height: "65px"}}>
                                            <img className="default-img" alt="" src={mypgReturn}/>
                                        </div>
                                    </div>
                                    <div className="m-b-15"><b className="c-def font-s-17 font-t-title" style={{
                                        textDecoration: "underline",
                                        textUnderlinePosition: "under"
                                    }}>반송</b></div>
                                    <div className="admin-status-return font-t-cont">
                                        <div className="status-cont" style={{
                                            border: selectedProcessSt === "PS4" ? "solid 2px" : null,
                                            borderColor: selectedProcessSt === "PS4" ? "#FFAF34" : null
                                        }} onClick={() => selectNoDateTotalOrderList("PS4")}>
                                            <a style={{cursor: "pointer"}}>반송중</a>
                                            <div>
                                                <b style={{cursor: "pointer"}}>{processData.OS13 + processData.PS4 || 0}</b>
                                            </div>
                                        </div>
                                        <div className="status-cont" style={{
                                            border: selectedProcessSt === "PS5" ? "solid 2px" : null,
                                            borderColor: selectedProcessSt === "PS5" ? "#FFAF34" : null
                                        }} onClick={() => selectNoDateTotalOrderList("PS5")}>
                                            <a style={{cursor: "pointer"}}>취소</a>
                                            <div>
                                                <b style={{cursor: "pointer"}}>{processData.OS14 + processData.PS5 || 0}</b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="wd-45pc">
                                <div className="board-lr">
                                    <div className="card-wrap-r"
                                         style={{borderTopLeftRadius: "10px", borderTopRightRadius: "10px"}}>
                                        <div>
                                            <div className="cooper-title text-center ht-30 p-t-3"
                                                 style={{borderTopLeftRadius: "10px", borderTopRightRadius: "10px",}}>
                                                <b className="font-c-white c-def font-t-title">공지사항</b>
                                            </div>
                                        </div>
                                        <div className="cooper-card-memo font-t-cont" style={{
                                            display: "block",
                                            position: "relative",
                                            overflowX: "hidden",
                                            overflowY: "auto",
                                            height: "270px",
                                            padding: "10px"
                                        }}>
                                            <table className="admin-tb">
                                                <tbody className="admin-tb-body">
                                                {data.map((cData, i) => {
                                                    return (
                                                        <tr className="admin-tb-body-line main-td-hover ht-35"
                                                            key={cData.coSeqNum}>
                                                            <td className="wd-40 p-t-3">
                                                                <input className="admin-input-chkBox-s m-0-a"
                                                                       type="checkbox" name={cData.coSeqNum}
                                                                       checked={noticeChecked.includes(cData.coSeqNum)}
                                                                       onChange={() => noticeCheckBoxChange(cData.coSeqNum)}
                                                                />
                                                            </td>
                                                            <td className="wd-40"><a>{i + 1}</a></td>
                                                            <td><p className="font-b font-s-13">{data[i].coopCont}</p>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div
                                            className="display-flex flex-row just-cont-sb dark-br-top font-t-cont wd-100pc gap5 ht-45 p-l-10 p-r-10">
                                            <input value={coopCont} onChange={Cont}
                                                   className="admin-input-line font-s-13 wd-80pc p-l-5 ht-30 m-t-7"
                                                   placeholder={"내용을 입력하세요.(50자 이내)"} type={"text"} maxLength={50}/>
                                            <button className="bt-btn-C wd-75 ht-30 font-s-13 btn-click-event m-t-7"
                                                    onClick={alert2}>삭제
                                            </button>
                                            <button className="bt-btn-D wd-75 ht-30 font-s-13 btn-click-event m-t-7"
                                                    onClick={coopSave}>등록
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="admin-wrap-card dash-cont">
                        <div className="status-board-work gap27">
                            <div className="display-flex flex-row just-cont-sb wd-100pc gap27 ht-180">
                                <div className="wd-65pc">
                                    <div
                                        className="service-card c-def ht-100pc display-flex flex-column just-cont-fstart text-center p-t-20">
                                        <div className="c-def font-t-title font-c-default font-s-20 m-b-10">Order &
                                            Payment
                                        </div>
                                        <div
                                            className="display-flex flex-row font-t-cont align-center just-cont-center p-t-20">
                                            <div className="display-flex c-point align-center"
                                                 style={{marginRight: "100px"}}
                                                 onClick={() => moveToAlarmListPg('order', lcNewOrdData.length)}>
                                                <p className="font-s-18 btorage-hover">신규주문</p>
                                                <div
                                                    className="main-value-badge text-center m-t-2 m-l-7">{lcNewOrdData.length || 0}</div>
                                            </div>
                                            <div className="display-flex c-point align-center"
                                                 onClick={() => moveToAlarmListPg('pay', lcPayData.length)}>
                                                <p className="font-s-18 btorage-hover">Pay</p>
                                                <div
                                                    className="main-value-badge text-center dark-font m-t-2 m-l-7">{lcPayData.length || 0}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="wd-35pc">
                                    <div
                                        className="service-card c-def ht-100pc display-flex flex-column just-cont-fstart text-center p-t-20">
                                        <div className="c-def font-t-title font-c-default font-s-20 m-b-17">Packing
                                        </div>
                                        <div className="display-flex flex-row font-t-cont align-center just-cont-ar">
                                            <div><PiPackageLight className="dark-icon font-s-45"/></div>
                                            <div>
                                                <b className={(processData.OS06 || processData.OS07) === 0 ? "font-s-40 c-point" : "real-text font-s-40 c-point"}
                                                   onClick={() => {
                                                       setIsPackingFilter(true);
                                                       if (processData.OS06 && processData.OS07) {
                                                           selectNoDateTotalOrderList("OS06");
                                                           selectNoDateTotalOrderList("OS07");
                                                       } else if (processData.OS06) {
                                                           selectNoDateTotalOrderList("OS06");
                                                       } else if (processData.OS07) {
                                                           selectNoDateTotalOrderList("OS07");
                                                       }
                                                   }}
                                                >
                                                    {packableCount || 0}
                                                    {/*{processData.OS06 || processData.OS07*/}
                                                    {/*    ? (parseInt(processData.OS06 || 0) + parseInt(processData.OS07 || 0))*/}
                                                    {/*    : 0}*/}
                                                </b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="display-flex flex-row just-cont-sb wd-100pc gap27">
                                <div className="wd-65pc display-flex flex-row just-cont-sb gap27 ht-180">
                                    <div className="wd-50pc">
                                        <div
                                            className="service-card c-def ht-100pc display-flex flex-column just-cont-fstart text-center p-t-20">
                                            <div
                                                className="c-def font-t-title font-c-default font-s-20 m-b-17">Request
                                            </div>
                                            <div
                                                className="display-flex flex-row font-t-cont align-center just-cont-ar p-l-30 p-r-30 p-t-20">
                                                <div className="display-flex c-point align-center"
                                                     onClick={() => navigate("/btcorpad/pickupwait")}>
                                                    <p className="font-s-18 btorage-hover">픽업신청</p>
                                                    <div
                                                        className="main-value-badge text-center dark-font m-t-2 m-l-7">{lcPickupData || 0}</div>
                                                </div>
                                                <div className="display-flex c-point align-center"
                                                     onClick={() => moveToAlarmListPg('deposit', lcDepositData.length)}>
                                                    <p className="font-s-18 btorage-hover">예치금신청</p>
                                                    <div
                                                        className="main-value-badge text-center dark-font m-t-2 m-l-7">{lcDepositData.length || 0}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="wd-50pc">
                                        <div
                                            className="service-card c-def ht-100pc display-flex flex-column just-cont-fstart text-center p-t-20">
                                            <div className="c-def font-t-title font-c-default font-s-20 m-b-17">Customer
                                                Service
                                            </div>
                                            <div
                                                className="display-flex flex-row font-t-cont align-center just-cont-ar p-l-30 p-r-30 p-t-20">
                                                <div className="display-flex c-point align-center"
                                                     onClick={() => moveToAlarmListPg('review', lcReviewData.length)}>
                                                    <p className="font-s-18 btorage-hover">이용후기</p>
                                                    <div
                                                        className="main-value-badge text-center dark-font m-t-2 m-l-7">{lcReviewData.length || 0}</div>
                                                </div>
                                                <div className="display-flex c-point align-center"
                                                     onClick={() => navigate("/btcorpad/adminorderchat")}>
                                                    <p className="font-s-18 btorage-hover">실시간채팅</p>
                                                    <div
                                                        className="main-value-badge text-center dark-font m-t-2 m-l-7">{lcChatData || 0}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="wd-35pc">
                                    <div className="wd-100pc ht-180">
                                        <div
                                            className="service-card c-def ht-100pc display-flex flex-column just-cont-fstart text-center p-t-20">
                                            <div
                                                className="c-def font-t-title font-c-default font-s-20 m-b-17">Receipt
                                            </div>
                                            <div
                                                className="display-flex flex-row font-t-cont align-center just-cont-ar">
                                                <div><PiAirplaneTakeoff className="dark-icon font-s-45"/></div>
                                                <div>
                                                    <Link className="font-b font-s-40" to="/btcorpad/receiptlist"
                                                          style={{color: ordReceiptCountData === 0 ? '#5B5B5B' : '#FFAF34'}}>
                                                        {ordReceiptCountData}
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {alertShow === true ?
                        <MsgSelectModal alertShow={alertShow} eventHandle1={modalCancel} eventHandle2={coopSave}
                                        msgData1={msgConfirmData1} msgData2={msgConfirmData2}/> : null}
                    {alertShow2 === true ?
                        <MsgSelectModal alertShow={alertShow2} eventHandle1={modalCancel2} eventHandle2={coopDataDelete}
                                        msgData1={msgConfirmData3} msgData2={msgConfirmData4}/> : null}
                </div>
                <div>
                    <div className="admin-wrap-card">
                        <section className="dash-cont">
                            <div className="status-board-order">
                                <Tabs className="ord-tab" defaultActiveKey="tab-task">
                                    <Tab className="tab-task" eventKey="tab-task" title="진행주문서">
                                        <div className="AdminOrdList">
                                            <div>
                                                <div className="admin-event-wrap"
                                                     style={{padding: "17px 10px 0 10px", marginBottom: "33px"}}>
                                                    <div className="admin-event-wrap-btn font-t-cont m-t-3">
                                                        <AdminPageEvent perPg={perPg}
                                                                        handleSelectChange={handleSelectChange}/>
                                                        {/*
                                                          * 조회 전건수 / 화면에 그려진 행수. (필요하면 주석을 풀어 쓴다)
                                                          * 가상스크롤이라 화면에는 일부만 떠 있지만, 전체선택과 엑셀은
                                                          * 항상 '조회' 건수 전체를 대상으로 한다.
                                                          */}
                                                        {/*<div className="font-t-cont m-r-15 font-s-13"*/}
                                                        {/*     style={{display: "flex", alignItems: "center", color: "#7a7a7a"}}>*/}
                                                        {/*    <span>조회&nbsp;<b style={{color: "#FFAF34"}}>{filteredList.length.toLocaleString()}</b>건</span>*/}
                                                        {/*    {(hasRowsAbove || hasRowsBelow) && (*/}
                                                        {/*        <span style={{marginLeft: "6px"}}>*/}
                                                        {/*            (화면 {windowRows.length.toLocaleString()}건 표시 · 스크롤 시 추가)*/}
                                                        {/*        </span>*/}
                                                        {/*    )}*/}
                                                        {/*</div>*/}
                                                        <AdminYmdEvent startDate={startDate} endDate={endDate}
                                                                       startHandle={startHandle} endHandle={endHandle}/>
                                                        <div style={{marginRight: "15px"}}>
                                                            <select
                                                                onChange={handleRangeChange}
                                                                defaultValue="2개월"
                                                                className="admin-combo wd-110 font-s-14 p-l-7 ht-30">
                                                                <option>1개월</option>
                                                                <option>2개월</option>
                                                                <option>3개월</option>
                                                                <option>6개월</option>
                                                                <option>1년</option>
                                                                <option>2년</option>
                                                                <option>5년</option>
                                                                <option>10년</option>
                                                            </select>
                                                        </div>
                                                        <div style={{marginRight: "15px"}}>
                                                            <select onChange={(e) => setOrderType(e.target.value)}
                                                                    value={orderType}
                                                                    className="admin-combo wd-110 font-s-14 p-l-7 ht-30 font-t-cont">
                                                                <option value="주문유형">주문유형</option>
                                                                <option value="주문서">주문서</option>
                                                                <option value="배송료">배송료</option>
                                                            </select>
                                                        </div>
                                                        <div style={{marginRight: "15px"}}>
                                                            <select className="admin-combo wd-110 ht-30 p-l-7 font-s-14"
                                                                    onChange={(e) => setSelectedShipCompany(e.target.value)}
                                                                    value={selectedShipCompany}>
                                                                <option value="배송사선택">배송사선택</option>
                                                                <option value="FedEx">FedEx</option>
                                                                <option value="FedEx">FedEx-E</option>
                                                                <option value="UPS">UPS</option>
                                                                <option value="UPS">UPS-E</option>
                                                                <option value="EMS">EMS</option>
                                                                <option value="EMSP">EMSP</option>
                                                                <option value="SEA">SEA</option>
                                                                <option value="국내배송">국내배송</option>
                                                                {/*<option value="DHL">DHL</option>*/}
                                                                <option value="K-Packet">K-Packet</option>
                                                                <option value="Small-Packet">Small-Packet</option>
                                                            </select>
                                                        </div>
                                                        <div style={{marginRight: "15px"}}>
                                                            <select className="admin-combo wd-110 ht-30 p-l-7 font-s-14"
                                                                    onChange={(e) => setOrderStSelectCommonValue(e.target.value)}
                                                                    value={orderStSelectCommonValue}>
                                                                <option value="상태(전체)">상태(전체)</option>
                                                                <option value="OS00">입고대기</option>
                                                                <option value="OS01">결제대기(상품)</option>
                                                                <option value="OS02">결제중(상품)</option>
                                                                <option value="OS03">결제완료(상품)</option>
                                                                <option value="OS04">구매중</option>
                                                                <option value="OS05">구매완료</option>
                                                                <option value="OS06">입고중</option>
                                                                <option value="OS07">센터도착</option>
                                                                <option value="OS08">패킹중</option>
                                                                <option value="PS0">결제대기(배송)</option>
                                                                <option value="PS1">결제중(배송)</option>
                                                                <option value="PS2">결제완료(배송)</option>
                                                                <option value="PS3">출고완료</option>
                                                                <option value="PS4">반송중</option>
                                                                <option value="PS5">취소</option>
                                                            </select>
                                                        </div>
                                                        <AdminSearchEvent searchInput={searchInput}
                                                                          handleSearchInputChange={handleSearchInputChange}/>
                                                    </div>
                                                    <div className="admin-event-wrap-btn gap10">
                                                        {errorInvoiceMsg && (<p className="font-s-13 m-t-4"
                                                                                style={{color: "red"}}>{errorInvoiceMsg}</p>)}
                                                        <button onClick={invoiceDown}
                                                                className="bt-btn-E wd-100 ht-30 font-s-13 btn-click-event">INVOICE
                                                        </button>
                                                        <button onClick={excelDown} disabled={excelLoading}
                                                                className="bt-btn-E wd-100 ht-30 font-s-13 btn-click-event">EXCEL[주문서]
                                                        </button>
                                                        <button onClick={customExcelDown}
                                                                className="bt-btn-E wd-150 ht-30 font-s-13 btn-click-event">EXCEL[세관신고]
                                                        </button>
                                                    </div>
                                                </div>
                                                <Table className="ord-main-tb admin-tb font-t-cont" bordered
                                                       ref={vsListRef}>
                                                    <thead ref={orderContentRef} className="ord-main-tb-head">
                                                    <tr className="ord-main-tb-head-line">
                                                        <th className="wd-35">
                                                            <li><input className="admin-input-chkBox" type="checkbox"
                                                                       checked={checkedKeys.length > 0 && checkedKeys.length === filteredList.length}
                                                                       onChange={allcheckBoxChange}/></li>
                                                        </th>
                                                        <th style={{width: "180px"}}>
                                                            <li>
                                                                <b>주문번호</b>
                                                                <b>주문서유형</b>
                                                            </li>
                                                        </th>
                                                        {/*<th style={{width: "80px"}}>*/}
                                                        {/*    <li><b>주문유형</b></li>*/}
                                                        {/*</th>*/}
                                                        <th style={{width: "150px"}}>
                                                            <li>
                                                                <b>사서함번호</b>
                                                                <b>고객명</b>
                                                                <b>수취인성함</b>
                                                            </li>
                                                        </th>
                                                        <th style={{width: "120px"}}>
                                                            <li>
                                                                <b>국가</b>
                                                                <b>CS언어</b>
                                                            </li>
                                                        </th>
                                                        <th style={{width: "165px"}}>
                                                            <li><b>상품명</b></li>
                                                        </th>
                                                        <th style={{width: "100px"}}>
                                                            <li>
                                                                <b>상태</b>
                                                            </li>
                                                        </th>
                                                        <th style={{width: "140px"}}>
                                                            <li>
                                                                <b>배송사</b>
                                                                <b>운송장번호</b>
                                                            </li>
                                                        </th>
                                                        <th style={{width: "110px"}}>
                                                            <li>
                                                                <b>세관신고수량</b>
                                                                <b>세관신고금액</b>
                                                                <b>보험여부</b>
                                                                <b>내용품명</b>
                                                            </li>
                                                        </th>
                                                        <th style={{width: "100px"}}>
                                                            <li>
                                                                <b>상품미결제</b>
                                                                <b>상품총결제</b>
                                                                <b>기타미결제</b>
                                                                <b>기타총결제</b>
                                                            </li>
                                                        </th>
                                                        <th style={{width: "100px"}}>
                                                            <li><b>상품수량</b></li>
                                                            <li><b>예치금</b></li>
                                                            <li><b>적립금</b></li>
                                                        </th>
                                                        <th style={{width: "120px"}}>
                                                            <li>
                                                                <b>작성일시</b>
                                                                <b>수정일시</b>
                                                                <b>출고일시</b>
                                                                <b>패킹일시</b>
                                                            </li>
                                                        </th>
                                                        <th style={{width: "100px"}}>
                                                            <li><b>System</b></li>
                                                        </th>
                                                    </tr>
                                                    </thead>
                                                    {/*
                                                      * 가상스크롤 - 위쪽에서 떼어낸 행들의 자리를 메우는 여백.
                                                      * 높이는 '그 행들을 실제로 그렸을 때 재둔 높이의 합' 이라서
                                                      * 떼어내도 스크롤 위치가 1px 도 움직이지 않는다.
                                                      */}
                                                    {topSpacerPx > 0 && (
                                                        <tbody key="vs-spacer-top" className="vs-spacer">
                                                        <tr style={{height: `${topSpacerPx}px`}}>
                                                            <td colSpan={12} style={{height: `${topSpacerPx}px`}}/>
                                                        </tr>
                                                        </tbody>
                                                    )}

                                                    {/* 위로 스크롤하면 이 줄이 보이는 순간 떼어낸 행을 다시 붙인다 */}
                                                    {hasRowsAbove && (
                                                        <tbody key="vs-sentinel-top" className="vs-sentinel-group">
                                                        <tr ref={vsTopSentinelRef}>
                                                            <td colSpan={12}>
                                                                <div className="vs-sentinel">
                                                                    <span className="vs-dot"/>
                                                                    <span className="vs-dot"/>
                                                                    <span className="vs-dot"/>
                                                                    <em>이전 {winStart.toLocaleString()}건</em>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    )}

                                                    {/*
                                                      * 가상스크롤: 화면 주변의 행만 그린다.
                                                      * cData 와 함께 '페이지 기준 원래 인덱스 i' 를 받아서 쓴다.
                                                      * i 는 key 외에도 isOpenCartItemDt[i] / selectedItems.cart[i] /
                                                      * handleCheckAll(..., i, ...) 의 키라서 반드시 원래값이어야 한다.
                                                      */}
                                                    {windowRows.map(({cData, i}) => {
                                                        let totalP05Count = 0;
                                                        let uniqueBoxCount = 0;

                                                        // const key = cData.seqnum || i; // 2개 다 쓸 경우 중복오류 발생가능있음
                                                        const key = i;
                                                        let data1 = 0, data2 = 0, data3 = 0, data4 = 0;
                                                        let totalProdQy = 0;

                                                        if (cData.type === 'orderdt') {
                                                            // ✅ 상품결제금액 현황
                                                            // 상품미결제 + 관리자가 등록한 상품누락금 미결제에 추가
                                                            data1 = cData.productsDTO?.reduce((sum, item) => {
                                                                return (item.prodSt === "IS01" || item.prodSt === "IS02") && item.price > 0 ? sum + item.price + item.mallShipPrice + item.fee : sum;
                                                            }, 0) || 0;
                                                            data1 += cData.payInfoDTO?.reduce((sum, item) => {
                                                                return (item.payStatus === "PS0" || item.payStatus === "PS1") && item.payClass === '1'
                                                                && item.ttProdExpense > 0 ? sum + item.ttProdExpense : sum;
                                                            }, 0) || 0;
                                                            // 상품총결제 + 관리자가 등록한 상품누락금 결제완료에 추가
                                                            data2 = cData.productsDTO?.reduce((sum, item) => {
                                                                return item.prodSt !== "IS01" && item.prodSt !== "IS02" && item.prodSt !== "IS12" && item.price > 0 ? sum + item.price + item.mallShipPrice + item.fee : sum;
                                                            }, 0) || 0;
                                                            data2 += cData.payInfoDTO?.reduce((sum, item) => {
                                                                return item.payStatus !== "PS0" && item.payStatus !== "PS1" && item.payClass === '1'
                                                                && item.ttProdExpense > 0 ? sum + item.ttProdExpense : sum;
                                                            }, 0) || 0;
                                                            // 기타미결제
                                                            data3 = cData.payInfoDTO?.reduce((sum, item) => {
                                                                if ((item.payStatus === "PS0" || item.payStatus === "PS1") && item.payClass === '1') {
                                                                    // payStatus가 PS0 또는 PS1일 때 ttEtcPrice와 ttEtcFee(있을 경우)를 더함
                                                                    const etcPrice = item.ttEtcPrice > 0 ? item.ttEtcPrice : 0;
                                                                    const etcFee = item.ttEtcFee > 0 ? item.ttEtcFee : 0;
                                                                    return sum + etcPrice + etcFee;
                                                                }
                                                                return sum;
                                                            }, 0) || 0;
                                                            // 기타총결제
                                                            data4 = cData?.payInfoDTO?.reduce((sum, item) => {
                                                                if ((item.payStatus !== "PS0" && item.payStatus !== "PS1") && item.payClass === '1') {
                                                                    // payStatus가 PS0 또는 PS1일 때 ttEtcPrice와 ttEtcFee(있을 경우)를 더함
                                                                    const etcPrice = item.ttEtcPrice > 0 ? item.ttEtcPrice : 0;
                                                                    const etcFee = item.ttEtcFee > 0 ? item.ttEtcFee : 0;
                                                                    return sum + etcPrice + etcFee;
                                                                }
                                                                return sum;
                                                            }, 0) || 0;
                                                            // 상품총수량(orderdt)
                                                            totalProdQy = cData?.productsDTO?.reduce((sum, item) => {
                                                                return sum + item.quantity;
                                                            }, 0) || 0;

                                                            // ✅ 배송대행 중복제거된 박스개수 표시
                                                            const p05Products = cData.productsDTO.filter(prod => prod.prodTy === "P05");
                                                            totalP05Count = p05Products.length;
                                                            // inWaynum이 null이면 1개로 간주
                                                            const nullInWaynumCount = p05Products.filter(prod => !prod.inWaynum).length;
                                                            const validInWaynums = p05Products
                                                                .map(prod => prod.inWaynum)
                                                                .filter(waynum => waynum); // 중복 트래킹번호 제거

                                                            // Set을 사용하여 cData orderdt 전체데이터 기준 중복제거한 배송대행의 최종박스개수
                                                            const uniqueValidInWaynumCount = new Set(validInWaynums).size; // inWaynum 중복제거된 박스개수
                                                            uniqueBoxCount = nullInWaynumCount + uniqueValidInWaynumCount; // inWaynum이 null인 박스개수(null은 무조건 1박스로 간주)

                                                        }
                                                        // data-vs-row: 가상스크롤이 이 행의 실제 높이를 재는 표식
                                                        return cData.type === 'orderdt' ? (
                                                                <tbody className="ord-main-tb-body" key={key}
                                                                       data-vs-row={i}>
                                                                <tr className="ord-main-tb-body-line">
                                                                    <td>
                                                                        <li>
                                                                            <input className="admin-input-chkBox"
                                                                                   type="checkbox" name={cData.seqnum}
                                                                                   checked={checkedKeySet.has(makeCheckKey('orderdt', cData.seqnum))}
                                                                                   onChange={() => checkBoxChange(cData.seqnum, 'orderdt')}/>
                                                                        </li>
                                                                    </td>
                                                                    <td>
                                                                        <li style={{alignItems: "center"}}>
                                                                            <img className="wd-20 ht-20"
                                                                                 alt="" src={orderIMG}
                                                                                 style={{margin: "5px 0"}}/>
                                                                            <p className="font-s-13 font-b">{cData.orderNumber}</p>
                                                                            <p className="font-b m-t-2 font-s-14">주문서</p>
                                                                            <span style={{
                                                                                display: "flex",
                                                                                flexDirection: "row",
                                                                                marginTop: "15px"
                                                                            }}>
                                                                                <a>
                                                                                    <button
                                                                                        onClick={() => openDetailWindow(cData.orderNumber)}
                                                                                        className="admin-btn-B wd-45 ht-30 m-t-3 m-r-5 btn-click-event">상세</button>
                                                                                </a>
                                                                                <button
                                                                                    onClick={() => toggleMenu(cData.seqnum)}
                                                                                    className="admin-btn-B wd-45 ht-30 m-t-3">
                                                                                    {cData.isOpen ?
                                                                                        <FiMinus
                                                                                            className="dt-click"/> :
                                                                                        <FiPlus className="dt-click"/>
                                                                                    }
                                                                                </button>
                                                                            </span>
                                                                        </li>
                                                                    </td>
                                                                    <td>
                                                                        <li className="position-relative">
                                                                            <a>BT{cData.memberDTO.mbNum}</a>{/* [구매대행 API] 쇼핑몰 API 연동 가입회원 표시 */}<ApiJoinBadge apiJoinFl={cData.memberDTO.apiJoinFl}/>
                                                                            <div
                                                                                className="display-flex flex-row just-cont-center">
                                                                                <p className="font-b c-point font-s-14 btorage-hover"
                                                                                   onClick={() => toggleInfoMenu(cData.seqnum, 'info')}
                                                                                   style={{color: infoToggleSt[cData.seqnum] ? "#FFAF34" : ""}}>
                                                                                    {cData.memberDTO.userName}
                                                                                </p>
                                                                                {cData.memberDTO.spfRegName && cData.memberDTO.spfRegName.trim() && (
                                                                                    <p className="m-l-5 font-s-10 c-def p-t-2">🚨</p>
                                                                                )}
                                                                            </div>
                                                                            {infoToggleSt[cData.seqnum] && (
                                                                                <div
                                                                                    className="user-dt-info-container font-s-13 pd12 c-def"
                                                                                    ref={menuRef}>
                                                                                    <div
                                                                                        className="display-flex flex-column">
                                                                                        <div className="m-b-7">
                                                                                            <p className="text-left c-point btorage-hover"
                                                                                               onClick={() => handleViewDetail(cData.memberDTO.userName)}>
                                                                                                상세정보보기 <IoIosArrowDropright
                                                                                                className="font-s-15"/>
                                                                                            </p>
                                                                                        </div>
                                                                                        <div
                                                                                            className="display-flex flex-column text-left just-cont-sb gap5">
                                                                                            <div
                                                                                                className="display-flex flex-row wd-100pc">
                                                                                                <p className="wd-35">계정:</p>
                                                                                                <p className="wd-auto">{cData.memberDTO.id}</p>
                                                                                                {!copiedIndexes.includes(i) && (
                                                                                                    <RxCopy
                                                                                                        className="m-l-7 font-s-18 c-point btorage-hover btn-click-event m-a-opc-07"
                                                                                                        onClick={() => handleCopy(cData.memberDTO.id.trim(), i)}/>
                                                                                                )}
                                                                                                {copiedIndexes.includes(i) &&
                                                                                                    <RxCheck
                                                                                                        className="m-l-7 font-s-18 font-c-btorage m-a-opc-07"/>}
                                                                                            </div>
                                                                                            <div
                                                                                                className="display-flex flex-row wd-100pc">
                                                                                                <p className="wd-35">@@:</p>
                                                                                                <p className="display-flex wd-auto ht-auto font-c-progress font-b">{cData.memberDTO.spfRegName}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                            <a style={{
                                                                                display: 'inline-block',
                                                                                maxWidth: '200px',
                                                                                overflowWrap: 'break-word',
                                                                                wordBreak: 'break-word',
                                                                                whiteSpace: 'normal',
                                                                                verticalAlign: 'middle',
                                                                                textAlign: 'center'
                                                                            }}>{cData.recinfoDTO.recname}</a>
                                                                        </li>
                                                                    </td>
                                                                    <td>
                                                                        <li>
                                                                            <a className="font-b">{cData.recinfoDTO.countryDTO.countryNm + "[" + cData.recinfoDTO.countryDTO.countryCode + "]"}</a>
                                                                            <a>{cData.memberDTO.lang}</a>
                                                                        </li>
                                                                    </td>
                                                                    <td>
                                                                        <li className="admin-tb-text-cut">
                                                                            {cData && cData.productsDTO && cData.productsDTO.length > 0 && (
                                                                                <div>
                                                                                    {cData.productsDTO.sort((a, b) => a.seqnum - b.seqnum).slice(0, 6).map((product, index) => (
                                                                                        <div key={index}>
                                                                                            <a>{product.name}</a>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            )}
                                                                        </li>
                                                                    </td>
                                                                    <td>
                                                                        <li>
                                                                            <a className="font-b">
                                                                                {orderStPrint(cData.orderStatus)}
                                                                            </a>
                                                                        </li>
                                                                    </td>
                                                                    <td>
                                                                        <li style={{alignItems: "center"}}>
                                                                            <a>{cData.shipco}</a>
                                                                            {/*국내운송장 등록*/}
                                                                            {cData.shipco === "국내배송" && cData.orderStatus === "OS12" ?
                                                                                <div className="flex-column">
                                                                                    <a onClick={() => selectDsTrackNum(cData.shipco, cData.outWaynum)}
                                                                                       className="font-b c-point font-c-progress text-underline">{cData.outWaynum}</a>
                                                                                    <div>
                                                                                        <RxCopy
                                                                                            className="font-s-18 c-point btorage-hover btn-click-event"
                                                                                            style={{opacity: "0.65"}}
                                                                                            onClick={() => handleCopy(cData?.outWaynum)}/>
                                                                                        <MdOutlineChangeCircle
                                                                                            className="m-l-3 font-s-20 c-point btorage-hover btn-click-event m-a-opc-07"
                                                                                            onClick={() => handleChangeValue(cData.seqnum, 'ds', cData.outWaynum)}/>
                                                                                    </div>
                                                                                </div>
                                                                                :
                                                                                null
                                                                            }
                                                                        </li>
                                                                    </td>
                                                                    <td>
                                                                        <li className="admin-tb-text-cut">
                                                                            {totalProdQy > 0 ?
                                                                                <a>{totalProdQy}개</a>
                                                                                :
                                                                                <a>0</a>
                                                                            }
                                                                        </li>
                                                                    </td>
                                                                    <td>
                                                                        <li>
                                                                            <a style={{
                                                                                lineHeight: "24px",
                                                                                color: data1 > 0 ? "darkorange" : "black",
                                                                                fontWeight: data1 > 0 ? "bold" : "normal"
                                                                            }}>
                                                                                {data1 > 0 ? data1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "-"}
                                                                            </a>
                                                                            <a style={{lineHeight: "24px"}}>
                                                                                {data2 > 0 ? data2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "-"}
                                                                            </a>
                                                                            <a style={{
                                                                                lineHeight: "24px",
                                                                                color: data3 > 0 ? "darkorange" : "black",
                                                                                fontWeight: data3 > 0 ? "bold" : "normal"
                                                                            }}>
                                                                                {data3 > 0 ? data3.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "-"}
                                                                            </a>
                                                                            <a style={{lineHeight: "24px"}}>
                                                                                {data4 > 0 ? data4.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "-"}
                                                                            </a>
                                                                        </li>
                                                                    </td>
                                                                    <td>
                                                                        {totalProdQy > 0 ?
                                                                            <a style={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center"
                                                                            }}>{totalProdQy}개</a>
                                                                            :
                                                                            <a style={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center"
                                                                            }}>0개</a>
                                                                        }
                                                                        <div style={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            margin: "5px 0 0 2px"
                                                                        }}>
                                                                            <img style={{width: "18px", height: "18px"}}
                                                                                 alt="deposit" src={deposit}/>
                                                                            <a style={{
                                                                                color: cData.memberDTO.deposit < 0 ? "#FF6628" : "black",
                                                                                marginLeft: "4px"
                                                                            }}>
                                                                                {cData.memberDTO.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                            </a>
                                                                        </div>
                                                                        <div style={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            marginLeft: "3px"
                                                                        }}>
                                                                            <img style={{width: "16px", height: "16px"}}
                                                                                 alt="point" src={point}/>
                                                                            <a style={{
                                                                                color: cData.memberDTO.point < 0 ? "#FF6628" : "black",
                                                                                marginLeft: "5px"
                                                                            }}>
                                                                                {cData.memberDTO.point.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                            </a>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <li>
                                                                            <a style={{lineHeight: "28px"}}>{formatDateTime(cData.regTime)}</a>
                                                                            <a className="font-b"
                                                                               style={{lineHeight: "28px"}}>{cData.modiTime ? formatDateTime(cData.modiTime) : "-"}</a>
                                                                            <a style={{lineHeight: "28px"}}>{cData?.shipTime ? formatDateTime(cData?.shipTime) : "-"}</a>
                                                                            {/* 주문서 패킹일시는 PayInfo 양식이라 현재 항상 "-"임 */}
                                                                            <a style={{lineHeight: "28px"}}>{cData.shipInfoDTO?.regTime ? formatDateTime(cData.shipInfoDTO.regTime) : "-"}</a>
                                                                        </li>
                                                                    </td>
                                                                    <td>
                                                                        <li className="align-center gap6">
                                                                            <button
                                                                                onClick={() => openModalMerge(cData)}
                                                                                className="admin-btn-A wd-75 ht-30 font-s-12 btn-click-event">통합
                                                                            </button>
                                                                            {cData.orderStatus !== "OS12" &&
                                                                                <button
                                                                                    onClick={() => openModalDivide(cData)}
                                                                                    className="admin-btn-A wd-75 ht-30 font-s-12 btn-click-event">분리</button>
                                                                            }
                                                                            {cData.type === "orderdt" &&
                                                                                <button
                                                                                    onClick={() => openModal(cData, 'orderdt')}
                                                                                    className="admin-btn-A wd-75 ht-30 font-s-12 btn-click-event">
                                                                                    비용등록
                                                                                </button>
                                                                            }
                                                                        </li>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan="12">
                                                                        <div className="cont-dt">

                                                                            <span className="dt-option">
                                                                                <a className="c-def dark-font">요청옵션 : </a>
                                                                                {(() => {
                                                                                    const options = [];
                                                                                    if (cData.reqmnDTO.tagRemove) options.push('택제거');
                                                                                    if (cData.reqmnDTO.shoesBoxRemove) options.push('신발박스제거');
                                                                                    if (cData.reqmnDTO.hangerRemove) options.push('옷걸이제거');
                                                                                    if (cData.reqmnDTO.compressionPack) options.push('압축팩서비스');
                                                                                    if (cData.reqmnDTO.prodBoxRemove) options.push('부피 큰 제품박스만 제거');
                                                                                    if (cData.reqmnDTO.packingHold) options.push('요청 시까지 패킹보류');
                                                                                    if (cData.reqmnDTO.shipPriceDepositpay) options.push('해외배송비 자동 예치금결제');
                                                                                    if (cData.reqmnDTO.shipPriceMessenger) options.push('해외배송비 메신저안내');
                                                                                    if (cData.reqmnDTO.cusPrepayFl) options.push('관부가세선납');

                                                                                    return options.length > 0
                                                                                        ?
                                                                                        <a style={{color: "#EB939D"}}>&nbsp;{options.join(' / ')}&nbsp;</a>
                                                                                        : null;
                                                                                })()}
                                                                            </span>

                                                                            <span className="dt-req display-flex align-items-start wd-100pc">
                                                                                <a className="c-def dark-font"
                                                                                   style={{flexShrink: 0}}>요청상세 :&nbsp;</a>
                                                                                <a style={{
                                                                                    color: "#7C9EDC",
                                                                                    flex: 1,
                                                                                    minWidth: 0,
                                                                                    whiteSpace: "pre-wrap",
                                                                                    wordBreak: "break-word",
                                                                                    overflowWrap: "anywhere",
                                                                                    lineHeight: "20px",
                                                                                    }}>&nbsp;{cData.reqmnDTO?.detailReq}
                                                                                </a>
                                                                            </span>

                                                                            <span
                                                                                className="dt-memo mt-1 display-flex align-items-center">
                                                                                <a className="c-def dark-font">주문서메모 :&nbsp;</a>
                                                                                <input
                                                                                    className="admin-common-input"
                                                                                    type="text" maxLength={500}
                                                                                    onKeyDown={(e) => onKeyPress(e, cData.seqnum, 'orderMemoDTO')}
                                                                                    value={memoModiData[`${cData.seqnum}-orderMemoDTO`] ?? cData?.orderMemoDTO?.ordDtCont ?? ''}
                                                                                    onChange={(e) => handleInputMemoChange(e, cData.seqnum, 'orderMemoDTO')}
                                                                                    ref={(el) => (inputRefs.current[cData.seqnum] = el)}
                                                                                />
                                                                            </span>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                {cData.isOpen && (
                                                                    <tr>
                                                                        <td colSpan="12">
                                                                            <div id="ord-dt-tb-wrap"
                                                                                 style={{marginBottom: "15px"}}>
                                                                                <div className="admin-ord-ctg">
                                                                                    <div
                                                                                        className="admin-ord-ctg-wrap c-point"
                                                                                        onClick={() => toggleMenuDTcartFn(i, cData.productsDTO.filter(prod => prod.prodTy === "P00").length)}>
                                                                                        {isOpenCartItemDt[i] ?
                                                                                            <i className="ord-accordion-icon"
                                                                                               style={{transform: "rotate(90deg)"}}/> :
                                                                                            <i className="ord-accordion-icon"></i>
                                                                                        }
                                                                                        <a className="dark-font font-s-14">장바구니</a>
                                                                                        <a style={{
                                                                                            color: cData.productsDTO.filter(prod => prod.prodTy === "P00").length === 0 ? "dimgrey" : "darkorange",
                                                                                            fontWeight: "bold",
                                                                                            marginLeft: "5px"
                                                                                        }}>{cData.productsDTO.filter(prod => prod.prodTy === "P00").length}
                                                                                        </a>
                                                                                    </div>
                                                                                    <div
                                                                                        className={isOpenCartItemDt[i] ? "order-dt-close" : "order-dt-open"}>
                                                                                        <Table striped bordered hover
                                                                                               style={{tableLayout: "fixed"}}>
                                                                                            <thead
                                                                                                className="tb-head-td-title">
                                                                                            <tr className="tb-head-title-line">
                                                                                                <th className="tb-head-cont-line-l"
                                                                                                    style={{width: "30px"}}>
                                                                                                    <li><input
                                                                                                        className="admin-input-chkBox"
                                                                                                        type="checkbox"
                                                                                                        onChange={e => handleCheckAll('cart', i, e.target.checked, cData.productsDTO)}
                                                                                                        checked={selectedItems.cart[i] ? selectedItems.cart[i].length === cData.productsDTO.filter(prod => prod.prodTy === "P00").length : false}
                                                                                                    /></li>
                                                                                                </th>
                                                                                                <th style={{width: "40px"}}>
                                                                                                    <li><b>품번</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "90px"}}>
                                                                                                    <li><b>사진</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "180px"}}>
                                                                                                    <li><b>ID / URL</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "340px"}}>
                                                                                                    <li><b>상품메모</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "260px"}}>
                                                                                                    <li><b>패스워드</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "50px"}}>
                                                                                                    <li><b>수량</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "100px"}}>
                                                                                                    <li><b>장바구니금액</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "80px"}}>
                                                                                                    <li><b>쇼핑몰배송비</b></li>
                                                                                                </th>
                                                                                                <th className="tb-head-cont-line-r"
                                                                                                    style={{width: "150px"}}>
                                                                                                    <li><b>개별현황</b></li>
                                                                                                </th>
                                                                                            </tr>
                                                                                            </thead>
                                                                                            {/*장바구니상품*/}
                                                                                            {cData.productsDTO.filter(prod => prod.prodTy === "P00").sort((a, b) => a.seqnum - b.seqnum).map((cart, index) => (
                                                                                                <tbody key={index}
                                                                                                       className="tb-head-cont-dt">
                                                                                                <tr className="tb-head-cont-line">
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <input
                                                                                                                onChange={e => handleCheckItem('cart', i, cart.seqnum, e.target.checked)}
                                                                                                                checked={selectedItems.cart[i] ? selectedItems.cart[i].includes(cart.seqnum) : false}
                                                                                                                className="admin-input-chkBox"
                                                                                                                type="checkbox"/>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">{index + 1}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <span
                                                                                                                className="ord-prod-img">
                                                                                                                <img
                                                                                                                    className="ord-prod-img-file"
                                                                                                                    src={BtorageWriteLogo}
                                                                                                                    alt="admin-logo"/>
                                                                                                            </span>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b"
                                                                                                            href={cart.url}
                                                                                                            target="_blank">{cart.name}</a>
                                                                                                        </li>
                                                                                                        <li style={{width: "100%"}}>
                                                                                                            <a
                                                                                                                href={cart.url}
                                                                                                                target="_blank"
                                                                                                                className="font-b"
                                                                                                                style={{
                                                                                                                    display: "-webkit-box",
                                                                                                                    WebkitBoxOrient: "vertical",
                                                                                                                    WebkitLineClamp: 3,
                                                                                                                    overflow: "hidden",
                                                                                                                    textOverflow: "ellipsis",

                                                                                                                    whiteSpace: "normal",
                                                                                                                    wordBreak: "break-all",
                                                                                                                    overflowWrap: "anywhere",

                                                                                                                    maxWidth: "500px",
                                                                                                                    width: "100%",

                                                                                                                    lineHeight: "16px",
                                                                                                                    maxHeight: "48px",
                                                                                                                    color: "#98B0D4",
                                                                                                                }}
                                                                                                            >
                                                                                                                {cart.url}
                                                                                                            </a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <textarea
                                                                                                                className="admin-input-line prod-textarea-memo"
                                                                                                                cols="52"
                                                                                                                rows="4"
                                                                                                                value={adminProdMemos[cart.seqnum] || ''}
                                                                                                                onChange={(e) => handleProdMemoChange(cart.seqnum, e.target.value)}
                                                                                                                onKeyDown={(e) => saveProdMemo(e, cart.seqnum)}
                                                                                                            ></textarea>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <a className="dark-font"
                                                                                                               style={{fontSize: "12px"}}>{cart.option}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">{cart.quantity}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">{cart.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">0</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <a>{prodStPrint(cart?.prodSt)}</a>
                                                                                                            <a style={{width: "100%"}}>
                                                                                                                {/*여기서부터 커스텀 상품상태 셀렉트*/}
                                                                                                                <div
                                                                                                                    ref={el => cartProdStRef.current[`${i}-${index}`] = el}
                                                                                                                    style={{
                                                                                                                        height: "30px",
                                                                                                                        width: "100%",
                                                                                                                        position: "relative",
                                                                                                                        padding: "3px"
                                                                                                                    }}>
                                                                                                                    <button
                                                                                                                        className="selectParentBt"
                                                                                                                        style={{
                                                                                                                            width: "100%",
                                                                                                                            height: "100%",
                                                                                                                            backgroundColor: "white",
                                                                                                                            border: "none"
                                                                                                                        }}
                                                                                                                        onClick={() => toggleCartProdStShow(i, index)}>
                                                                                                                        <p style={{
                                                                                                                            margin: "0",
                                                                                                                            fontSize: "12px",
                                                                                                                        }}>{selectedProdSt[`${'cart'}-${i}-${index}`]?.label || '개별변경'}</p>
                                                                                                                        <span
                                                                                                                            style={{
                                                                                                                                position: "absolute",
                                                                                                                                left: "80%",
                                                                                                                                top: "0",
                                                                                                                                height: "100%",
                                                                                                                                width: "20%"
                                                                                                                            }}>
                                                                                                                            <i style={{
                                                                                                                                display: "flex",
                                                                                                                                justifyContent: "center",
                                                                                                                                alignItems: "center",
                                                                                                                                height: "100%",
                                                                                                                                color: "dimgray"
                                                                                                                            }}><BiCaretDown/></i>
                                                                                                                        </span>
                                                                                                                    </button>
                                                                                                                    {cartProdStShow[`${i}-${index}`] ?
                                                                                                                        <div
                                                                                                                            style={{
                                                                                                                                width: "100%",
                                                                                                                                border: "solid",
                                                                                                                                maxHeight: "250px",
                                                                                                                                borderWidth: "thin 1px",
                                                                                                                                borderColor: "lightgray",
                                                                                                                                position: "absolute",
                                                                                                                                top: "100%",
                                                                                                                                zIndex: 1000,
                                                                                                                                marginTop: "5px",
                                                                                                                                overflowY: "auto",
                                                                                                                            }}>
                                                                                                                            {prodStList.map((ps, idx) => (
                                                                                                                                <div
                                                                                                                                    className="selectChildBt ht-30"
                                                                                                                                    key={idx}
                                                                                                                                    onClick={() => handleProdStChange('cart', ps, cart.seqnum, i, index)}
                                                                                                                                    style={{
                                                                                                                                        display: "flex",
                                                                                                                                        padding: "10px",
                                                                                                                                        justifyContent: "center",
                                                                                                                                        alignItems: "center",
                                                                                                                                        cursor: "pointer",
                                                                                                                                        fontSize: "12px",
                                                                                                                                        borderRadius: "4px",
                                                                                                                                        zIndex: 99,
                                                                                                                                    }}>{ps.label}</div>
                                                                                                                            ))}
                                                                                                                        </div>
                                                                                                                        :
                                                                                                                        null
                                                                                                                    }
                                                                                                                </div>
                                                                                                            </a>
                                                                                                            {cart?.modiTime &&
                                                                                                                <a className="dark-font">{formatDateTime(cart.modiTime)}(수정)</a>}
                                                                                                            {cart?.orderDate &&
                                                                                                                <a className="dark-font">{formatDateTime(cart.orderDate)}((구매)</a>}
                                                                                                            {cart?.arrDate &&
                                                                                                                <a className="dark-font">{formatDateTime(cart.arrDate)}(도착)</a>}
                                                                                                        </li>
                                                                                                    </td>
                                                                                                </tr>
                                                                                                </tbody>
                                                                                            ))}
                                                                                        </Table>
                                                                                        <div className="cont-dt-bottom">
                                                                                            {/*<span className="dt-bottom-sp-l" style={{border:"solid"}}>*/}
                                                                                            {/*    <button className="admin-btn-B wd-40 ht-25 m-l-7" onClick={()=> toggleMenuDTcartFn(i, cData.productsDTO.filter(prod => prod.prodTy === "P00").length)}><TbArrowBarToUp className="up-icon"/></button>*/}
                                                                                            {/*</span>*/}
                                                                                            <span
                                                                                                className="dt-bottom-sp-left"
                                                                                                style={{width: "130px"}}>
                                                                                                <div style={{
                                                                                                    display: "flex",
                                                                                                    alignItems: "center",
                                                                                                    width: "100%",
                                                                                                    height: "100%"
                                                                                                }}>
                                                                                                {/*여기서부터 커스텀 전체상태변경 셀렉트*/}
                                                                                                    <div
                                                                                                        ref={el => allCartProdStRefs.current[`${i}`] = el}
                                                                                                        style={{
                                                                                                            height: "100%",
                                                                                                            width: "100%",
                                                                                                            position: "relative",
                                                                                                            marginRight: "10px"
                                                                                                        }}>
                                                                                                        <button
                                                                                                            className="selectParentBt"
                                                                                                            style={{
                                                                                                                width: "100%",
                                                                                                                height: "100%"
                                                                                                            }}
                                                                                                            onClick={() => toggleAllCartProdStShow(i)}>
                                                                                                            <p style={{
                                                                                                                margin: "0",
                                                                                                                fontSize: "13px"
                                                                                                            }}>{selectedAllCartProdSt[i]?.label || '전체변경'}</p>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    position: "absolute",
                                                                                                                    left: "80%",
                                                                                                                    top: "0",
                                                                                                                    height: "100%",
                                                                                                                    width: "20%"
                                                                                                                }}>
                                                                                                                <i style={{
                                                                                                                    display: "flex",
                                                                                                                    justifyContent: "center",
                                                                                                                    alignItems: "center",
                                                                                                                    height: "100%",
                                                                                                                    color: "dimgray"
                                                                                                                }}><BiCaretDown/></i>
                                                                                                            </span>
                                                                                                        </button>
                                                                                                        {allCartProdStShow[i] ?
                                                                                                            <div
                                                                                                                style={{
                                                                                                                    width: "100%",
                                                                                                                    border: "solid",
                                                                                                                    maxHeight: "250px",
                                                                                                                    borderWidth: "thin 1px",
                                                                                                                    borderColor: "lightgray",
                                                                                                                    position: "absolute",
                                                                                                                    top: "100%",
                                                                                                                    zIndex: 1000,
                                                                                                                    marginTop: "5px",
                                                                                                                    overflowY: "auto",
                                                                                                                }}>
                                                                                                                {prodStList.map((aps, idx) => (
                                                                                                                    <div
                                                                                                                        className="selectChildBt ht-30"
                                                                                                                        key={idx}
                                                                                                                        onClick={() => handleAllProdStChange('cart', i, aps)}
                                                                                                                        style={{
                                                                                                                            display: "flex",
                                                                                                                            padding: "10px",
                                                                                                                            justifyContent: "center",
                                                                                                                            alignItems: "center",
                                                                                                                            cursor: "pointer",
                                                                                                                            fontSize: "12px",
                                                                                                                            borderRadius: "4px",
                                                                                                                            zIndex: 99,
                                                                                                                        }}>{aps.label}</div>
                                                                                                                ))}
                                                                                                            </div>
                                                                                                            :
                                                                                                            null
                                                                                                        }
                                                                                                    </div>
                                                                                                </div>
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        className="admin-ord-ctg-wrap c-point"
                                                                                        onClick={() => toggleMenuDTorderFn(i, cData.productsDTO.filter(prod => prod.prodTy === "P01").length)}>
                                                                                        {isOpenOrderItemDt[i] ?
                                                                                            <i className="ord-accordion-icon"
                                                                                               style={{transform: "rotate(90deg)"}}/> :
                                                                                            <i className="ord-accordion-icon"></i>
                                                                                        }
                                                                                        <a className="dark-font font-s-14">구매대행</a>
                                                                                        <a style={{
                                                                                            color: cData.productsDTO.filter(prod => prod.prodTy === "P01").length === 0 ? "dimgrey" : "darkorange",
                                                                                            fontWeight: "bold",
                                                                                            marginLeft: "5px"
                                                                                        }}>{cData.productsDTO.filter(prod => prod.prodTy === "P01").length}
                                                                                        </a>
                                                                                    </div>
                                                                                    <div
                                                                                        className={isOpenOrderItemDt[i] ? "order-dt-close" : "order-dt-open"}>
                                                                                        <Table striped bordered hover
                                                                                               style={{tableLayout: "fixed"}}>
                                                                                            <thead
                                                                                                className="tb-head-td-title">
                                                                                            <tr className="tb-head-title-line">
                                                                                                <th className="tb-head-cont-line-l"
                                                                                                    style={{width: "30px"}}>
                                                                                                    <li><input
                                                                                                        className="admin-input-chkBox"
                                                                                                        type="checkbox"
                                                                                                        onChange={e => handleCheckAll('order', i, e.target.checked, cData.productsDTO)}
                                                                                                        checked={selectedItems.order[i] ? selectedItems.order[i].length === cData.productsDTO.filter(prod => prod.prodTy === "P01").length : false}
                                                                                                    /></li>
                                                                                                </th>
                                                                                                <th style={{width: "40px"}}>
                                                                                                    <li><b>품번</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "90px"}}>
                                                                                                    <li><b>사진</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "250px"}}>
                                                                                                    <li><b>상품명 / URL /
                                                                                                        운송장번호</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "270px"}}>
                                                                                                    <li><b>상품메모</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "260px"}}>
                                                                                                    <li><b>상품옵션</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "50px"}}>
                                                                                                    <li><b>수량</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "100px"}}>
                                                                                                    <li><b>구매금액</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "70px"}}>
                                                                                                    <li><b>몰배송비</b></li>
                                                                                                </th>
                                                                                                <th className="tb-head-cont-line-r"
                                                                                                    style={{width: "130px"}}>
                                                                                                    <li><b>개별현황</b></li>
                                                                                                </th>
                                                                                            </tr>
                                                                                            </thead>
                                                                                            {/*구매대행상품*/}
                                                                                            {cData.productsDTO.filter(prod => prod.prodTy === "P01").sort((a, b) => a.seqnum - b.seqnum).map((order, index) => (
                                                                                                <tbody key={index}
                                                                                                       className="tb-head-cont-dt">
                                                                                                <tr className="tb-head-cont-line">
                                                                                                    <td>
                                                                                                        <li><input
                                                                                                            onChange={e => handleCheckItem('order', i, order.seqnum, e.target.checked)}
                                                                                                            checked={selectedItems.order[i] ? selectedItems.order[i].includes(order.seqnum) : false}
                                                                                                            className="admin-input-chkBox"
                                                                                                            type="checkbox"/>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">{index + 1}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <span
                                                                                                                className="ord-prod-img">
                                                                                                                <img
                                                                                                                    className="ord-prod-img-file"
                                                                                                                    src={BtorageWriteLogo}
                                                                                                                    alt="admin-logo"/>
                                                                                                            </span>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b"
                                                                                                            href={order.url}
                                                                                                            target="_blank">{order.name}</a>
                                                                                                        </li>
                                                                                                        <li style={{width: "100%"}}>
                                                                                                            <a
                                                                                                                href={order.url}
                                                                                                                target="_blank"
                                                                                                                className="font-b"
                                                                                                                style={{
                                                                                                                    display: "-webkit-box",
                                                                                                                    WebkitBoxOrient: "vertical",
                                                                                                                    WebkitLineClamp: 3,
                                                                                                                    overflow: "hidden",
                                                                                                                    textOverflow: "ellipsis",

                                                                                                                    whiteSpace: "normal",
                                                                                                                    wordBreak: "break-all",
                                                                                                                    overflowWrap: "anywhere",

                                                                                                                    maxWidth: "500px",
                                                                                                                    width: "100%",

                                                                                                                    lineHeight: "16px",
                                                                                                                    maxHeight: "48px",
                                                                                                                    color: "#98B0D4",
                                                                                                                }}
                                                                                                            >
                                                                                                                {order.url}
                                                                                                            </a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <textarea
                                                                                                                className="admin-input-line prod-textarea-memo"
                                                                                                                cols="44"
                                                                                                                rows="4"
                                                                                                                value={adminProdMemos[order.seqnum] || ''} // 초기값 설정
                                                                                                                onChange={(e) => handleProdMemoChange(order.seqnum, e.target.value)}
                                                                                                                onKeyDown={(e) => saveProdMemo(e, order.seqnum)}
                                                                                                            ></textarea>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <a className="dark-font"
                                                                                                               style={{fontSize: "14px"}}>
                                                                                                                {order?.option}
                                                                                                            </a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">{order?.quantity}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">{order?.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">{order?.mallShipPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <a>{prodStPrint(order?.prodSt)}</a>
                                                                                                            <a style={{width: "100%"}}>
                                                                                                                <div
                                                                                                                    ref={el => orderProdStRef.current[`${i}-${index}`] = el}
                                                                                                                    style={{
                                                                                                                        height: "30px",
                                                                                                                        width: "100%",
                                                                                                                        position: "relative",
                                                                                                                        padding: "3px"
                                                                                                                    }}>
                                                                                                                    <button
                                                                                                                        className="selectParentBt"
                                                                                                                        style={{
                                                                                                                            width: "100%",
                                                                                                                            height: "100%",
                                                                                                                            backgroundColor: "white",
                                                                                                                            border: "none"
                                                                                                                        }}
                                                                                                                        onClick={() => toggleOrderProdStShow(i, index)}>
                                                                                                                        <p style={{
                                                                                                                            margin: "0",
                                                                                                                            fontSize: "12px",
                                                                                                                        }}>{selectedProdSt[`${'order'}-${i}-${index}`]?.label || '개별변경'}</p>
                                                                                                                        <span
                                                                                                                            style={{
                                                                                                                                position: "absolute",
                                                                                                                                left: "80%",
                                                                                                                                top: "0",
                                                                                                                                height: "100%",
                                                                                                                                width: "20%"
                                                                                                                            }}>
                                                                                                                            <i style={{
                                                                                                                                display: "flex",
                                                                                                                                justifyContent: "center",
                                                                                                                                alignItems: "center",
                                                                                                                                height: "100%",
                                                                                                                                color: "dimgray"
                                                                                                                            }}><BiCaretDown/></i>
                                                                                                                        </span>
                                                                                                                    </button>
                                                                                                                    {orderProdStShow[`${i}-${index}`] ?
                                                                                                                        <div
                                                                                                                            style={{
                                                                                                                                width: "100%",
                                                                                                                                border: "solid",
                                                                                                                                maxHeight: "250px",
                                                                                                                                borderWidth: "thin 1px",
                                                                                                                                borderColor: "lightgray",
                                                                                                                                position: "absolute",
                                                                                                                                top: "100%",
                                                                                                                                zIndex: 1000,
                                                                                                                                marginTop: "5px",
                                                                                                                                overflowY: "auto",
                                                                                                                            }}>
                                                                                                                            {prodStList.map((ps, idx) => (
                                                                                                                                <div
                                                                                                                                    className="selectChildBt ht-30"
                                                                                                                                    key={idx}
                                                                                                                                    onClick={() => handleProdStChange('order', ps, order.seqnum, i, index)}
                                                                                                                                    style={{
                                                                                                                                        display: "flex",
                                                                                                                                        padding: "10px",
                                                                                                                                        justifyContent: "center",
                                                                                                                                        alignItems: "center",
                                                                                                                                        cursor: "pointer",
                                                                                                                                        fontSize: "12px",
                                                                                                                                        borderRadius: "4px",
                                                                                                                                        zIndex: 99,
                                                                                                                                    }}>{ps.label}</div>
                                                                                                                            ))}
                                                                                                                        </div>
                                                                                                                        :
                                                                                                                        null
                                                                                                                    }
                                                                                                                </div>
                                                                                                            </a>
                                                                                                            {order?.modiTime &&
                                                                                                                <a className="dark-font">{formatDateTime(order.modiTime)}(수정)</a>}
                                                                                                            {order?.orderDate &&
                                                                                                                <a className="dark-font">{formatDateTime(order.orderDate)}(구매)</a>}
                                                                                                            {order?.arrDate &&
                                                                                                                <a className="dark-font">{formatDateTime(order.arrDate)}(도착)</a>}
                                                                                                        </li>
                                                                                                    </td>
                                                                                                </tr>
                                                                                                </tbody>
                                                                                            ))}
                                                                                        </Table>
                                                                                        <div className="cont-dt-bottom">
                                                                                            {/*<span className="dt-bottom-sp-l">*/}
                                                                                            {/*    <button className="admin-btn-B wd-40 ht-25 m-l-7"*/}
                                                                                            {/*            onClick={() => toggleMenuDTorderFn(i, cData.productsDTO.filter(prod => prod.prodTy === "P01").length)}><TbArrowBarToUp className="up-icon"/>*/}
                                                                                            {/*    </button>*/}
                                                                                            {/*</span>*/}
                                                                                            <span
                                                                                                className="dt-bottom-sp-left"
                                                                                                style={{width: "130px"}}>
                                                                    <div style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        width: "100%",
                                                                        height: "25px"
                                                                    }}>
                                                                        <div
                                                                            ref={el => allOrderProdStRefs.current[`${i}`] = el}
                                                                            style={{
                                                                                height: "100%",
                                                                                width: "100%",
                                                                                position: "relative",
                                                                                marginRight: "10px"
                                                                            }}>
                                                                            <button className="selectParentBt" style={{
                                                                                width: "100%",
                                                                                height: "100%"
                                                                            }}
                                                                                    onClick={() => toggleAllOrderProdStShow(i)}>
                                                                                <p style={{
                                                                                    margin: "0",
                                                                                    fontSize: "13px"
                                                                                }}>{selectedAllOrderProdSt[i]?.label || '전체변경'}</p>
                                                                                <span style={{
                                                                                    position: "absolute",
                                                                                    left: "80%",
                                                                                    top: "0",
                                                                                    height: "100%",
                                                                                    width: "20%"
                                                                                }}>
                                                                                    <i style={{
                                                                                        display: "flex",
                                                                                        justifyContent: "center",
                                                                                        alignItems: "center",
                                                                                        height: "100%",
                                                                                        color: "dimgray"
                                                                                    }}><BiCaretDown/></i>
                                                                                </span>
                                                                            </button>
                                                                            {allOrderProdStShow[i] ?
                                                                                <div style={{
                                                                                    width: "100%",
                                                                                    border: "solid",
                                                                                    maxHeight: "250px",
                                                                                    borderWidth: "thin 1px",
                                                                                    borderColor: "lightgray",
                                                                                    position: "absolute",
                                                                                    top: "100%",
                                                                                    zIndex: 1000,
                                                                                    marginTop: "5px",
                                                                                    overflowY: "auto",
                                                                                }}>
                                                                                    {prodStList.map((aps, idx) => (
                                                                                        <div
                                                                                            className="selectChildBt ht-30"
                                                                                            key={idx}
                                                                                            onClick={() => handleAllProdStChange('order', i, aps)}
                                                                                            style={{
                                                                                                display: "flex",
                                                                                                padding: "10px",
                                                                                                justifyContent: "center",
                                                                                                alignItems: "center",
                                                                                                cursor: "pointer",
                                                                                                fontSize: "12px",
                                                                                                borderRadius: "4px",
                                                                                                zIndex: 99,
                                                                                            }}>{aps.label}</div>
                                                                                    ))}
                                                                                </div>
                                                                                :
                                                                                null
                                                                            }
                                                                        </div>
                                                                        </div>
                                                                </span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        className="admin-ord-ctg-wrap c-point"
                                                                                        onClick={() => toggleMenuDTofflineFn(i, cData.productsDTO.filter(prod => prod.prodTy === "P02").length)}>
                                                                                        {isOpenOfflineItemDt[i] ?
                                                                                            <i className="ord-accordion-icon"
                                                                                               style={{transform: "rotate(90deg)"}}/> :
                                                                                            <i className="ord-accordion-icon"></i>
                                                                                        }
                                                                                        <a className="dark-font font-s-14">오프라인</a>
                                                                                        <a style={{
                                                                                            color: cData.productsDTO.filter(prod => prod.prodTy === "P02").length === 0 ? "dimgrey" : "darkorange",
                                                                                            fontWeight: "bold",
                                                                                            marginLeft: "5px"
                                                                                        }}>{cData.productsDTO.filter(prod => prod.prodTy === "P02").length}
                                                                                        </a>
                                                                                    </div>
                                                                                    <div
                                                                                        className={isOpenOfflineItemDt[i] ? "order-dt-close" : "order-dt-open"}>
                                                                                        <Table striped bordered hover
                                                                                               style={{tableLayout: "fixed"}}>
                                                                                            <thead
                                                                                                className="tb-head-td-title">
                                                                                            <tr className="tb-head-title-line">
                                                                                                <th className="tb-head-cont-line-l"
                                                                                                    style={{width: "30px"}}>
                                                                                                    <li><input
                                                                                                        className="admin-input-chkBox"
                                                                                                        type="checkbox"
                                                                                                        onChange={e => handleCheckAll('offline', i, e.target.checked, cData.productsDTO)}
                                                                                                        checked={selectedItems.offline[i] ? selectedItems.offline[i].length === cData.productsDTO.filter(prod => prod.prodTy === "P02").length : false}
                                                                                                    /></li>
                                                                                                </th>
                                                                                                <th style={{width: "40px"}}>
                                                                                                    <li><b>품번</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "90px"}}>
                                                                                                    <li><b>사진</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "180px"}}>
                                                                                                    <li><b>상품명 / URL /
                                                                                                        운송장번호</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "340px"}}>
                                                                                                    <li><b>상품메모</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "260px"}}>
                                                                                                    <li><b>상품옵션</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "50px"}}>
                                                                                                    <li><b>수량</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "100px"}}>
                                                                                                    <li><b>구매금액</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "80px"}}>
                                                                                                    <li><b>수수료</b></li>
                                                                                                </th>
                                                                                                <th className="tb-head-cont-line-r"
                                                                                                    style={{width: "150px"}}>
                                                                                                    <li><b>개별현황</b></li>
                                                                                                </th>
                                                                                            </tr>
                                                                                            </thead>
                                                                                            {/*오프라인상품*/}
                                                                                            {cData.productsDTO.filter(prod => prod.prodTy === "P02").sort((a, b) => a.seqnum - b.seqnum).map((offline, index) => (
                                                                                                <tbody key={index}
                                                                                                       className="tb-head-cont-dt">
                                                                                                <tr className="tb-head-cont-line">
                                                                                                    <td>
                                                                                                        <li><input
                                                                                                            onChange={e => handleCheckItem('offline', i, offline.seqnum, e.target.checked)}
                                                                                                            checked={selectedItems.offline[i] ? selectedItems.offline[i].includes(offline.seqnum) : false}
                                                                                                            className="admin-input-chkBox"
                                                                                                            type="checkbox"/>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">{index + 1}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <span
                                                                                                                className="ord-prod-img">
                                                                                                                <img
                                                                                                                    className="ord-prod-img-file"
                                                                                                                    src={BtorageWriteLogo}
                                                                                                                    alt="admin-logo"/>
                                                                                                            </span>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b"
                                                                                                            href="https://www.naver.com"
                                                                                                            target="_blank">
                                                                                                            {offline.name}
                                                                                                        </a></li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                            <textarea
                                                                                className="admin-input-line prod-textarea-memo"
                                                                                cols="52"
                                                                                rows="4"
                                                                                value={adminProdMemos[offline.seqnum] || ''} // 초기값 설정
                                                                                onChange={(e) => handleProdMemoChange(offline.seqnum, e.target.value)}
                                                                                onKeyDown={(e) => saveProdMemo(e, offline.seqnum)}
                                                                            ></textarea>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <a className="dark-font"
                                                                                                               style={{fontSize: "14px"}}>
                                                                                                                {offline.option}
                                                                                                            </a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">{offline.quantity}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">{offline.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">{offline.fee.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>

                                                                                                            <a>{prodStPrint(offline?.prodSt)}</a>

                                                                                                            <a style={{width: "100%"}}>
                                                                                                                {/*여기서부터 커스텀 상품상태 셀렉트*/}
                                                                                                                <div
                                                                                                                    ref={el => offlineProdStRef.current[`${i}-${index}`] = el}
                                                                                                                    style={{
                                                                                                                        height: "30px",
                                                                                                                        width: "100%",
                                                                                                                        position: "relative",
                                                                                                                        padding: "3px"
                                                                                                                    }}>
                                                                                                                    <button
                                                                                                                        className="selectParentBt"
                                                                                                                        style={{
                                                                                                                            width: "100%",
                                                                                                                            height: "100%",
                                                                                                                            backgroundColor: "white",
                                                                                                                            border: "none"
                                                                                                                        }}
                                                                                                                        onClick={() => toggleOfflineProdStShow(i, index)}>
                                                                                                                        <p style={{
                                                                                                                            margin: "0",
                                                                                                                            fontSize: "12px",
                                                                                                                        }}>{selectedProdSt[`${'offline'}-${i}-${index}`]?.label || '개별변경'}</p>
                                                                                                                        <span
                                                                                                                            style={{
                                                                                                                                position: "absolute",
                                                                                                                                left: "80%",
                                                                                                                                top: "0",
                                                                                                                                height: "100%",
                                                                                                                                width: "20%"
                                                                                                                            }}>

                                                                    <i style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        height: "100%",
                                                                        color: "dimgray"
                                                                    }}><BiCaretDown/></i>

                                                                </span>
                                                                                                                    </button>
                                                                                                                    {offlineProdStShow[`${i}-${index}`] ?
                                                                                                                        <div
                                                                                                                            style={{
                                                                                                                                width: "100%",
                                                                                                                                border: "solid",
                                                                                                                                maxHeight: "250px",
                                                                                                                                borderWidth: "thin 1px",
                                                                                                                                borderColor: "lightgray",
                                                                                                                                position: "absolute",
                                                                                                                                top: "100%",
                                                                                                                                zIndex: 1000,
                                                                                                                                marginTop: "5px",
                                                                                                                                overflowY: "auto",
                                                                                                                            }}>
                                                                                                                            {prodStList.map((ps, idx) => (
                                                                                                                                <div
                                                                                                                                    className="selectChildBt ht-30"
                                                                                                                                    key={idx}
                                                                                                                                    onClick={() => handleProdStChange('offline', ps, offline.seqnum, i, index)}
                                                                                                                                    style={{
                                                                                                                                        display: "flex",
                                                                                                                                        padding: "10px",
                                                                                                                                        justifyContent: "center",
                                                                                                                                        alignItems: "center",
                                                                                                                                        cursor: "pointer",
                                                                                                                                        fontSize: "12px",
                                                                                                                                        borderRadius: "4px",
                                                                                                                                        zIndex: 99,
                                                                                                                                    }}>{ps.label}</div>
                                                                                                                            ))}
                                                                                                                        </div>
                                                                                                                        :
                                                                                                                        null
                                                                                                                    }
                                                                                                                </div>
                                                                                                            </a>
                                                                                                            {offline?.modiTime &&
                                                                                                                <a className="dark-font">{formatDateTime(offline.modiTime)}(수정)</a>}
                                                                                                            {offline?.orderDate &&
                                                                                                                <a className="dark-font">{formatDateTime(offline.orderDate)}(구매)</a>}
                                                                                                            {offline?.arrDate &&
                                                                                                                <a className="dark-font">{formatDateTime(offline.arrDate)}(도착)</a>}
                                                                                                        </li>
                                                                                                    </td>
                                                                                                </tr>
                                                                                                </tbody>
                                                                                            ))}
                                                                                        </Table>
                                                                                        <div className="cont-dt-bottom">
                                                                                            {/*<span className="dt-bottom-sp-l">*/}
                                                                                            {/*    <button className="admin-btn-B wd-40 ht-25 m-l-7" onClick={()=> toggleMenuDTofflineFn(i, cData.productsDTO.filter(prod => prod.prodTy === "P02").length)}>*/}
                                                                                            {/*        <TbArrowBarToUp className="up-icon"/>*/}
                                                                                            {/*    </button>*/}
                                                                                            {/*</span>*/}
                                                                                            <span
                                                                                                className="dt-bottom-sp-left"
                                                                                                style={{width: "130px"}}>
                                                                    <div style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        width: "100%",
                                                                        height: "100%"
                                                                    }}>
                                                                        <div
                                                                            ref={el => allOfflineProdStRefs.current[`${i}`] = el}
                                                                            style={{
                                                                                height: "100%",
                                                                                width: "100%",
                                                                                position: "relative",
                                                                                marginRight: "10px"
                                                                            }}>
                                                                        <button className="selectParentBt"
                                                                                style={{width: "100%", height: "100%"}}
                                                                                onClick={() => toggleAllOfflineProdStShow(i)}>
                                                                            <p style={{
                                                                                margin: "0",
                                                                                fontSize: "13px"
                                                                            }}>{selectedAllOfflineProdSt[i]?.label || '전체변경'}</p>
                                                                            <span style={{
                                                                                position: "absolute",
                                                                                left: "80%",
                                                                                top: "0",
                                                                                height: "100%",
                                                                                width: "20%"
                                                                            }}>
                                                                                <i style={{
                                                                                    display: "flex",
                                                                                    justifyContent: "center",
                                                                                    alignItems: "center",
                                                                                    height: "100%",
                                                                                    color: "dimgray"
                                                                                }}><BiCaretDown/></i>
                                                                            </span>
                                                                        </button>
                                                                            {allOfflineProdStShow[i] ?
                                                                                <div style={{
                                                                                    width: "100%",
                                                                                    border: "solid",
                                                                                    maxHeight: "250px",
                                                                                    borderWidth: "thin 1px",
                                                                                    borderColor: "lightgray",
                                                                                    position: "absolute",
                                                                                    top: "100%",
                                                                                    zIndex: 1000,
                                                                                    marginTop: "5px",
                                                                                    overflowY: "auto",
                                                                                }}>
                                                                                    {prodStList.map((aps, idx) => (
                                                                                        <div
                                                                                            className="selectChildBt ht-30"
                                                                                            key={idx}
                                                                                            onClick={() => handleAllProdStChange('offline', i, aps)}
                                                                                            style={{
                                                                                                display: "flex",
                                                                                                padding: "10px",
                                                                                                justifyContent: "center",
                                                                                                alignItems: "center",
                                                                                                cursor: "pointer",
                                                                                                fontSize: "12px",
                                                                                                borderRadius: "4px",
                                                                                                zIndex: 99,
                                                                                            }}>{aps.label}</div>
                                                                                    ))}
                                                                                </div>
                                                                                :
                                                                                null
                                                                            }
                                                                        </div>
                                                                        {/*여기까지 커스텀 전체상태변경 셀렉트*/}
                                                                        </div>
                                                                </span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        className="admin-ord-ctg-wrap c-point"
                                                                                        onClick={() => toggleMenuDTtransferFn(i, cData.productsDTO.filter(prod => prod.prodTy === "P03").length)}>
                                                                                        {isOpenTransferItemDt[i] ?
                                                                                            <i className="ord-accordion-icon"
                                                                                               style={{transform: "rotate(90deg)"}}/> :
                                                                                            <i className="ord-accordion-icon"></i>
                                                                                        }
                                                                                        <a className="dark-font font-s-14">이체대행</a>
                                                                                        <a style={{
                                                                                            color: cData.productsDTO.filter(prod => prod.prodTy === "P03").length === 0 ? "dimgrey" : "darkorange",
                                                                                            fontWeight: "bold",
                                                                                            marginLeft: "5px"
                                                                                        }}>{cData.productsDTO.filter(prod => prod.prodTy === "P03").length}
                                                                                        </a>
                                                                                    </div>
                                                                                    <div
                                                                                        className={isOpenTransferItemDt[i] ? "order-dt-close" : "order-dt-open"}>
                                                                                        <Table striped bordered hover
                                                                                               style={{tableLayout: "fixed"}}>
                                                                                            <thead
                                                                                                className="tb-head-td-title">
                                                                                            <tr className="tb-head-title-line">
                                                                                                <th className="tb-head-cont-line-l"
                                                                                                    style={{width: "30px"}}>
                                                                                                    <li><input
                                                                                                        className="admin-input-chkBox"
                                                                                                        type="checkbox"
                                                                                                        onChange={e => handleCheckAll('transfer', i, e.target.checked, cData.productsDTO)}
                                                                                                        checked={selectedItems.transfer[i] ? selectedItems.transfer[i].length === cData.productsDTO.filter(prod => prod.prodTy === "P03").length : false}
                                                                                                    /></li>
                                                                                                </th>
                                                                                                <th style={{width: "40px"}}>
                                                                                                    <li><b>품번</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "90px"}}>
                                                                                                    <li><b>사진</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "180px"}}>
                                                                                                    <li><b>상품명 / URL /
                                                                                                        운송장번호</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "340px"}}>
                                                                                                    <li><b>상품메모</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "260px"}}>
                                                                                                    <li><b>상품옵션</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "50px"}}>
                                                                                                    <li><b>수량</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "100px"}}>
                                                                                                    <li><b>이체금액</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "80px"}}>
                                                                                                    <li><b>수수료</b></li>
                                                                                                </th>
                                                                                                <th className="tb-head-cont-line-r"
                                                                                                    style={{width: "150px"}}>
                                                                                                    <li><b>개별현황</b></li>
                                                                                                </th>
                                                                                            </tr>
                                                                                            </thead>
                                                                                            {/*이체대행상품*/}
                                                                                            {cData.productsDTO.filter(prod => prod.prodTy === "P03").sort((a, b) => a.seqnum - b.seqnum).map((transfer, index) => (
                                                                                                <tbody key={index}
                                                                                                       className="tb-head-cont-dt">
                                                                                                <tr className="tb-head-cont-line">
                                                                                                    <td>
                                                                                                        <li><input
                                                                                                            onChange={e => handleCheckItem('transfer', i, transfer.seqnum, e.target.checked)}
                                                                                                            checked={selectedItems.transfer[i] ? selectedItems.transfer[i].includes(transfer.seqnum) : false}
                                                                                                            className="admin-input-chkBox"
                                                                                                            type="checkbox"/>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">{index + 1}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                            <span className="ord-prod-img">
                                                                                <img className="ord-prod-img-file"
                                                                                     src={BtorageWriteLogo}
                                                                                     alt="admin-logo"/>
                                                                            </span>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b"
                                                                                                            href="https://www.naver.com"
                                                                                                            target="_blank">
                                                                                                            {transfer.name}
                                                                                                        </a></li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                            <textarea
                                                                                className="admin-input-line prod-textarea-memo"
                                                                                cols="52"
                                                                                rows="4"
                                                                                value={adminProdMemos[transfer.seqnum] || ''} // 초기값 설정
                                                                                onChange={(e) => handleProdMemoChange(transfer.seqnum, e.target.value)}
                                                                                onKeyDown={(e) => saveProdMemo(e, transfer.seqnum)}
                                                                            ></textarea>

                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <a className="dark-font"
                                                                                                               style={{fontSize: "11px"}}>

                                                                                                            </a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b"></a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">{transfer.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">{transfer.fee.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <a>{prodStPrint(transfer?.prodSt)}</a>
                                                                                                            <a style={{width: "100%"}}>
                                                                                                                {/*여기서부터 커스텀 상품상태 셀렉트*/}
                                                                                                                <div
                                                                                                                    ref={el => transferProdStRef.current[`${i}-${index}`] = el}
                                                                                                                    style={{
                                                                                                                        height: "30px",
                                                                                                                        width: "100%",
                                                                                                                        position: "relative",
                                                                                                                        padding: "3px"
                                                                                                                    }}>
                                                                                                                    <button
                                                                                                                        className="selectParentBt"
                                                                                                                        style={{
                                                                                                                            width: "100%",
                                                                                                                            height: "100%",
                                                                                                                            backgroundColor: "white",
                                                                                                                            border: "none"
                                                                                                                        }}
                                                                                                                        onClick={() => toggleTransferProdStShow(i, index)}>
                                                                                                                        <p style={{
                                                                                                                            margin: "0",
                                                                                                                            fontSize: "12px",
                                                                                                                        }}>{selectedProdSt[`${'transfer'}-${i}-${index}`]?.label || '개별변경'}</p>
                                                                                                                        <span
                                                                                                                            style={{
                                                                                                                                position: "absolute",
                                                                                                                                left: "80%",
                                                                                                                                top: "0",
                                                                                                                                height: "100%",
                                                                                                                                width: "20%"
                                                                                                                            }}>
                                                                                                                            <i style={{
                                                                                                                                display: "flex",
                                                                                                                                justifyContent: "center",
                                                                                                                                alignItems: "center",
                                                                                                                                height: "100%",
                                                                                                                                color: "dimgray"
                                                                                                                            }}><BiCaretDown/></i>
                                                                                                                        </span>
                                                                                                                    </button>
                                                                                                                    {transferProdStShow[`${i}-${index}`] ?
                                                                                                                        <div
                                                                                                                            style={{
                                                                                                                                width: "100%",
                                                                                                                                border: "solid",
                                                                                                                                maxHeight: "250px",
                                                                                                                                borderWidth: "thin 1px",
                                                                                                                                borderColor: "lightgray",
                                                                                                                                position: "absolute",
                                                                                                                                top: "100%",
                                                                                                                                zIndex: 1000,
                                                                                                                                marginTop: "5px",
                                                                                                                                overflowY: "auto",
                                                                                                                            }}>
                                                                                                                            {prodStList.map((ps, idx) => (
                                                                                                                                <div
                                                                                                                                    className="selectChildBt ht-30"
                                                                                                                                    key={idx}
                                                                                                                                    onClick={() => handleProdStChange('transfer', ps, transfer.seqnum, i, index)}
                                                                                                                                    style={{
                                                                                                                                        display: "flex",
                                                                                                                                        padding: "10px",
                                                                                                                                        justifyContent: "center",
                                                                                                                                        alignItems: "center",
                                                                                                                                        cursor: "pointer",
                                                                                                                                        fontSize: "12px",
                                                                                                                                        borderRadius: "4px",
                                                                                                                                        zIndex: 99,
                                                                                                                                    }}>{ps.label}</div>
                                                                                                                            ))}
                                                                                                                        </div>
                                                                                                                        :
                                                                                                                        null
                                                                                                                    }
                                                                                                                </div>
                                                                                                            </a>
                                                                                                            {transfer?.modiTime &&
                                                                                                                <a className="dark-font">{formatDateTime(transfer.modiTime)}(수정)</a>}
                                                                                                            {transfer?.orderDate &&
                                                                                                                <a className="dark-font">{formatDateTime(transfer.orderDate)}(구매)</a>}
                                                                                                            {transfer?.arrDate &&
                                                                                                                <a className="dark-font">{formatDateTime(transfer.arrDate)}(도착)</a>}
                                                                                                        </li>
                                                                                                    </td>
                                                                                                </tr>
                                                                                                </tbody>
                                                                                            ))}
                                                                                        </Table>
                                                                                        <div className="cont-dt-bottom">
                                                                                            {/*<span className="dt-bottom-sp-l">*/}
                                                                                            {/*    <button className="admin-btn-B wd-40 ht-25 m-l-7" onClick={()=> toggleMenuDTtransferFn(i, cData.productsDTO.filter(prod => prod.prodTy === "P03").length)}>*/}
                                                                                            {/*        <TbArrowBarToUp className="up-icon"/>*/}
                                                                                            {/*    </button>*/}
                                                                                            {/*</span>*/}
                                                                                            <span
                                                                                                className="dt-bottom-sp-left"
                                                                                                style={{width: "130px"}}>
                                                                    <div style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        width: "100%",
                                                                        height: "100%"
                                                                    }}>
                                                                    {/*여기서부터 커스텀 전체상태변경 셀렉트*/}
                                                                        <div
                                                                            ref={el => allTransferProdStRefs.current[`${i}`] = el}
                                                                            style={{
                                                                                height: "100%",
                                                                                width: "100%",
                                                                                position: "relative",
                                                                                marginRight: "10px"
                                                                            }}>
                                                                            <button className="selectParentBt" style={{
                                                                                width: "100%",
                                                                                height: "100%"
                                                                            }}
                                                                                    onClick={() => toggleAllTransferProdStShow(i)}>
                                                                                <p style={{
                                                                                    margin: "0",
                                                                                    fontSize: "13px"
                                                                                }}>{selectedAllTransferProdSt[i]?.label || '전체변경'}</p>
                                                                                <span style={{
                                                                                    position: "absolute",
                                                                                    left: "80%",
                                                                                    top: "0",
                                                                                    height: "100%",
                                                                                    width: "20%"
                                                                                }}>
                                                                                    <i style={{
                                                                                        display: "flex",
                                                                                        justifyContent: "center",
                                                                                        alignItems: "center",
                                                                                        height: "100%",
                                                                                        color: "dimgray"
                                                                                    }}><BiCaretDown/></i>
                                                                                </span>
                                                                            </button>
                                                                            {allTransferProdStShow[i] ?
                                                                                <div style={{
                                                                                    width: "100%",
                                                                                    border: "solid",
                                                                                    maxHeight: "250px",
                                                                                    borderWidth: "thin 1px",
                                                                                    borderColor: "lightgray",
                                                                                    position: "absolute",
                                                                                    top: "100%",
                                                                                    zIndex: 1000,
                                                                                    marginTop: "5px",
                                                                                    overflowY: "auto",
                                                                                }}>
                                                                                    {prodStList.map((aps, idx) => (
                                                                                        <div
                                                                                            className="selectChildBt ht-30"
                                                                                            key={idx}
                                                                                            onClick={() => handleAllProdStChange('transfer', i, aps)}
                                                                                            style={{
                                                                                                display: "flex",
                                                                                                padding: "10px",
                                                                                                justifyContent: "center",
                                                                                                alignItems: "center",
                                                                                                cursor: "pointer",
                                                                                                fontSize: "12px",
                                                                                                borderRadius: "4px",
                                                                                                zIndex: 99,
                                                                                            }}>{aps.label}</div>
                                                                                    ))}
                                                                                </div>
                                                                                :
                                                                                null
                                                                            }
                                                                        </div>
                                                                        {/*여기까지 커스텀 전체상태변경 셀렉트*/}
                                                                        </div>
                                                                </span>
                                                                                        </div>

                                                                                    </div>
                                                                                    <div
                                                                                        className="admin-ord-ctg-wrap c-point"
                                                                                        onClick={() => toggleMenuDTdomesticFn(i, cData.productsDTO.filter(prod => prod.prodTy === "P04").length)}>
                                                                                        {isOpenCartItemDt[i] ?
                                                                                            <i className="ord-accordion-icon"
                                                                                               style={{transform: "rotate(90deg)"}}/> :
                                                                                            <i className="ord-accordion-icon"></i>
                                                                                        }
                                                                                        <a className="dark-font font-s-14">국내배송</a>
                                                                                        <a style={{
                                                                                            color: cData.productsDTO.filter(prod => prod.prodTy === "P04").length === 0 ? "dimgrey" : "darkorange",
                                                                                            fontWeight: "bold",
                                                                                            marginLeft: "5px"
                                                                                        }}>{cData.productsDTO.filter(prod => prod.prodTy === "P04").length}
                                                                                        </a>
                                                                                    </div>
                                                                                    <div
                                                                                        className={isOpenDomesticItemDt[i] ? "order-dt-close" : "order-dt-open"}>
                                                                                        <Table striped bordered hover
                                                                                               style={{tableLayout: "fixed"}}>
                                                                                            <thead
                                                                                                className="tb-head-td-title">
                                                                                            <tr className="tb-head-title-line">
                                                                                                <th className="tb-head-cont-line-l"
                                                                                                    style={{width: "30px"}}>
                                                                                                    <li><input
                                                                                                        className="admin-input-chkBox"
                                                                                                        type="checkbox"
                                                                                                        onChange={e => handleCheckAll('domestic', i, e.target.checked, cData.productsDTO)}
                                                                                                        checked={selectedItems.domestic[i] ? selectedItems.domestic[i].length === cData.productsDTO.filter(prod => prod.prodTy === "P04").length : false}
                                                                                                    /></li>
                                                                                                </th>
                                                                                                <th style={{width: "40px"}}>
                                                                                                    <li><b>품번</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "90px"}}>
                                                                                                    <li><b>사진</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "180px"}}>
                                                                                                    <li><b>상품명 / URL /
                                                                                                        운송장번호</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "340px"}}>
                                                                                                    <li><b>상품메모</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "260px"}}>
                                                                                                    <li><b>상품옵션</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "50px"}}>
                                                                                                    <li><b>수량</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "100px"}}>
                                                                                                    <li><b>구매금액</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "80px"}}>
                                                                                                    <li><b>쇼핑몰배송비/수수료</b>
                                                                                                    </li>
                                                                                                </th>
                                                                                                <th className="tb-head-cont-line-r"
                                                                                                    style={{width: "150px"}}>
                                                                                                    <li><b>개별현황</b></li>
                                                                                                </th>
                                                                                            </tr>
                                                                                            </thead>
                                                                                            {/*국내배송상품*/}
                                                                                            {cData.productsDTO.filter(prod => prod.prodTy === "P04").sort((a, b) => a.seqnum - b.seqnum).map((domestic, index) => (
                                                                                                <tbody key={index}
                                                                                                       className="tb-head-cont-dt">
                                                                                                <tr className="tb-head-cont-line">
                                                                                                    <td>
                                                                                                        <li><input
                                                                                                            onChange={e => handleCheckItem('domestic', i, domestic.seqnum, e.target.checked)}
                                                                                                            checked={selectedItems.domestic[i] ? selectedItems.domestic[i].includes(domestic.seqnum) : false}
                                                                                                            className="admin-input-chkBox"
                                                                                                            type="checkbox"/>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">{index + 1}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <span
                                                                                                                className="ord-prod-img">
                                                                                                                <img
                                                                                                                    className="ord-prod-img-file"
                                                                                                                    src={BtorageWriteLogo}
                                                                                                                    alt="admin-logo"/>
                                                                                                            </span>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b"
                                                                                                            href={domestic.url}
                                                                                                            target="_blank">
                                                                                                            {domestic.name}
                                                                                                        </a></li>
                                                                                                        <li style={{width: "180px"}}>
                                                                                                            <a className="font-b"
                                                                                                               href={domestic.url}
                                                                                                               target="_blank"
                                                                                                               style={{
                                                                                                                   width: "95%",
                                                                                                                   overflow: "hidden",
                                                                                                                   textOverflow: "ellipsis",
                                                                                                                   whiteSpace: "nowrap",
                                                                                                                   wordBreak: "break-all",
                                                                                                                   color: "#98B0D4"
                                                                                                               }}>{domestic.url}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <textarea
                                                                                                                className="admin-input-line prod-textarea-memo"
                                                                                                                cols="52"
                                                                                                                rows="4"
                                                                                                                value={adminProdMemos[domestic.seqnum] || ''} // 초기값 설정
                                                                                                                onChange={(e) => handleProdMemoChange(domestic.seqnum, e.target.value)}
                                                                                                                onKeyDown={(e) => saveProdMemo(e, domestic.seqnum)}
                                                                                                            ></textarea>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <a className="dark-font"
                                                                                                               style={{fontSize: "14px"}}>
                                                                                                                {domestic.option}
                                                                                                            </a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">{domestic.quantity}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">{domestic.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">{domestic?.mallShipPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a>
                                                                                                        </li>
                                                                                                        <li><a
                                                                                                            className="font-b">{domestic.fee.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <a>{prodStPrint(domestic?.prodSt)}</a>
                                                                                                            <a style={{width: "100%"}}>
                                                                                                                {/*여기서부터 커스텀 상품상태 셀렉트*/}
                                                                                                                <div
                                                                                                                    ref={el => domesticProdStRef.current[`${i}-${index}`] = el}
                                                                                                                    style={{
                                                                                                                        height: "30px",
                                                                                                                        width: "100%",
                                                                                                                        position: "relative",
                                                                                                                        padding: "3px"
                                                                                                                    }}>
                                                                                                                    <button
                                                                                                                        className="selectParentBt"
                                                                                                                        style={{
                                                                                                                            width: "100%",
                                                                                                                            height: "100%",
                                                                                                                            backgroundColor: "white",
                                                                                                                            border: "none"
                                                                                                                        }}
                                                                                                                        onClick={() => toggleDomesticProdStShow(i, index)}>
                                                                                                                        <p style={{
                                                                                                                            margin: "0",
                                                                                                                            fontSize: "12px",
                                                                                                                        }}>{selectedProdSt[`${'domestic'}-${i}-${index}`]?.label || '개별변경'}</p>
                                                                                                                        <span
                                                                                                                            style={{
                                                                                                                                position: "absolute",
                                                                                                                                left: "80%",
                                                                                                                                top: "0",
                                                                                                                                height: "100%",
                                                                                                                                width: "20%"
                                                                                                                            }}>
                                                                                                                                    <i style={{
                                                                                                                                        display: "flex",
                                                                                                                                        justifyContent: "center",
                                                                                                                                        alignItems: "center",
                                                                                                                                        height: "100%",
                                                                                                                                        color: "dimgray"
                                                                                                                                    }}><BiCaretDown/></i>

                                                                                                                                </span>
                                                                                                                    </button>
                                                                                                                    {domesticProdStShow[`${i}-${index}`] ?
                                                                                                                        <div
                                                                                                                            style={{
                                                                                                                                width: "100%",
                                                                                                                                border: "solid",
                                                                                                                                maxHeight: "250px",
                                                                                                                                borderWidth: "thin 1px",
                                                                                                                                borderColor: "lightgray",
                                                                                                                                position: "absolute",
                                                                                                                                top: "100%",
                                                                                                                                zIndex: 1000,
                                                                                                                                marginTop: "5px",
                                                                                                                                overflowY: "auto",
                                                                                                                            }}>
                                                                                                                            {prodStList.map((ps, idx) => (
                                                                                                                                <div
                                                                                                                                    className="selectChildBt ht-30"
                                                                                                                                    key={idx}
                                                                                                                                    onClick={() => handleProdStChange('domestic', ps, domestic.seqnum, i, index)}
                                                                                                                                    style={{
                                                                                                                                        display: "flex",
                                                                                                                                        padding: "10px",
                                                                                                                                        justifyContent: "center",
                                                                                                                                        alignItems: "center",
                                                                                                                                        cursor: "pointer",
                                                                                                                                        fontSize: "12px",
                                                                                                                                        borderRadius: "4px",
                                                                                                                                        zIndex: 99,
                                                                                                                                    }}>{ps.label}</div>
                                                                                                                            ))}
                                                                                                                        </div>
                                                                                                                        :
                                                                                                                        null
                                                                                                                    }
                                                                                                                </div>
                                                                                                                {/*여기까지 커스텀 상품상태 셀렉트*/}
                                                                                                            </a>
                                                                                                            {domestic?.modiTime &&
                                                                                                                <a className="dark-font">{formatDateTime(domestic.modiTime)}(수정)</a>}
                                                                                                            {domestic?.orderDate &&
                                                                                                                <a className="dark-font">{formatDateTime(domestic.orderDate)}(구매)</a>}
                                                                                                            {domestic?.arrDate &&
                                                                                                                <a className="dark-font">{formatDateTime(domestic.arrDate)}(도착)</a>}
                                                                                                        </li>
                                                                                                    </td>
                                                                                                </tr>
                                                                                                </tbody>
                                                                                            ))}
                                                                                        </Table>
                                                                                        <div className="cont-dt-bottom">
                                                                                            {/*<span className="dt-bottom-sp-l">*/}
                                                                                            {/*    <button className="admin-btn-B wd-40 ht-25 m-l-7"*/}
                                                                                            {/*            onClick={()=> toggleMenuDTdomesticFn(i, cData.productsDTO.filter(prod => prod.prodTy === "P04").length)}>*/}
                                                                                            {/*        <TbArrowBarToUp className="up-icon"/>*/}
                                                                                            {/*    </button>*/}
                                                                                            {/*</span>*/}
                                                                                            <span
                                                                                                className="dt-bottom-sp-left"
                                                                                                style={{width: "130px"}}>
                                                                    <div style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        width: "100%",
                                                                        height: "100%"
                                                                    }}>
                                                                    {/*여기서부터 커스텀 전체상태변경 셀렉트*/}
                                                                        <div
                                                                            ref={el => allDomesticProdStRefs.current[`${i}`] = el}
                                                                            style={{
                                                                                height: "100%",
                                                                                width: "100%",
                                                                                position: "relative",
                                                                                marginRight: "10px"
                                                                            }}>
                                                                            <button className="selectParentBt" style={{
                                                                                width: "100%",
                                                                                height: "100%"
                                                                            }}
                                                                                    onClick={() => toggleAllDomesticProdStShow(i)}>
                                                                                <p style={{
                                                                                    margin: "0",
                                                                                    fontSize: "13px"
                                                                                }}>{selectedAllDomesticProdSt[i]?.label || '전체변경'}</p>
                                                                                <span style={{
                                                                                    position: "absolute",
                                                                                    left: "80%",
                                                                                    top: "0",
                                                                                    height: "100%",
                                                                                    width: "20%"
                                                                                }}>
                                                                                    <i style={{
                                                                                        display: "flex",
                                                                                        justifyContent: "center",
                                                                                        alignItems: "center",
                                                                                        height: "100%",
                                                                                        color: "dimgray"
                                                                                    }}><BiCaretDown/></i>
                                                                                </span>
                                                                            </button>
                                                                            {allDomesticProdStShow[i] ?
                                                                                <div style={{
                                                                                    width: "100%",
                                                                                    border: "solid",
                                                                                    maxHeight: "250px",
                                                                                    borderWidth: "thin 1px",
                                                                                    borderColor: "lightgray",
                                                                                    position: "absolute",
                                                                                    top: "100%",
                                                                                    zIndex: 1000,
                                                                                    marginTop: "5px",
                                                                                    overflowY: "auto",
                                                                                }}>
                                                                                    {prodStList.map((aps, idx) => (
                                                                                        <div
                                                                                            className="selectChildBt ht-30"
                                                                                            key={idx}
                                                                                            onClick={() => handleAllProdStChange('domestic', i, aps)}
                                                                                            style={{
                                                                                                display: "flex",
                                                                                                padding: "10px",
                                                                                                justifyContent: "center",
                                                                                                alignItems: "center",
                                                                                                cursor: "pointer",
                                                                                                fontSize: "12px",
                                                                                                borderRadius: "4px",
                                                                                                zIndex: 99,
                                                                                            }}>{aps.label}</div>
                                                                                    ))}
                                                                                </div>
                                                                                :
                                                                                null
                                                                            }
                                                                        </div>
                                                                        {/*여기까지 커스텀 전체상태변경 셀렉트*/}
                                                                        </div>
                                                                </span>
                                                                                        </div>

                                                                                    </div>
                                                                                    <div
                                                                                        className="admin-ord-ctg-wrap c-point"
                                                                                        onClick={() => toggleMenuDTdeliveryFn(i, totalP05Count)}>
                                                                                        {isOpenDeliveryItemDt[i] ?
                                                                                            <i className="ord-accordion-icon"
                                                                                               style={{transform: "rotate(90deg)"}}/> :
                                                                                            <i className="ord-accordion-icon"></i>
                                                                                        }
                                                                                        <a className="dark-font font-s-14">배송대행</a>
                                                                                        <a style={{
                                                                                            color: cData.productsDTO.filter(prod => prod.prodTy === "P05").length === 0 ? "dimgrey" : "darkorange",
                                                                                            fontWeight: "bold",
                                                                                            marginLeft: "5px"
                                                                                        }}>{totalP05Count}
                                                                                        </a>
                                                                                        <a>&nbsp;ㅡ {uniqueBoxCount} Box</a>
                                                                                    </div>
                                                                                    <div
                                                                                        className={isOpenDeliveryItemDt[i] ? "order-dt-close" : "order-dt-open"}>
                                                                                        <Table striped bordered hover
                                                                                               style={{tableLayout: "fixed"}}>
                                                                                            <thead
                                                                                                className="tb-head-td-title">
                                                                                            <tr className="tb-head-title-line">
                                                                                                <th className="tb-head-cont-line-l"
                                                                                                    style={{width: "30px"}}>
                                                                                                    <li><input
                                                                                                        className="admin-input-chkBox"
                                                                                                        type="checkbox"
                                                                                                        onChange={e => handleCheckAll('delivery', i, e.target.checked, cData.productsDTO)}
                                                                                                        checked={selectedItems.delivery[i] ? selectedItems.delivery[i].length === cData.productsDTO.filter(prod => prod.prodTy === "P05").length : false}
                                                                                                    /></li>
                                                                                                </th>
                                                                                                <th style={{width: "40px"}}>
                                                                                                    <li><b>품번</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "90px"}}>
                                                                                                    <li><b>사진</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "180px"}}>
                                                                                                    <li><b>TR / 물품명</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "340px"}}>
                                                                                                    <li><b>상품메모</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "260px"}}>
                                                                                                    <li><b>상품옵션</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "50px"}}>
                                                                                                    <li><b>수량</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "100px"}}>
                                                                                                    <li><b>구매금액</b></li>
                                                                                                </th>
                                                                                                <th style={{width: "80px"}}>
                                                                                                    <li><b>스캔</b></li>
                                                                                                </th>
                                                                                                <th className="tb-head-cont-line-r"
                                                                                                    style={{width: "150px"}}>
                                                                                                    <li><b>개별현황</b></li>
                                                                                                </th>
                                                                                            </tr>
                                                                                            </thead>
                                                                                            {/*배송대행상품*/}
                                                                                            {cData.productsDTO.filter(prod => prod.prodTy === "P05").sort((a, b) => a.seqnum - b.seqnum).map((delivery, index) => (
                                                                                                <tbody key={index}
                                                                                                       className="tb-head-cont-dt">
                                                                                                <tr className="tb-head-cont-line">
                                                                                                    <td>
                                                                                                        <li><input
                                                                                                            onChange={e => handleCheckItem('delivery', i, delivery.seqnum, e.target.checked)}
                                                                                                            checked={selectedItems.delivery[i] ? selectedItems.delivery[i].includes(delivery.seqnum) : false}
                                                                                                            className="admin-input-chkBox"
                                                                                                            type="checkbox"/>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">{index + 1}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <span
                                                                                                                className="ord-prod-img">
                                                                                                                <img
                                                                                                                    className="ord-prod-img-file"
                                                                                                                    src={BtorageWriteLogo}
                                                                                                                    alt="admin-logo"/>
                                                                                                            </span>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <a>{delivery.domShipco}</a>
                                                                                                        </li>
                                                                                                        <li style={{
                                                                                                            display: "flex",
                                                                                                            justifyContent: "center",
                                                                                                            marginTop: "5px",
                                                                                                            marginBottom: "5px",
                                                                                                            flexDirection: "row"
                                                                                                        }}>
                                                                                                            <a onClick={() => selectDsTrackNum(delivery.domShipco, delivery.inWaynum)}
                                                                                                               className="m-r-3 font-b c-point font-c-progress text-underline">{delivery?.inWaynum || ""}
                                                                                                            </a>
                                                                                                            {!copiedIndexes.includes(index) && (
                                                                                                                <RxCopy
                                                                                                                    className="m-l-3 font-s-18 c-point btorage-hover btn-click-event"
                                                                                                                    style={{opacity: "0.65"}}
                                                                                                                    onClick={() => handleCopy(delivery.inWaynum.trim(), index)}/>
                                                                                                            )}
                                                                                                            {copiedIndexes.includes(index) &&
                                                                                                                <RxCheck
                                                                                                                    className="m-l-3 font-s-18 font-c-btorage"
                                                                                                                    style={{opacity: "0.65"}}/>}
                                                                                                        </li>
                                                                                                        <li>
                                                                                                            <a className="font-b">{delivery.name}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <textarea
                                                                                                                className="admin-input-line prod-textarea-memo"
                                                                                                                cols="52"
                                                                                                                rows="4"
                                                                                                                value={adminProdMemos[delivery.seqnum] || ''} // 초기값 설정
                                                                                                                onChange={(e) => handleProdMemoChange(delivery.seqnum, e.target.value)}
                                                                                                                onKeyDown={(e) => saveProdMemo(e, delivery.seqnum)}
                                                                                                            ></textarea>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <a className="dark-font"
                                                                                                               style={{fontSize: "14px"}}>
                                                                                                                {delivery.option}
                                                                                                            </a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li><a
                                                                                                            className="font-b">{delivery.quantity}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        {/*<li><a*/}
                                                                                                        {/*    className="font-b">{delivery.cusPrice.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") || 0}</a>*/}
                                                                                                        {/*</li>*/}
                                                                                                        <li><a
                                                                                                            className="font-b">{(delivery.cusPrice || 0).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a>
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            {scannedInvoices.includes(delivery?.inWaynum) && (
                                                                                                                <p className="font-s-26 font-b c-def font-c-success">✔</p>
                                                                                                            )}
                                                                                                        </li>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <li>
                                                                                                            <a>{prodStPrint(delivery?.prodSt)}</a>
                                                                                                            <a style={{width: "100%"}}>
                                                                                                                {/*여기서부터 커스텀 상품상태 셀렉트*/}
                                                                                                                <div
                                                                                                                    ref={el => deliveryProdStRef.current[`${i}-${index}`] = el}
                                                                                                                    style={{
                                                                                                                        height: "30px",
                                                                                                                        width: "100%",
                                                                                                                        position: "relative",
                                                                                                                        padding: "3px"
                                                                                                                    }}>
                                                                                                                    <button
                                                                                                                        className="selectParentBt"
                                                                                                                        style={{
                                                                                                                            width: "100%",
                                                                                                                            height: "100%",
                                                                                                                            backgroundColor: "white",
                                                                                                                            border: "none"
                                                                                                                        }}
                                                                                                                        onClick={() => toggleDeliveryProdStShow(i, index)}>
                                                                                                                        <p style={{
                                                                                                                            margin: "0",
                                                                                                                            fontSize: "12px",
                                                                                                                        }}>{selectedProdSt[`${'delivery'}-${i}-${index}`]?.label || '개별변경'}</p>
                                                                                                                        <span
                                                                                                                            style={{
                                                                                                                                position: "absolute",
                                                                                                                                left: "80%",
                                                                                                                                top: "0",
                                                                                                                                height: "100%",
                                                                                                                                width: "20%"
                                                                                                                            }}>
                                                                                                                            <i style={{
                                                                                                                                display: "flex",
                                                                                                                                justifyContent: "center",
                                                                                                                                alignItems: "center",
                                                                                                                                height: "100%",
                                                                                                                                color: "dimgray"
                                                                                                                            }}><BiCaretDown/></i>
                                                                                                                        </span>
                                                                                                                    </button>
                                                                                                                    {deliveryProdStShow[`${i}-${index}`] ?
                                                                                                                        <div
                                                                                                                            style={{
                                                                                                                                width: "100%",
                                                                                                                                border: "solid",
                                                                                                                                maxHeight: "250px",
                                                                                                                                borderWidth: "thin 1px",
                                                                                                                                borderColor: "lightgray",
                                                                                                                                position: "absolute",
                                                                                                                                top: "100%",
                                                                                                                                zIndex: 1000,
                                                                                                                                marginTop: "5px",
                                                                                                                                overflowY: "auto",
                                                                                                                            }}>
                                                                                                                            {prodStList.map((ps, idx) => (
                                                                                                                                <div
                                                                                                                                    className="selectChildBt ht-30"
                                                                                                                                    key={idx}
                                                                                                                                    onClick={() => handleProdStChange('delivery', ps, delivery.seqnum, i, index)}
                                                                                                                                    style={{
                                                                                                                                        display: "flex",
                                                                                                                                        padding: "10px",
                                                                                                                                        justifyContent: "center",
                                                                                                                                        alignItems: "center",
                                                                                                                                        cursor: "pointer",
                                                                                                                                        fontSize: "12px",
                                                                                                                                        borderRadius: "4px",
                                                                                                                                        zIndex: 99,
                                                                                                                                    }}>{ps.label}</div>
                                                                                                                            ))}
                                                                                                                        </div>
                                                                                                                        :
                                                                                                                        null
                                                                                                                    }
                                                                                                                </div>
                                                                                                                {/*여기까지 커스텀 상품상태 셀렉트*/}
                                                                                                            </a>
                                                                                                            {delivery?.modiTime &&
                                                                                                                <a className="dark-font">{formatDateTime(delivery.modiTime)}(수정)</a>}
                                                                                                            {delivery?.arrDate &&
                                                                                                                <a className="dark-font">{formatDateTime(delivery.arrDate)}(도착)</a>}
                                                                                                        </li>
                                                                                                    </td>
                                                                                                </tr>
                                                                                                </tbody>
                                                                                            ))}
                                                                                        </Table>
                                                                                        <div className="cont-dt-bottom">
                                                                                            {/*<span className="dt-bottom-sp-l">*/}
                                                                                            {/*    <button className="admin-btn-B wd-40 ht-25 m-l-7"*/}
                                                                                            {/*            onClick={()=> toggleMenuDTdeliveryFn(i, cData.productsDTO.filter(prod => prod.prodTy === "P05").length)}>*/}
                                                                                            {/*        <TbArrowBarToUp className="up-icon"/>*/}
                                                                                            {/*    </button>*/}
                                                                                            {/*</span>*/}
                                                                                            <span
                                                                                                className="dt-bottom-sp-left">
                                                                                                <div
                                                                                                    className="wd-130 ht-25"
                                                                                                    style={{
                                                                                                        display: "flex",
                                                                                                        alignItems: "center"
                                                                                                    }}>
                                                                                                {/*여기서부터 커스텀 전체상태변경 셀렉트*/}
                                                                                                    <div
                                                                                                        ref={el => allDeliveryProdStRefs.current[`${i}`] = el}
                                                                                                        style={{
                                                                                                            height: "100%",
                                                                                                            width: "100%",
                                                                                                            position: "relative",
                                                                                                            marginRight: "10px"
                                                                                                        }}>
                                                                                                        <button
                                                                                                            className="selectParentBt"
                                                                                                            style={{
                                                                                                                width: "100%",
                                                                                                                height: "100%"
                                                                                                            }}
                                                                                                            onClick={() => toggleAllDeliveryProdStShow(i)}>
                                                                                                            <p style={{fontSize: "13px"}}>{selectedAllDeliveryProdSt[i]?.label || '전체변경'}</p>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    position: "absolute",
                                                                                                                    left: "80%",
                                                                                                                    top: "0",
                                                                                                                    height: "100%",
                                                                                                                    width: "20%"
                                                                                                                }}>
                                                                                                                <i style={{
                                                                                                                    display: "flex",
                                                                                                                    justifyContent: "center",
                                                                                                                    alignItems: "center",
                                                                                                                    height: "100%",
                                                                                                                    color: "dimgray"
                                                                                                                }}><BiCaretDown/></i>
                                                                                                            </span>
                                                                                                        </button>
                                                                                                        {allDeliveryProdStShow[i] ?
                                                                                                            <div
                                                                                                                style={{
                                                                                                                    width: "100%",
                                                                                                                    border: "solid",
                                                                                                                    maxHeight: "250px",
                                                                                                                    borderWidth: "thin 1px",
                                                                                                                    borderColor: "lightgray",
                                                                                                                    position: "absolute",
                                                                                                                    top: "100%",
                                                                                                                    zIndex: 1000,
                                                                                                                    marginTop: "5px",
                                                                                                                    overflowY: "auto",
                                                                                                                }}>
                                                                                                                {prodStList.map((aps, idx) => (
                                                                                                                    <div
                                                                                                                        className="selectChildBt ht-30"
                                                                                                                        key={idx}
                                                                                                                        onClick={() => handleAllProdStChange('delivery', i, aps)}
                                                                                                                        style={{
                                                                                                                            display: "flex",
                                                                                                                            padding: "10px",
                                                                                                                            justifyContent: "center",
                                                                                                                            alignItems: "center",
                                                                                                                            cursor: "pointer",
                                                                                                                            fontSize: "12px",
                                                                                                                            borderRadius: "4px",
                                                                                                                            zIndex: 99,
                                                                                                                        }}>{aps.label}</div>
                                                                                                                ))}
                                                                                                            </div>
                                                                                                            :
                                                                                                            null
                                                                                                        }
                                                                                                    </div>
                                                                                                    {/*여기까지 커스텀 전체상태변경 셀렉트*/}
                                                                                                    </div>
                                                                                            </span>
                                                                                            <span className="dt-bottom-sp-r"
                                                                                                  style={{marginRight: "10px"}}>
                                                                                                <label
                                                                                                    className="font-s-12 m-r-5">운송장스캔</label>
                                                                                                <input
                                                                                                    className="admin-input-line bt-border-hover wd-200 ht-30 p-l-5"
                                                                                                    type="text"
                                                                                                    value={scannedInvoiceNum}
                                                                                                    onChange={handleInvoiceScanChange}
                                                                                                    onKeyDown={handleKeyPress}
                                                                                                />
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                                </tbody>
                                                            ) :
                                                            // payinfo map[배송료]
                                                            cData.type === 'payinfo' && (cData.payType === "PT1") ? (
                                                                    <tbody className="ord-main-tb-body" style={{zIndex: 1}}
                                                                           key={key} data-vs-row={i}>
                                                                    <tr className="ord-main-tb-body-line">
                                                                        <td>
                                                                            <li>
                                                                                <input className="admin-input-chkBox"
                                                                                       type="checkbox" name={cData.seqNum}
                                                                                       checked={checkedKeySet.has(makeCheckKey('payinfo', cData.seqNum))}
                                                                                       onChange={() => checkBoxChange(cData.seqNum, 'payinfo')}/>
                                                                            </li>
                                                                        </td>
                                                                        <td>
                                                                            <li style={{alignItems: "center"}}>
                                                                                <img className="wd-20 ht-20"
                                                                                     alt="" src={shipIMG}
                                                                                     style={{margin: "5px 0"}}/>
                                                                                <a className="font-b">{cData.orderdtDTO.orderNumber}-{cData.shipInfoDTO.boxNum}</a>
                                                                                {/*<a>A1234</a>*/} {/*랙&위치번호*/}
                                                                                <p className="font-b m-t-2 font-s-14">배송료</p>
                                                                                <span style={{
                                                                                    display: "flex",
                                                                                    flexDirection: "row",
                                                                                    marginTop: "15px"
                                                                                }}>
                                                                                    <a>
                                                                                        <button
                                                                                            className="admin-btn-B wd-45 ht-30 m-t-3"
                                                                                            onClick={() => deliveryDetailTrueFn(cData.seqNum)}>상세</button>
                                                                                    </a>
                                                                                </span>
                                                                            </li>
                                                                        </td>
                                                                        <td>
                                                                            <li className="position-relative">
                                                                                <a>BT{cData.orderdtDTO.memberDTO.mbNum}</a>{/* [구매대행 API] 쇼핑몰 API 연동 가입회원 표시 */}<ApiJoinBadge apiJoinFl={cData.orderdtDTO.memberDTO.apiJoinFl}/>
                                                                                <div
                                                                                    className="display-flex flex-row just-cont-center">
                                                                                    <p className="font-b c-point btorage-hover font-s-14"
                                                                                       onClick={() => toggleInfoMenu(cData.seqNum, 'info')}
                                                                                       style={{color: infoToggleSt[cData.seqNum] ? "#FFAF34" : ""}}>
                                                                                        {cData.orderdtDTO.memberDTO.userName}
                                                                                    </p>
                                                                                    {cData.orderdtDTO.memberDTO.spfRegName && cData.orderdtDTO.memberDTO.spfRegName.trim() && (
                                                                                        <p className="m-l-5 font-s-10 c-def p-t-2">🚨</p>
                                                                                    )}
                                                                                </div>
                                                                                {infoToggleSt[cData.seqNum] && (
                                                                                    <div
                                                                                        className="user-dt-info-container font-s-13 pd12 c-def"
                                                                                        ref={menuRef}>
                                                                                        <div
                                                                                            className="display-flex flex-column">
                                                                                            <div className="m-b-7">
                                                                                                <p className="text-left c-point btorage-hover"
                                                                                                   onClick={() => handleViewDetail(cData.orderdtDTO.memberDTO.userName)}>
                                                                                                    상세정보보기 <IoIosArrowDropright
                                                                                                    className="font-s-15"/>
                                                                                                </p>
                                                                                            </div>
                                                                                            <div
                                                                                                className="display-flex flex-column text-left just-cont-sb gap5">
                                                                                                <div
                                                                                                    className="display-flex flex-row wd-100pc">
                                                                                                    <p className="wd-35">계정:</p>
                                                                                                    <p className="wd-auto">{cData.orderdtDTO.memberDTO.id}</p>
                                                                                                    {!copiedIndexes.includes(i) && (
                                                                                                        <RxCopy
                                                                                                            className="m-l-7 font-s-18 c-point btorage-hover btn-click-event m-a-opc-07"
                                                                                                            onClick={() => handleCopy(cData.orderdtDTO.memberDTO.id.trim(), i)}/>
                                                                                                    )}
                                                                                                    {copiedIndexes.includes(i) &&
                                                                                                        <RxCheck
                                                                                                            className="m-l-7 font-s-18 font-c-btorage m-a-opc-07"/>}
                                                                                                </div>
                                                                                                <div
                                                                                                    className="display-flex flex-row wd-100pc">
                                                                                                    <p className="wd-35">@@:</p>
                                                                                                    <p className="display-flex wd-auto ht-auto font-c-progress font-b">{cData.orderdtDTO.memberDTO.spfRegName}</p>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                                <a style={{
                                                                                    display: 'inline-block',
                                                                                    maxWidth: '200px',
                                                                                    overflowWrap: 'break-word',
                                                                                    wordBreak: 'break-word',
                                                                                    whiteSpace: 'normal',
                                                                                    verticalAlign: 'middle',
                                                                                    textAlign: 'center'
                                                                                }}>{cData.appRecDTO.recname}</a>
                                                                            </li>
                                                                        </td>
                                                                        <td>
                                                                            <li>
                                                                                <a className="font-b">{cData.appRecDTO.countryDTO.countryNm + "[" + cData.appRecDTO.countryDTO.countryCode + "]"}</a>
                                                                                <a>{cData.orderdtDTO.memberDTO.lang}</a>
                                                                            </li>
                                                                        </td>
                                                                        <td>
                                                                            <li className="admin-tb-text-cut">
                                                                                {/*{cData && cData.packListDTO && cData.packListDTO.productsDTO && cData.packListDTO.productsDTO.length > 0 && (*/}
                                                                                {/*    <div>*/}
                                                                                {/*        {cData.packListDTO.productsDTO.sort((a,b) => a.seqNum - b.seqNum).slice(0, 6)*/}
                                                                                {/*            .map((product, index) => (*/}
                                                                                {/*            <div key={index}><a>{product.name}</a></div>*/}
                                                                                {/*        ))}*/}
                                                                                {/*    </div>*/}
                                                                                {/*)}*/}
                                                                                {cData?.packListDTO?.productsDTO?.length === 0 ? (
                                                                                    <div><a>첫번째 박스에서 나누어진 상품</a></div>
                                                                                ) : (
                                                                                    <div>
                                                                                        {cData.packListDTO.productsDTO.sort((a, b) => a.seqNum - b.seqNum).slice(0, 6)
                                                                                            .map((product, index) => (
                                                                                                <div key={index}>
                                                                                                    <a>{product.name}</a>
                                                                                                </div>
                                                                                            ))}
                                                                                    </div>
                                                                                )}
                                                                            </li>
                                                                        </td>
                                                                        <td>
                                                                            <li>
                                                                                <a className="font-b">
                                                                                    {orderStPrint(
                                                                                        cData.payStatus === "PS0" ? "OS09" :
                                                                                            cData.payStatus === "PS1" ? "OS10" :
                                                                                                cData.payStatus === "PS2" ? "OS11" :
                                                                                                    cData.payStatus === "PS3" ? "OS12" :
                                                                                                        cData.payStatus === "PS4" ? "OS13" :
                                                                                                            cData.payStatus === "PS5" ? "OS14" : null)}
                                                                                </a>
                                                                            </li>
                                                                        </td>
                                                                        <td>
                                                                            <li style={{alignItems: "center"}}>
                                                                                {
                                                                                    (cData.ttFedexPrice > 0 ||
                                                                                        cData.ttFedexEcoPrice > 0 ||
                                                                                        cData.ttUpsPrice > 0 ||
                                                                                        cData.ttUpsEcoPrice > 0 ||
                                                                                        cData.ttEmsPrice > 0 ||
                                                                                        cData.ttEmsPrePrice > 0 ||
                                                                                        cData.ttKPackPrice > 0 ||
                                                                                        cData.ttAirSPrice > 0 ||
                                                                                        cData.ttSeaPrice > 0) ? (
                                                                                        <a>
                                                                                            {getSpecificShippingName(cData) || convertToShipco(cData.dvType, cData.orderdtDTO.shipco)}
                                                                                        </a>
                                                                                    ) : (
                                                                                        cData.ttDomPrice > 0 ?
                                                                                            <a>국내배송</a> : null
                                                                                    )
                                                                                }
                                                                                {editMode === cData.seqNum ? (
                                                                                    <input type="text"
                                                                                           className="admin-input-line m-0-a font-b font-c-cancel wd-100pc ht-25 text-center font-s-13 com-input"
                                                                                           maxLength="18"
                                                                                           value={editedWayNum.outWayNum}
                                                                                           onChange={(e) => handleFeeChange(e, 'outWayNum')}
                                                                                    />
                                                                                ) : (
                                                                                    <div>
                                                                                        <a onClick={() => cData.ttDomPrice > 0 ? selectDsTrackNum(convertToShipco(cData.dvType), cData.shipInfoDTO?.outWayNum)
                                                                                            : selectOsTrackNum(convertToShipco(cData.dvType), cData.shipInfoDTO?.outWayNum)}
                                                                                           className="m-r-7 font-b c-point font-c-progress text-underline">{cData.shipInfoDTO.outWayNum}</a>
                                                                                        {cData.shipInfoDTO?.outWayNum !== "" && cData.shipInfoDTO?.outWayNum !== 0 && cData.shipInfoDTO?.outWayNum !== null &&
                                                                                            <div>
                                                                                                {/*운송장복사*/}
                                                                                                <RxCopy
                                                                                                    className="font-s-18 c-point btorage-hover btn-click-event"
                                                                                                    style={{opacity: "0.65"}}
                                                                                                    onClick={() => handleCopy(cData.shipInfoDTO?.outWayNum)}/>
                                                                                                {/*운송장변경*/}
                                                                                                <MdOutlineChangeCircle
                                                                                                    className="m-l-3 font-s-20 c-point btorage-hover btn-click-event m-a-opc-07"
                                                                                                    onClick={() => handleChangeValue(cData.shipInfoDTO.seqNum, 'os', cData.shipInfoDTO?.outWayNum)}/>
                                                                                            </div>
                                                                                        }
                                                                                    </div>
                                                                                )}
                                                                                {cData.shipInfoDTO?.outWayNum
                                                                                    ?
                                                                                    <a onClick={() => handleChangeValue(cData.shipInfoDTO.seqNum, "osp", cData.shipInfoDTO?.shipPrice)}
                                                                                       className="ship-fee-text c-point mt-1">배송료: {Number(cData.shipInfoDTO?.shipPrice).toLocaleString()}</a>
                                                                                    : <a></a>
                                                                                }
                                                                            </li>
                                                                        </td>
                                                                        <td>
                                                                            <li className="wd-100pc ht-100pc position-relative">
                                                                                {/*<a>{cData.customsDTO.custQty}개</a>*/}
                                                                                <span>
                                                                                    {totalProdQyDv(cData) > 0 ?
                                                                                        <a style={{
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            justifyContent: "center"
                                                                                        }}>{totalProdQyDv(cData)}개</a>
                                                                                        :
                                                                                        <a style={{
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            justifyContent: "center"
                                                                                        }}>1개</a>
                                                                                    }
                                                                                </span>
                                                                                <div className="user-center">
                                                                                    <a className="m-r-3 font-b"
                                                                                       style={{color: cData.customsDTO.custPrice > 800 ? "#E06974" : "#7EAAE6"}}>{cData.customsDTO.custPrice}</a>
                                                                                    <div className="user-center">
                                                                                        <a style={{fontSize: "10px"}}>{cData.customsDTO.custCurrency}</a>
                                                                                    </div>
                                                                                </div>
                                                                                {cData.customsDTO.insrFl ?
                                                                                    <div style={{
                                                                                        display: "flex",
                                                                                        justifyContent: "center"
                                                                                    }}>
                                                                                        <a className="font-b font-c-cancel">Y</a>
                                                                                        <a style={{marginLeft: "5px"}}>({cData.customsDTO.insrPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")})</a>
                                                                                    </div>
                                                                                    :
                                                                                    <a>N</a>
                                                                                }

                                                                                {/* 드랍다운버튼 */}
                                                                                <div
                                                                                    className="cust-content-preview m-t-3 c-point"
                                                                                    onClick={() => togglePopover(cData.seqNum)}
                                                                                    title="클릭하여 전체 내용 보기">
                                                                                    <a>{cData.customsDTO.custContent}</a>
                                                                                </div>

                                                                                {/* 드랍다운팝업 */}
                                                                                {payDropSeqNum === cData.seqNum && (
                                                                                    <div
                                                                                        className="cust-content-popover">
                                                                                        <div className="popover-header">
                                                                                            <span>전체 세관신고내용</span>
                                                                                            <button
                                                                                                className="close-btn"
                                                                                                onClick={closePopover}>✖
                                                                                            </button>
                                                                                        </div>
                                                                                        <div className="popover-body">
                                                                                            {cData.customsDTO.custContent}
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                                {/*<a className="wd-100pc m-t-3">{cData.customsDTO.custContent}</a>*/}
                                                                            </li>
                                                                        </td>
                                                                        <td className="wd-100pc">
                                                                            {cData.ttFedexPrice > 0
                                                                            || cData.ttFedexEcoPrice > 0
                                                                            || cData.ttUpsPrice > 0
                                                                            || cData.ttUpsEcoPrice > 0
                                                                            || cData.ttEmsPrice > 0
                                                                            || cData.ttEmsPrePrice > 0
                                                                            || cData.ttKPackPrice > 0
                                                                            || cData.ttAirSPrice > 0
                                                                            || cData.ttSeaPrice > 0 ?
                                                                                <li className="wd-100pc"
                                                                                    style={{gap: "8px"}}>
                                                                                    {cData?.ttFedexPrice > 0 && (cData.payStatus === "PS3" && cData.dvType === "D01" || cData.payStatus !== "PS3") && (
                                                                                        <div
                                                                                            className="display-flex flex-row just-cont-center wd-100pc">
                                                                                            <a className="font-b wd-15pc text-center">F:&nbsp;</a>
                                                                                            <a className="wd-85pc"
                                                                                               style={{
                                                                                                   color: cData?.ttFedexPrice > 0 && cData?.payStatus === "PS0" ? "darkorange" : "black",
                                                                                                   fontWeight: cData?.ttFedexPrice > 0 ? "bold" : "normal"
                                                                                               }}>
                                                                                                {cData?.ttFedexPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                            </a>
                                                                                        </div>
                                                                                    )}
                                                                                    {cData?.ttFedexEcoPrice > 0 && (cData.payStatus === "PS3" && cData.dvType === "D16" || cData.payStatus !== "PS3") && (
                                                                                        <div
                                                                                            className="display-flex flex-row just-cont-center wd-100pc">
                                                                                            <a className="font-b wd-15pc text-center">Fe:&nbsp;</a>
                                                                                            <a className="wd-85pc" style={{
                                                                                                color: cData?.ttFedexEcoPrice > 0 && cData?.payStatus === "PS0" ? "darkorange" : "black",
                                                                                                fontWeight: cData?.ttFedexEcoPrice > 0 ? "bold" : "normal"
                                                                                            }}>
                                                                                                {cData?.ttFedexEcoPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                            </a>
                                                                                        </div>
                                                                                    )}
                                                                                    {cData?.ttUpsPrice > 0 && (cData.payStatus === "PS3" && cData.dvType === "D11" || cData.payStatus !== "PS3") && (
                                                                                        <div
                                                                                            className="display-flex flex-row just-cont-center wd-100pc">
                                                                                            <a className="font-b wd-15pc text-center">U:&nbsp;</a>
                                                                                            <a className="wd-85pc" style={{
                                                                                                color: cData?.ttUpsPrice > 0 && cData?.payStatus === "PS0" ? "darkorange" : "black",
                                                                                                fontWeight: cData?.ttUpsPrice > 0 ? "bold" : "normal"
                                                                                            }}>
                                                                                                {cData?.ttUpsPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                            </a>
                                                                                        </div>
                                                                                    )}
                                                                                    {cData?.ttUpsEcoPrice > 0 && (cData.payStatus === "PS3" && cData.dvType === "D17" || cData.payStatus !== "PS3") && (
                                                                                        <div
                                                                                            className="display-flex flex-row just-cont-center wd-100pc">
                                                                                            <a className="font-b wd-15pc text-center">Ue:&nbsp;</a>
                                                                                            <a className="wd-85pc" style={{
                                                                                                color: cData?.ttUpsEcoPrice > 0 && cData?.payStatus === "PS0" ? "darkorange" : "black",
                                                                                                fontWeight: cData?.ttUpsEcoPrice > 0 ? "bold" : "normal"
                                                                                            }}>
                                                                                                {cData?.ttUpsEcoPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                            </a>
                                                                                        </div>
                                                                                    )}
                                                                                    {cData?.ttEmsPrePrice > 0 && (cData.payStatus === "PS3" && cData.dvType === "D15" || cData.payStatus !== "PS3") && (
                                                                                        <div
                                                                                            className="display-flex flex-row just-cont-center wd-100pc">
                                                                                            <a className="font-b wd-15pc text-center">Ep:&nbsp;</a>
                                                                                            <a className="wd-85pc" style={{
                                                                                                color: cData?.ttEmsPrePrice > 0 && cData?.payStatus === "PS0" ? "darkorange" : "black",
                                                                                                fontWeight: cData?.ttEmsPrePrice > 0 ? "bold" : "normal"
                                                                                            }}>
                                                                                                {cData?.ttEmsPrePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                            </a>
                                                                                        </div>
                                                                                    )}
                                                                                    {cData?.ttEmsPrice > 0 && (cData.payStatus === "PS3" && cData.dvType === "D02" || cData.payStatus !== "PS3") && (
                                                                                        <div
                                                                                            className="display-flex flex-row just-cont-center wd-100pc">
                                                                                            <a className="font-b wd-15pc text-center">E:&nbsp;</a>
                                                                                            <a className="wd-85pc" style={{
                                                                                                color: cData?.ttEmsPrice > 0 && cData?.payStatus === "PS0" ? "darkorange" : "black",
                                                                                                fontWeight: cData?.ttEmsPrice > 0 ? "bold" : "normal"
                                                                                            }}>
                                                                                                {cData?.ttEmsPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                            </a>
                                                                                        </div>
                                                                                    )}
                                                                                    {cData?.ttKPackPrice > 0 && (cData.payStatus === "PS3" && cData.dvType === "D13" || cData.payStatus !== "PS3") && (
                                                                                        <div
                                                                                            className="display-flex flex-row just-cont-center wd-100pc">
                                                                                            <a className="font-b wd-15pc text-center">K:&nbsp;</a>
                                                                                            <a className="wd-85pc" style={{
                                                                                                color: cData?.ttKPackPrice > 0 && cData?.payStatus === "PS0" ? "darkorange" : "black",
                                                                                                fontWeight: cData?.ttKPackPrice > 0 ? "bold" : "normal"
                                                                                            }}>
                                                                                                {cData?.ttKPackPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                            </a>
                                                                                        </div>
                                                                                    )}
                                                                                    {cData?.ttAirSPrice > 0 && (cData.payStatus === "PS3" && cData.dvType === "D14" || cData.payStatus !== "PS3") && (
                                                                                        <div
                                                                                            className="display-flex flex-row just-cont-center wd-100pc">
                                                                                            <a className="font-b wd-15pc text-center">A:&nbsp;</a>
                                                                                            <a className="wd-85pc" style={{
                                                                                                color: cData?.ttAirSPrice > 0 && cData?.payStatus === "PS0" ? "darkorange" : "black",
                                                                                                fontWeight: cData?.ttAirSPrice > 0 ? "bold" : "normal"
                                                                                            }}>
                                                                                                {cData?.ttAirSPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                            </a>
                                                                                        </div>
                                                                                    )}
                                                                                    {cData?.ttSeaPrice > 0 && (cData.payStatus === "PS3" && cData.dvType === "D03" || cData.payStatus !== "PS3") && (
                                                                                        <div
                                                                                            className="display-flex flex-row just-cont-center wd-100pc">
                                                                                            <a className="font-b wd-15pc text-center">S:&nbsp;</a>
                                                                                            <a className="wd-85pc" style={{
                                                                                                color: cData?.ttSeaPrice > 0 && cData?.payStatus === "PS0" ? "darkorange" : "black",
                                                                                                fontWeight: cData?.ttSeaPrice > 0 ? "bold" : "normal"
                                                                                            }}>
                                                                                                {cData?.ttSeaPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                            </a>
                                                                                        </div>
                                                                                    )}
                                                                                </li>
                                                                                :
                                                                                cData.ttDomPrice > 0 ?
                                                                                    <li>
                                                                                        <a style={{lineHeight: "24px"}}>국내배송</a>
                                                                                        <a style={{
                                                                                            lineHeight: "26px",
                                                                                            color: cData?.ttDomPrice > 0 && cData?.payStatus === "PS0" ? "darkorange" : "black",
                                                                                            fontWeight: "bold"
                                                                                        }}>
                                                                                            {cData?.ttDomPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                        </a>
                                                                                    </li>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            {totalProdQyDv(cData) > 0 ?
                                                                                <a style={{
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center"
                                                                                }}>{totalProdQyDv(cData)}개</a>
                                                                                :
                                                                                <a style={{
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center"
                                                                                }}>1개</a>
                                                                            }
                                                                            <div style={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                margin: "5px 0 0 2px"
                                                                            }}>
                                                                                <img style={{
                                                                                    width: "18px",
                                                                                    height: "18px"
                                                                                }}
                                                                                     alt="deposit" src={deposit}/>
                                                                                <a style={{
                                                                                    color: cData.orderdtDTO.memberDTO.deposit < 0 ? "#FF6628" : "black",
                                                                                    marginLeft: "4px"
                                                                                }}>
                                                                                    {cData.orderdtDTO.memberDTO.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                </a>
                                                                            </div>
                                                                            <div style={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                marginLeft: "3px"
                                                                            }}>
                                                                                <img style={{
                                                                                    width: "16px",
                                                                                    height: "16px"
                                                                                }}
                                                                                     alt="point" src={point}/>
                                                                                <a style={{
                                                                                    color: cData.orderdtDTO.memberDTO.point < 0 ? "#FF6628" : "black",
                                                                                    marginLeft: "5px"
                                                                                }}>
                                                                                    {cData.orderdtDTO.memberDTO.point.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                </a>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <li>
                                                                                <a style={{lineHeight: "28px"}}>{formatDateTime(cData.regTime)}</a>
                                                                                <a className="font-b"
                                                                                   style={{lineHeight: "28px"}}>{formatDateTime(cData.orderdtDTO?.modiTime)}</a>
                                                                                <a style={{lineHeight: "28px"}}>{cData?.shipTime ? formatDateTime(cData?.shipTime) : cData.shipInfoDTO?.outRegTime ? formatDateTime(cData.shipInfoDTO.outRegTime) : "-"}</a>
                                                                                <a style={{lineHeight: "28px"}}>{cData.shipInfoDTO?.regTime ? formatDateTime(cData.shipInfoDTO.regTime) : "-"}</a>
                                                                            </li>
                                                                        </td>
                                                                        <td>
                                                                            <li className="gap8"
                                                                                style={{alignItems: "center"}}>
                                                                                {cData.type === "payinfo" && !["PS3", "PS2", "PS5"].includes(cData.payStatus) &&
                                                                                    <button
                                                                                        className="admin-btn-B wd-75 ht-30 font-s-12 btn-click-event"
                                                                                        onClick={() => openModal(cData, 'payinfo')}>
                                                                                        비용수정
                                                                                    </button>
                                                                                }
                                                                                {cData.type === "payinfo" && !["PS3", "PS2", "PS5"].includes(cData.payStatus) &&
                                                                                    <button
                                                                                        className="admin-btn-B wd-75 ht-30 font-s-12 btn-click-event"
                                                                                        onClick={() => alert3(cData)}>
                                                                                        등록취소
                                                                                    </button>
                                                                                }
                                                                                {cData.type === "payinfo" && cData.payStatus === "PS3" && selectedProcessSt === "PS3" &&
                                                                                    <>
                                                                                        <button
                                                                                            className="admin-btn-B wd-75 ht-30 font-s-12 btn-click-event"
                                                                                            onClick={() => openDeliveryCancelSt(cData.seqNum)}>출고취소
                                                                                        </button>
                                                                                        {cData.dvType === "D03" || cData.dvType === "D13" || cData.dvType === "D14" || cData.dvType === "D15" && (
                                                                                            <button
                                                                                                className="admin-btn-B wd-75 ht-30 font-s-12 btn-click-event">EMS취소</button>
                                                                                        )}
                                                                                        {cData.dvType === "D17" || cData.dvType === "D11" && (
                                                                                            <button
                                                                                                className="admin-btn-B wd-75 ht-30 font-s-12 btn-click-event"
                                                                                                onClick={() => cancelUpsShipment(cData.shipInfoDTO.outWayNum)}>UPS취소</button>
                                                                                        )}
                                                                                        {editMode === cData.seqNum ? (
                                                                                            <button
                                                                                                className="admin-btn-A wd-75 ht-30 font-s-12 btn-click-event"
                                                                                                onClick={() => handleSaveClick(cData.shipInfoDTO.seqNum)}>
                                                                                                저장
                                                                                            </button>
                                                                                        ) : (
                                                                                            <button
                                                                                                className="admin-btn-B wd-75 ht-30 font-s-12 btn-click-event"
                                                                                                onClick={() => handleEditClick(cData)}>
                                                                                                운송장수정
                                                                                            </button>
                                                                                        )}
                                                                                    </>
                                                                                }
                                                                            </li>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colSpan="12">
                                                                            <div className="cont-dt">

                                                                                <span className="dt-option">
                                                                                    <a className="c-def dark-font">요청옵션 : </a>
                                                                                    {(() => {
                                                                                        const options = [];
                                                                                        if (cData.appReqDTO?.tagRemove) options.push('택제거');
                                                                                        if (cData.appReqDTO?.shoesBoxRemove) options.push('신발박스제거');
                                                                                        if (cData.appReqDTO?.hangerRemove) options.push('옷걸이제거');
                                                                                        if (cData.appReqDTO?.compressionPack) options.push('압축팩서비스');
                                                                                        if (cData.appReqDTO?.prodBoxRemove) options.push('부피 큰 제품박스만 제거');
                                                                                        if (cData.appReqDTO?.packingHold) options.push('요청 시까지 패킹보류');
                                                                                        if (cData.appReqDTO?.shipPriceDepositpay) options.push('해외배송비 자동 예치금결제');
                                                                                        if (cData.appReqDTO?.shipPriceMessenger) options.push('해외배송비 메신저안내');
                                                                                        if (cData.appReqDTO?.cusPrepayFl) options.push('관부가세선납');

                                                                                        return options.length > 0
                                                                                            ?
                                                                                            <a style={{color: "#EB939D"}}>&nbsp;{options.join(' / ')}&nbsp;</a>
                                                                                            : null;
                                                                                    })()}
                                                                                </span>

                                                                                <span className="dt-req display-flex align-items-start wd-100pc">
                                                                                    <a className="c-def dark-font" style={{flexShrink: 0}}>요청상세 :&nbsp;</a>
                                                                                    <a style={{
                                                                                        color: "#7C9EDC",
                                                                                        flex: 1,
                                                                                        minWidth: 0,
                                                                                        whiteSpace: "pre-wrap",
                                                                                        wordBreak: "break-word",
                                                                                        overflowWrap: "anywhere",
                                                                                        lineHeight: "20px",
                                                                                    }}>&nbsp;{cData.appReqDTO?.detailReq}
                                                                                    </a>
                                                                                </span>

                                                                                <span
                                                                                    className="dt-memo mt-1 display-flex align-items-center">
                                                                                    <a className="c-def dark-font">배송료메모:&nbsp;</a>
                                                                                    <input
                                                                                        className="admin-common-input"
                                                                                        type="text" maxLength={500}
                                                                                        onKeyDown={(e) => onKeyPress(e, cData.seqNum, 'appOrderMemoDTO')}
                                                                                        value={memoModiData[`${cData.seqNum}-appOrderMemoDTO`] ?? cData?.appOrderMemoDTO?.ordDtCont ?? ''}
                                                                                        onChange={(e) => handleInputMemoChange(e, cData.seqNum, 'appOrderMemoDTO')}
                                                                                        ref={(el) => (inputRefs.current[cData.seqNum] = el)}/>
                                                                                </span>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                )
                                                                :
                                                                null
                                                    })}
                                                    {/*
                                                      * 아래로 스크롤하면 이 줄이 보이는 순간 다음 배치를 붙인다.
                                                      * (전체선택/엑셀은 화면에 그려진 행수와 무관하게 조회된 전건을 대상으로 한다)
                                                      */}
                                                    {hasRowsBelow && (
                                                        <tbody key="vs-sentinel-bottom" className="vs-sentinel-group">
                                                        <tr ref={vsBottomSentinelRef}>
                                                            <td colSpan={12}>
                                                                <div className="vs-sentinel">
                                                                    <span className="vs-dot"/>
                                                                    <span className="vs-dot"/>
                                                                    <span className="vs-dot"/>
                                                                    <em>{winEnd.toLocaleString()} / {pageRowCount.toLocaleString()}건</em>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    )}
                                                </Table>
                                            </div>
                                            <div style={{
                                                minHeight: "50px",
                                                display: "flex",
                                                alignItems: "center",
                                                marginLeft: "10px"
                                            }}>
                                                {selectedProcessSt === "PS3" ?
                                                    <div style={{display: "flex", alignItems: "center"}}>
                                                        <button onClick={openDsReturnSt}
                                                                className="admin-btn-B wd-75 ht-30 font-s-12 btn-click-event m-r-7"
                                                                disabled={isLoading}>국내반송
                                                        </button>
                                                        <button onClick={openOsReturnSt}
                                                                className="admin-btn-B wd-75 ht-30 font-s-12 btn-click-event m-r-7">해외반송
                                                        </button>
                                                        <button
                                                            className="admin-btn-B wd-75 ht-30 font-s-12 btn-click-event m-r-7"
                                                            onClick={(e) => openDeliveryCancelSt()}>출고취소
                                                        </button>
                                                    </div>
                                                    :
                                                    null
                                                }
                                                {selectedProcessSt === "PS0" ?
                                                    <div className="display-flex align-center gap10">
                                                        <button onClick={openPayinfoDepositPaySt}
                                                                className="admin-btn-B wd-90 ht-30 font-s-13 btn-click-event">예치금결제
                                                        </button>
                                                        <button onClick={openPayinfoPointPaySt}
                                                                className="admin-btn-B wd-90 ht-30 font-s-13 btn-click-event">적립금결제
                                                        </button>
                                                    </div>
                                                    :
                                                    selectedProcessSt === "OS01" || selectedProcessSt === "OS02" || selectedProcessSt === "OS03" ||
                                                    selectedProcessSt === "OS04" || selectedProcessSt === "OS05" || selectedProcessSt === "OS06" ?
                                                        <div style={{display: "flex", alignItems: "center"}}>
                                                            <button onClick={openOrderdtDepositPaySt}
                                                                    className="orderSaveBt user-center" style={{
                                                                width: "80px",
                                                                height: "30px",
                                                                textAlign: "center",
                                                                borderColor: "lightgray"
                                                            }}><span style={{fontSize: "12px"}}>예치금결제</span>
                                                            </button>
                                                            <button onClick={openOrderdtPointPaySt}
                                                                    className="orderSaveBt user-center" style={{
                                                                width: "80px",
                                                                height: "30px",
                                                                textAlign: "center",
                                                                marginLeft: "5px",
                                                                borderColor: "lightgray"
                                                            }}><span style={{fontSize: "12px"}}>적립금결제</span>
                                                            </button>
                                                        </div>
                                                        :
                                                        null
                                                }
                                            </div>
                                        </div>

                                    </Tab>
                                    <Tab className="tab-temp" eventKey="tab-temp" title="예비Tab">

                                    </Tab>
                                </Tabs>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
            <TopBtn/>
            {deliveryDetailSt ?
                <DeliveryPriceDetail deliveryDetailSt={deliveryDetailSt} deliveryDetailFalseFn={deliveryDetailFalseFn}
                                     paySeqnum={paySeqnum} updateAppRecinfo={updateAppRecinfo}
                                     updatePayinfoList={updatePayinfoList} pathComponent={pathComponent}/>
                :
                allCartProdStChangeShow ?
                    <MsgSelectModal allCartProdStChangeShow={allCartProdStChangeShow}
                                    closeAllCartProdStChangeShow={closeAllCartProdStChangeShow}
                                    allProdStChangeMsg1={allProdStChangeMsg1} allProdStChangeMsg2={allProdStChangeMsg2}
                                    modifyProdSt={modifyProdSt}
                                    selectedAllCartProdSt={selectedAllCartProdSt} selectedItems={selectedItems}
                                    selectedCdataIndex={selectedCdataIndex} selectedFormTy={selectedFormTy}/>
                    :
                    allCartProdStNonSeqnumShow ?
                        <MsgConfirmModal allCartProdStNonSeqnumShow={allCartProdStNonSeqnumShow}
                                         closeAllCartProdStNonSeqNumModalShow={closeAllCartProdStNonSeqNumModalShow}
                                         allProdStNonSeqnumMsg={allProdStNonSeqnumMsg}/>
                        :
                        allOrderProdStChangeShow ?
                            <MsgSelectModal allOrderProdStChangeShow={allOrderProdStChangeShow}
                                            closeAllOrderProdStChangeShow={closeAllOrderProdStChangeShow}
                                            allProdStChangeMsg1={allProdStChangeMsg1}
                                            allProdStChangeMsg2={allProdStChangeMsg2} modifyProdSt={modifyProdSt}
                                            selectedAllOrderProdSt={selectedAllOrderProdSt}
                                            selectedItems={selectedItems} selectedCdataIndex={selectedCdataIndex}
                                            selectedFormTy={selectedFormTy}/>
                            :
                            allOrderProdStNonSeqnumShow ?
                                <MsgConfirmModal allOrderProdStNonSeqnumShow={allOrderProdStNonSeqnumShow}
                                                 closeAllOrderProdStNonSeqNumModalShow={closeAllOrderProdStNonSeqNumModalShow}
                                                 allProdStNonSeqnumMsg={allProdStNonSeqnumMsg}/>
                                :
                                allOfflineProdStChangeShow ?
                                    <MsgSelectModal allOfflineProdStChangeShow={allOfflineProdStChangeShow}
                                                    closeAllOfflineProdStChangeShow={closeAllOfflineProdStChangeShow}
                                                    allProdStChangeMsg1={allProdStChangeMsg1}
                                                    allProdStChangeMsg2={allProdStChangeMsg2}
                                                    modifyProdSt={modifyProdSt}
                                                    selectedAllOfflineProdSt={selectedAllOfflineProdSt}
                                                    selectedItems={selectedItems}
                                                    selectedCdataIndex={selectedCdataIndex}
                                                    selectedFormTy={selectedFormTy}/>
                                    :
                                    allOfflineProdStNonSeqnumShow ?
                                        <MsgConfirmModal allOfflineProdStNonSeqnumShow={allOfflineProdStNonSeqnumShow}
                                                         closeAllOfflineProdStNonSeqNumModalShow={closeAllOfflineProdStNonSeqNumModalShow}
                                                         allProdStNonSeqnumMsg={allProdStNonSeqnumMsg}/>
                                        :
                                        allTransferProdStChangeShow ?
                                            <MsgSelectModal allTransferProdStChangeShow={allTransferProdStChangeShow}
                                                            closeAllTransferProdStChangeShow={closeAllTransferProdStChangeShow}
                                                            allProdStChangeMsg1={allProdStChangeMsg1}
                                                            allProdStChangeMsg2={allProdStChangeMsg2}
                                                            modifyProdSt={modifyProdSt}
                                                            selectedAllTransferProdSt={selectedAllTransferProdSt}
                                                            selectedItems={selectedItems}
                                                            selectedCdataIndex={selectedCdataIndex}
                                                            selectedFormTy={selectedFormTy}/>
                                            :
                                            allTransferProdStNonSeqnumShow ?
                                                <MsgConfirmModal
                                                    allTransferProdStNonSeqnumShow={allTransferProdStNonSeqnumShow}
                                                    closeAllTransferProdStNonSeqNumModalShow={closeAllTransferProdStNonSeqNumModalShow}
                                                    allProdStNonSeqnumMsg={allProdStNonSeqnumMsg}/>
                                                :
                                                allDomesticProdStChangeShow ?
                                                    <MsgSelectModal
                                                        allDomesticProdStChangeShow={allDomesticProdStChangeShow}
                                                        closeAllDomesticProdStChangeShow={closeAllDomesticProdStChangeShow}
                                                        allProdStChangeMsg1={allProdStChangeMsg1}
                                                        allProdStChangeMsg2={allProdStChangeMsg2}
                                                        modifyProdSt={modifyProdSt}
                                                        selectedAllDomesticProdSt={selectedAllDomesticProdSt}
                                                        selectedItems={selectedItems}
                                                        selectedCdataIndex={selectedCdataIndex}
                                                        selectedFormTy={selectedFormTy}/>
                                                    :
                                                    allDomesticProdStNonSeqnumShow ?
                                                        <MsgConfirmModal
                                                            allDomesticProdStNonSeqnumShow={allDomesticProdStNonSeqnumShow}
                                                            closeAllDomesticProdStNonSeqNumModalShow={closeAllDomesticProdStNonSeqNumModalShow}
                                                            allProdStNonSeqnumMsg={allProdStNonSeqnumMsg}/>
                                                        :
                                                        allDeliveryProdStChangeShow ?
                                                            <MsgSelectModal
                                                                allDeliveryProdStChangeShow={allDeliveryProdStChangeShow}
                                                                closeAllDeliveryProdStChangeShow={closeAllDeliveryProdStChangeShow}
                                                                allProdStChangeMsg1={allProdStChangeMsg1}
                                                                allProdStChangeMsg2={allProdStChangeMsg2}
                                                                modifyProdSt={modifyProdSt}
                                                                selectedAllDeliveryProdSt={selectedAllDeliveryProdSt}
                                                                selectedItems={selectedItems}
                                                                selectedCdataIndex={selectedCdataIndex}
                                                                selectedFormTy={selectedFormTy}/>
                                                            :
                                                            allDeliveryProdStNonSeqnumShow ?
                                                                <MsgConfirmModal
                                                                    allDeliveryProdStNonSeqnumShow={allDeliveryProdStNonSeqnumShow}
                                                                    closeAllDeliveryProdStNonSeqNumModalShow={closeAllDeliveryProdStNonSeqNumModalShow}
                                                                    allProdStNonSeqnumMsg={allProdStNonSeqnumMsg}/>
                                                                :
                                                                dontTrackingShipcoSt ?
                                                                    <MsgCheckModal
                                                                        dontTrackingShipcoSt={dontTrackingShipcoSt}
                                                                        closeDontTrackingShipco={closeDontTrackingShipco}/>
                                                                    :
                                                                    // 관리자 예치금or포인트 결제팝업
                                                                    orderdtDepositPaySt ?
                                                                        <MsgSelectModal
                                                                            orderdtDepositPaySt={orderdtDepositPaySt}
                                                                            closeOrderdtDepositPaySt={closeOrderdtDepositPaySt}
                                                                            orderdtDepositPayMsg1={orderdtDepositPayMsg1}
                                                                            orderdtDepositPayMsg2={orderdtDepositPayMsg2}
                                                                            orderdtAdminDpPay={orderdtAdminDpPay}/>
                                                                        :
                                                                        orderdtPointPaySt ?
                                                                            <MsgSelectModal
                                                                                orderdtPointPaySt={orderdtPointPaySt}
                                                                                closeOrderdtPointPaySt={closeOrderdtPointPaySt}
                                                                                orderdtPointPayMsg1={orderdtPointPayMsg1}
                                                                                orderdtPointPayMsg2={orderdtPointPayMsg2}
                                                                                orderdtAdminDpPay={orderdtAdminDpPay}
                                                                            />
                                                                            :
                                                                            payinfoDepositPaySt ?
                                                                                <MsgSelectModal
                                                                                    payinfoDepositPaySt={payinfoDepositPaySt}
                                                                                    closePayinfoDepositPaySt={closePayinfoDepositPaySt}
                                                                                    payinfoDepositPayMsg1={payinfoDepositPayMsg1}
                                                                                    payinfoDepositPayMsg2={payinfoDepositPayMsg2}
                                                                                    payinfoAdminDpPay={payinfoAdminDpPay}
                                                                                />
                                                                                :
                                                                                payinfoPointPaySt ?
                                                                                    <MsgSelectModal
                                                                                        payinfoPointPaySt={payinfoPointPaySt}
                                                                                        closePayinfoPointPaySt={closePayinfoPointPaySt}
                                                                                        payinfoPointPayMsg1={payinfoPointPayMsg1}
                                                                                        payinfoPointPayMsg2={payinfoPointPayMsg2}
                                                                                        payinfoAdminDpPay={payinfoAdminDpPay}
                                                                                    />
                                                                                    :
                                                                                    dpPayNullSt ?
                                                                                        <MsgCheckModal
                                                                                            dpPayNullSt={dpPayNullSt}
                                                                                            closeDpPayNullSt={closeDpPayNullSt}/>
                                                                                        :
                                                                                        // 관리자 해외/국내반송 팝업
                                                                                        adminOsReturnSt ?
                                                                                            <MsgSelectModal
                                                                                                adminOsReturnSt={adminOsReturnSt}
                                                                                                closeOsReturnSt={closeOsReturnSt}
                                                                                                osReturnMsg1={osReturnMsg1}
                                                                                                osReturnMsg2={osReturnMsg2}
                                                                                                deliveryReturn={deliveryReturn}
                                                                                            />
                                                                                            :
                                                                                            adminDsReturnSt ?
                                                                                                <MsgSelectModal
                                                                                                    adminDsReturnSt={adminDsReturnSt}
                                                                                                    closeDsReturnSt={closeDsReturnSt}
                                                                                                    dsReturnMsg1={dsReturnMsg1}
                                                                                                    dsReturnMsg2={dsReturnMsg2}
                                                                                                    deliveryReturn={deliveryReturn}
                                                                                                />
                                                                                                :
                                                                                                adminDeliveryCancelSt ?
                                                                                                    <MsgSelectModal
                                                                                                        adminDeliveryCancelSt={adminDeliveryCancelSt}
                                                                                                        closeDeliveryCancelSt={closeDeliveryCancelSt}
                                                                                                        dvCancelMsg1={dvCancelMsg1}
                                                                                                        dvCancelMsg2={dvCancelMsg2}
                                                                                                        deliveryCancel={deliveryCancel}
                                                                                                    />
                                                                                                    :
                                                                                                    returnNullSt ?
                                                                                                        <MsgCheckModal
                                                                                                            returnNullSt={returnNullSt}
                                                                                                            closeReturnNullSt={closeReturnNullSt}/>
                                                                                                        :
                                                                                                        saveMsgSt ?
                                                                                                            <SaveMsgModal
                                                                                                                message={savePopupMsg}/>
                                                                                                            :
                                                                                                            payinfoSelectOrderErrSt ?
                                                                                                                <MsgCheckModal
                                                                                                                    payinfoSelectOrderErrSt={payinfoSelectOrderErrSt}
                                                                                                                    payinfoSelectOrderErrMsg={payinfoSelectOrderErrMsg}
                                                                                                                    closePayinfoSelectOrderErr={closePayinfoSelectOrderErr}/>
                                                                                                                :
                                                                                                                modifyOneValueSt ?
                                                                                                                    <AdminChangeValuePopup
                                                                                                                        modifyOneValueSeqNum={modifyOneValueSeqNum}
                                                                                                                        beforeOneValue={beforeOneValue}
                                                                                                                        modifyOneValueType={modifyOneValueType}
                                                                                                                        modifyTrackNum={modifyTrackNum}
                                                                                                                        closeModifyPopup={closeModifyPopup}/>
                                                                                                                    :
                                                                                                                    isEmptyOrderData ?
                                                                                                                        <MsgCheckModal
                                                                                                                            isEmptyOrderData={isEmptyOrderData}
                                                                                                                            closeIsEmptyOrderData={closeIsEmptyOrderData}/>
                                                                                                                        :
                                                                                                                        null
            }
            {isLoading && <CommonLoading/>}
            {/* 엑셀[주문서] 생성중 로딩. 기존 isLoading(국내반송 등)과 섞이면 다른 버튼의
                disabled 조건까지 바뀌므로 별도 상태로 둔다 */}
            {excelLoading && <CommonLoading/>}
            {alertShow3 === true ? <MsgSelectModal alertShow={alertShow3} eventHandle1={modalCancel3}
                                                   eventHandle2={() => expRegDelete(selectedData)}
                                                   msgData1={msgConfirmData5} msgData2={msgConfirmData6}/> : null}
            {alertShow4 === true ? <MsgSelectModal alertShow={alertShow4} eventHandle1={modalCancel4}
                                                   eventHandle2={() => ordOutCancel(selectedData)}
                                                   msgData1={msgConfirmData7} msgData2={msgConfirmData8}/> : null}
        </div>
    );
}

export default AdminDashBoardPg
